/*!
 * accounting.js v0.4.1
 * Copyright 2014 Open Exchange Rates
 *
 * Freely distributable under the MIT license.
 * Portions of accounting.js are inspired or borrowed from underscore.js
 *
 * Full details and documentation:
 * http://openexchangerates.github.io/accounting.js/
 */

(function (root, undefined) {

  /* --- Setup --- */

  // Create the local library object, to be exported or referenced globally later
  var lib = {};

  // Current version
  lib.version = '0.4.1';


  /* --- Exposed settings --- */

  // The library's settings configuration object. Contains default parameters for
  // currency and number formatting
  lib.settings = {
    currency: {
      symbol: "$",		// default currency symbol is '$'
      format: "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
      decimal: ".",		// decimal point separator
      thousand: ",",		// thousands separator
      precision: 2,		// decimal places
      grouping: 3		// digit grouping (not implemented yet)
    },
    number: {
      precision: 0,		// default precision on numbers is 0
      grouping: 3,		// digit grouping (not implemented yet)
      thousand: ",",
      decimal: "."
    }
  };


  /* --- Internal Helper Methods --- */

  // Store reference to possibly-available ECMAScript 5 methods for later
  var nativeMap = Array.prototype.map,
    nativeIsArray = Array.isArray,
    toString = Object.prototype.toString;

  /**
   * Tests whether supplied parameter is a string
   * from underscore.js
   */
  function isString(obj) {
    return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
  }

  /**
   * Tests whether supplied parameter is a string
   * from underscore.js, delegates to ECMA5's native Array.isArray
   */
  function isArray(obj) {
    return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
  }

  /**
   * Tests whether supplied parameter is a true object
   */
  function isObject(obj) {
    return obj && toString.call(obj) === '[object Object]';
  }

  /**
   * Extends an object with a defaults object, similar to underscore's _.defaults
   *
   * Used for abstracting parameter handling from API methods
   */
  function defaults(object, defs) {
    var key;
    object = object || {};
    defs = defs || {};
    // Iterate over object non-prototype properties:
    for (key in defs) {
      if (defs.hasOwnProperty(key)) {
        // Replace values with defaults only if undefined (allow empty/zero values):
        if (object[key] == null) object[key] = defs[key];
      }
    }
    return object;
  }

  /**
   * Implementation of `Array.map()` for iteration loops
   *
   * Returns a new Array as a result of calling `iterator` on each array value.
   * Defers to native Array.map if available
   */
  function map(obj, iterator, context) {
    var results = [], i, j;

    if (!obj) return results;

    // Use native .map method if it exists:
    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);

    // Fallback for native .map:
    for (i = 0, j = obj.length; i < j; i++) {
      results[i] = iterator.call(context, obj[i], i, obj);
    }
    return results;
  }

  /**
   * Check and normalise the value of precision (must be positive integer)
   */
  function checkPrecision(val, base) {
    val = Math.round(Math.abs(val));
    return isNaN(val) ? base : val;
  }


  /**
   * Parses a format string or object and returns format obj for use in rendering
   *
   * `format` is either a string with the default (positive) format, or object
   * containing `pos` (required), `neg` and `zero` values (or a function returning
   * either a string or object)
   *
   * Either string or format.pos must contain "%v" (value) to be valid
   */
  function checkCurrencyFormat(format) {
    var defaults = lib.settings.currency.format;

    // Allow function as format parameter (should return string or object):
    if (typeof format === "function") format = format();

    // Format can be a string, in which case `value` ("%v") must be present:
    if (isString(format) && format.match("%v")) {

      // Create and return positive, negative and zero formats:
      return {
        pos: format,
        neg: format.replace("-", "").replace("%v", "-%v"),
        zero: format
      };

      // If no format, or object is missing valid positive value, use defaults:
    } else if (!format || !format.pos || !format.pos.match("%v")) {

      // If defaults is a string, casts it to an object for faster checking next time:
      return (!isString(defaults)) ? defaults : lib.settings.currency.format = {
        pos: defaults,
        neg: defaults.replace("%v", "-%v"),
        zero: defaults
      };

    }
    // Otherwise, assume format was fine:
    return format;
  }


  /* --- API Methods --- */

  /**
   * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
   * Alias: `accounting.parse(string)`
   *
   * Decimal must be included in the regular expression to match floats (defaults to
   * accounting.settings.number.decimal), so if the number uses a non-standard decimal
   * separator, provide it as the second argument.
   *
   * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
   *
   * Doesn't throw any errors (`NaN`s become 0) but this may change in future
   */
  var unformat = lib.unformat = lib.parse = function (value, decimal) {
    // Recursively unformat arrays:
    if (isArray(value)) {
      return map(value, function (val) {
        return unformat(val, decimal);
      });
    }

    // Fails silently (need decent errors):
    value = value || 0;

    // Return the value as-is if it's already a number:
    if (typeof value === "number") return value;

    // Default decimal point comes from settings, but could be set to eg. "," in opts:
    decimal = decimal || lib.settings.number.decimal;

    // Build regex to strip out everything except digits, decimal point and minus sign:
    var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
      unformatted = parseFloat(
        ("" + value)
          .replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
          .replace(regex, '')         // strip out any cruft
          .replace(decimal, '.')      // make sure decimal point is standard
      );

    // This will fail silently which may cause trouble, let's wait and see:
    return !isNaN(unformatted) ? unformatted : 0;
  };


  /**
   * Implementation of toFixed() that treats floats more like decimals
   *
   * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
   * problems for accounting- and finance-related software.
   */
  var toFixed = lib.toFixed = function (value, precision) {
    precision = checkPrecision(precision, lib.settings.number.precision);
    var power = Math.pow(10, precision);

    // Multiply up by precision, round accurately, then divide and use native toFixed():
    return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
  };


  /**
   * Format a number, with comma-separated thousands and custom precision/decimal places
   * Alias: `accounting.format()`
   *
   * Localise by overriding the precision and thousand / decimal separators
   * 2nd parameter `precision` can be an object matching `settings.number`
   */
  var formatNumber = lib.formatNumber = lib.format = function (number, precision, thousand, decimal) {
    // Resursively format arrays:
    if (isArray(number)) {
      return map(number, function (val) {
        return formatNumber(val, precision, thousand, decimal);
      });
    }

    // Clean up number:
    number = unformat(number);

    // Build options object from second param (if object) or all params, extending defaults:
    var opts = defaults(
        (isObject(precision) ? precision : {
          precision: precision,
          thousand: thousand,
          decimal: decimal
        }),
        lib.settings.number
      ),

      // Clean up precision
      usePrecision = checkPrecision(opts.precision),

      // Do some calc:
      negative = number < 0 ? "-" : "",
      base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
      mod = base.length > 3 ? base.length % 3 : 0;

    // Format the number:
    return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
  };


  /**
   * Format a number into currency
   *
   * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
   * defaults: (0, "$", 2, ",", ".", "%s%v")
   *
   * Localise by overriding the symbol, precision, thousand / decimal separators and format
   * Second param can be an object matching `settings.currency` which is the easiest way.
   *
   * To do: tidy up the parameters
   */
  var formatMoney = lib.formatMoney = function (number, symbol, precision, thousand, decimal, format) {
    // Resursively format arrays:
    if (isArray(number)) {
      return map(number, function (val) {
        return formatMoney(val, symbol, precision, thousand, decimal, format);
      });
    }

    // Clean up number:
    number = unformat(number);

    // Build options object from second param (if object) or all params, extending defaults:
    var opts = defaults(
        (isObject(symbol) ? symbol : {
          symbol: symbol,
          precision: precision,
          thousand: thousand,
          decimal: decimal,
          format: format
        }),
        lib.settings.currency
      ),

      // Check format (returns object with pos, neg and zero):
      formats = checkCurrencyFormat(opts.format),

      // Choose which format to use for this value:
      useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;

    // Return with currency symbol added:
    return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
  };


  /**
   * Format a list of numbers into an accounting column, padding with whitespace
   * to line up currency symbols, thousand separators and decimals places
   *
   * List should be an array of numbers
   * Second parameter can be an object containing keys that match the params
   *
   * Returns array of accouting-formatted number strings of same length
   *
   * NB: `white-space:pre` CSS rule is required on the list container to prevent
   * browsers from collapsing the whitespace in the output strings.
   */
  lib.formatColumn = function (list, symbol, precision, thousand, decimal, format) {
    if (!list) return [];

    // Build options object from second param (if object) or all params, extending defaults:
    var opts = defaults(
        (isObject(symbol) ? symbol : {
          symbol: symbol,
          precision: precision,
          thousand: thousand,
          decimal: decimal,
          format: format
        }),
        lib.settings.currency
      ),

      // Check format (returns object with pos, neg and zero), only need pos for now:
      formats = checkCurrencyFormat(opts.format),

      // Whether to pad at start of string or after currency symbol:
      padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,

      // Store value for the length of the longest string in the column:
      maxLength = 0,

      // Format the list according to options, store the length of the longest string:
      formatted = map(list, function (val, i) {
        if (isArray(val)) {
          // Recursively format columns if list is a multi-dimensional array:
          return lib.formatColumn(val, opts);
        } else {
          // Clean up the value
          val = unformat(val);

          // Choose which format to use for this value (pos, neg or zero):
          var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,

            // Format this value, push into formatted list and save the length:
            fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));

          if (fVal.length > maxLength) maxLength = fVal.length;
          return fVal;
        }
      });

    // Pad each number in the list and send back the column of numbers:
    return map(formatted, function (val, i) {
      // Only if this is a string (not a nested array, which would have already been padded):
      if (isString(val) && val.length < maxLength) {
        // Depending on symbol position, pad after symbol or at index 0:
        return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + (new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
      }
      return val;
    });
  };


  /* --- Module Definition --- */

  // Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
  // Otherwise, just add `accounting` to the global object
  if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = lib;
    }
    exports.accounting = lib;
  } else if (typeof define === 'function' && define.amd) {
    // Return the library as an AMD module:
    define([], function () {
      return lib;
    });
  } else {
    // Use accounting.noConflict to restore `accounting` back to its original value.
    // Returns a reference to the library's `accounting` object;
    // e.g. `var numbers = accounting.noConflict();`
    lib.noConflict = (function (oldAccounting) {
      return function () {
        // Reset the value of the root's `accounting` variable:
        root.accounting = oldAccounting;
        // Delete the noConflict method:
        lib.noConflict = undefined;
        // Return reference to the library to re-assign it:
        return lib;
      };
    })(root.accounting);

    // Declare `fx` on the root (global/window) object:
    root['accounting'] = lib;
  }

  // Root will be `window` in browser or `global` on the server:
}(this));
;
(function() {
  // Amilia Widgets - Backbone, Backgrid and Bootstrap 2.3.
  // Used in Taxes and Account modules for now. To be used in new modules.
  // Assumes files from appLibs grunt task are loaded.
  // Works in conjunction with amilia-widgets.less.


  // Subclass Backgrid classes and put them under Backgrid.Amilia.
  Backgrid.Amilia = {};

  // Subclass the Backbone model to save changes to the server.
  Backgrid.Amilia.Model = Backbone.Model.extend({
    initialize: function() {
      Backbone.Model.prototype.initialize.apply(this, arguments);
      this.on('change', function(model, options) {
        if (options && (options.xhr || options.save === false)) return;
        model.save(null, { wait: true })
          .fail(function(xhr, textStatus, errorThrown) {
            alert(errorThrown);
          });
      });
    }
  });

  Backbone.alphaNumericComparator = function(propertyName, reverse) {
    var reA = /^[^a-zA-Z]$/g;
    var reN = /^[^0-9]$/g;

    return function(a, b) {
      var aA = a.get(propertyName).replace(reA, '').toLowerCase();
      var bA = b.get(propertyName).replace(reA, '').toLowerCase();

      if (aA === bA) {
        var aN = parseInt(a.get(propertyName).replace(reN, '').toLowerCase(), 10);
        var bN = parseInt(b.get(propertyName).replace(reN, '').toLowerCase(), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      }

      if (reverse) {
        return aA < bA ? 1 : -1;
      }

      return aA > bA ? 1 : -1;
    };
  };

  Backbone.DescendingComparator = function(propertyName) {
    return function(obj1, obj2) {
      if (obj1.get(propertyName) > obj2.get(propertyName)) return -1; // before
      if (obj2.get(propertyName) > obj1.get(propertyName)) return 1; // after
      return 0; // equal
    };
  };

  // Subclass the Backbone model to keep the model and its state (errors)
  // sent back by the server. Creates a new errorModel property holding
  // a Backbone model with errors, mapped to the model attributes.
  // Handles one-level nesting of object errors potentially returned
  // by ModelState error dictionnaries.
  // In the case of an attribute representing a nested collection,
  // use method bindNestedCollection to keep the model and collection in sync.
  // It will properly maintain their error models as well.
  Backbone.ModelWithState = Backbone.Model.extend({
    errorModel: undefined,

    constructor: function(attributes, options) {
      Backbone.Model.apply(this, arguments);
      options || (options = {});
      this.errorModel = options.errorModel || new Backbone.Model();
      this.on('error', this.onSaveError, this);
      this._nestedCollections = [];
    },
    bindNestedCollection: function(attribute, collection) {
      var model = this;
      model._nestedCollections.push({
        attribute: attribute,
        collection: collection
      });

      collection.on('add remove change reset', function() {
        model.set(attribute, collection.toJSON());
      });
    },
    save: function(key, val, options) {
      if (key === undefined) key = null;
      if (key == null || typeof key === 'object') options = val;
      options || (options = {});

      this.errorModel.clear();

      var model = this;
      _.each(this._nestedCollections, function(item) {
        item.collection.each(function(model) {
          if (model.errorModel) model.errorModel.clear();
        });
        model.set(item.attribute, item.collection.toJSON());
      });

      var error = options.error;
      options.error = function(model, resp, options) {
        if (resp && resp.responseJSON && _.isObject(resp.responseJSON))
          model.errorModel.set(Backbone.parseModelState(resp.responseJSON));
        if (error) error(model, resp, options);
      };

      if (key == null || typeof key === 'object')
        return Backbone.Model.prototype.save.call(this, key, options);
      else
        return Backbone.Model.prototype.save.call(this, key, val, options);
    },
    onSaveError: function() {
      var model = this;
      _.each(this._nestedCollections, function(item) {
        Backbone.injectNestedArrayErrors(model, item.attribute, item.collection);
      });
    }
  });

  // Parses a ModelState error response looking for nested errors in order to
  // correctly construct the mapping. For example if we find attribute "Email.From",
  // we will construct attribute "Email" as an object with its nested attribute "From".
  Backbone.parseModelState = function(response) {
    var re = new RegExp('^([A-Za-z0-9_]+)\\.([A-Za-z0-9_]+)$'),
        result = {};
    _.each(response, function(error, name) {
      var match = name.match(re);
      if (match && match.length == 3) {
        var key = match[1],
            nested = match[2];
        if (!_.isObject(result[key])) result[key] = {};
        result[key][nested] = error;
      } else {
        result[name] = error;
      }
    });
    return result;
  };

  // Injects nested array errors returned from the ModelState into a collection.
  // For example attribute name "Codes[0]"" means there is an error in the code
  // collection's first model.
  Backbone.injectNestedArrayErrors = function(model, attrName, collection) {
    var re = new RegExp('^' + attrName + '\\[([0-9]+)\\]\\.([a-zA-Z_]+)$');
    _.each(model.errorModel.attributes, function(error, name) {
      var match = name.match(re);
      if (match && match.length == 3) {
        var index = parseInt(match[1], 10),
            key = match[2];
        if (index < collection.models.length)
          collection.models[index].errorModel.set(key, error);
      }
    });
  };


  // Subclass basic cells to ensure the column name is added as a class
  // name of the element. Also to display an error by looking at model
  // attribute Errors.
  _.each(['StringCell', 'NumberCell', 'IntegerCell', 'SelectCell', 'DateCell'], function(cellName) {
    Backgrid.Amilia[cellName] = Backgrid[cellName].extend({
      initialize: function() {
        Backgrid[cellName].prototype.initialize.apply(this, arguments);
        this.listenTo(this.model.errorModel instanceof Backbone.Model ? this.model.errorModel : this.model, 'change', this.updateInvalid);
      },
      render: function() {
        Backgrid[cellName].prototype.render.apply(this, arguments);
        var column = this.column;
        this.$el.addClass(column.get('name'));
        this.updateInvalid();
        return this;
      },
      updateInvalid: function() {
        var model = this.model,
            columnName = this.column.get('name'),
            errors = model.errorModel instanceof Backbone.Model ? model.errorModel.toJSON() : model.get('Errors'),
            error = errors && errors[columnName] ?
                    _.isArray(errors[columnName]) ? errors[columnName].join(' ') : errors[columnName] :
                    null;

        if (error)
          this.$el.addClass('invalid').attr('title', error);
        else
          this.$el.removeClass('invalid').removeAttr('title');
        return this;
      }
    });
  });

  // Subclass Backgrid cell to show a checkmark. Casts the value to a boolean.
  // If an array, will place a checkmark if not empty.
  Backgrid.Amilia.HasCell = Backgrid.Cell.extend({
    formatter: {
      fromRaw: function(rawData, model) {
        if (_.isArray(rawData)) return !!rawData.length;
        return !!rawData;
      }
    },
    initialize: function() {
      Backgrid.Cell.prototype.initialize.apply(this, arguments);
      this.listenTo(this.model.errorModel instanceof Backbone.Model ? this.model.errorModel : this.model, 'change', this.updateInvalid);
    },
    render: function() {
      this.$el.empty();
      var columnName = this.column.get('name'),
          check = this.formatter.fromRaw(this.model.get(columnName), this.model);
      if (check) this.$el.html('<i class="fa fa-check"></i>').addClass(columnName);
      this.delegateEvents();
      this.updateInvalid();
      return this;
    },
    updateInvalid: Backgrid.Amilia.StringCell.prototype.updateInvalid
  });

  // Subclass HasCell cell to show Yes or No.
  Backgrid.Amilia.YesNoCell = Backgrid.Amilia.HasCell.extend({
    render: function() {
      this.$el.empty();
      var columnName = this.column.get('name'),
          check = this.formatter.fromRaw(this.model.get(columnName), this.model);
      this.$el.html(check ? AMILIA_APP.Labels.Yes : AMILIA_APP.Labels.No).addClass(columnName);
      this.delegateEvents();
      this.updateInvalid();
      return this;
    }
  });

  // Subclass Backgrid UriCell to allow displaying different text in URL,
  // the the URL itself. Extend and set displayAttribute to the model
  // attribute to display as URL text.
  Backgrid.Amilia.UriCell = Backgrid.UriCell.extend({
    initialize: function(options) {
      Backgrid.UriCell.prototype.initialize.apply(this, arguments);
      this.displayAttribute = options.displayAttribute || this.displayAttribute;
    },
    target: null,
    render: function() {
      this.$el.empty();

      var columnName = this.column.get('name'),
          url = this.model.get(columnName),
          name = this.displayAttribute ? this.model.get(this.displayAttribute) : null,
          text = name ? name : this.formatter.fromRaw(url, this.model);

      this.$el.append($('<a>', {
        tabIndex: -1,
        href: url,
        title: this.title || url,
        target: this.target
      })
        .text(name))
        .addClass(columnName);

      this.delegateEvents();

      return this;
    }
  });

  // Subclass BooleanCell to allow single click to toggle. Skips the
  // editor altogether. Warning: Prevents editable = false mode to work.
  // Source: https://github.com/wyuenho/backgrid/issues/166
  Backgrid.Amilia.BooleanCell = Backgrid.BooleanCell.extend({
    events: {
      "change input": function(e) {
        this.currentEditor = $();
        this.model.set(this.column.get('name'), e.target.checked);
        this.model.trigger('backgrid:edited', this.model, this.column, new Backgrid.Command(e));
      }
    }
  });

  Backgrid.Amilia.ImageCell = Backgrid.UriCell.extend({
    render: function() {
      this.$el.empty();
      var columnName = this.column.get('name'),
          rawValue = this.model.get(columnName),
          formattedValue = this.formatter.fromRaw(rawValue, this.model);
      this.$el.append($('<img>', {
        tabIndex: -1,
        src: rawValue,
        title: this.title || formattedValue,
        alt: formattedValue,
        target: this.target
      })).addClass(columnName);
      this.delegateEvents();
      return this;
    }
  });

  // Subclass the ObjectCell to display errors looking at model attribute
  // Errors matching the attributes defined in its schema. Subclass its editor
  // as well to display those errors in the form.
  Backgrid.Amilia.ObjectCellEditor = Backgrid.Extension.ObjectCellEditor.extend({
    postRender: function() {
      Backgrid.Extension.ObjectCellEditor.prototype.postRender.apply(this, arguments);
      this.updateInvalid();
      return this;
    },
    updateInvalid: function() {
      var errors = this.model.errorModel instanceof Backbone.Model ? this.model.errorModel.toJSON() : this.model.get('Errors');
      if (!errors) return this;

      var $form = this.$dialog.find('form'),
          columnName = this.column.get('name');

      _.each(errors, function(error, key) {
        var pieces = key.split('.');
        if (pieces.length != 2 || pieces[0] != columnName) return this;

        var attr = pieces[1],
            $input = $form.find('input[name="' + attr + '"]');
        if (!$input.length) return true;

        $input.closest('.control-group').addClass('error')
            .find('.controls').append('<span class="help-inline">' + error + '</span>');

        $input.one('focus', function(e) {
          $input.closest('.control-group').removeClass('error')
              .find('.help-inline').remove();
        });
      });

      return this;
    }
  });
  Backgrid.Amilia.ObjectCell = Backgrid.Extension.ObjectCell.extend({
    render: function() {
      Backgrid.Extension.ObjectCell.prototype.render.apply(this, arguments);
      this.updateInvalid();
      return this;
    },
    updateInvalid: function() {
      var model = this.model,
          columnName = this.column.get('name'),
          errors = model.errorModel instanceof Backbone.Model ? model.errorModel.toJSON() : model.get('Errors') || [],
          attrs = _.pluck(this.schema, 'name'),
          error = _.reduce(errors, function(result, error, attr) {
            if (_.indexOf(attrs, attr.replace(columnName + '.', '')) >= 0)
              result.push(_.isArray(error) ? error.join(' ') : error);
            return result;
          }, []).join(' ');

      if (error.length)
        this.$el.addClass('invalid').attr('title', error);
      else
        this.$el.removeClass('invalid').removeAttr('title');

      return this;
    },
    editor: Backgrid.Amilia.ObjectCellEditor
  });

  // Subclass ArrayObjectCell to display errors. Look at each object for attribute
  // Errors matching the attributes defined in columns. Also set its backgrid
  // class to Amilia's, in order to display errors.
  Backgrid.Amilia.ArrayObjectCell = Backgrid.Extension.ArrayObjectCell.extend({
    // Render a read-only mini-table layout in the cell.
    render: function() {
      this.$el.empty();
      var columns = this.gridOptions.columns,
          array = this.model.get(this.column.get('name')),
          $ul = $('<ul>');

      _.each(array, function(object) {
        var $li = $('<li>').appendTo($ul);
        _.each(columns, function(column) {
          var value = object[column.name];
          if (column.cell == Backgrid.Amilia.NumberCell && !_.isEmpty(value))
            value = _.sprintf('%.2f', value);
          $('<span>').appendTo($li)
              .addClass(column.name)
              .text(value ? value : '');
        });
      });
      this.$el.html($ul).addClass('children');

      this.delegateEvents();
      this.updateInvalid();
      return this;
    },
    updateInvalid: function() {
      if (!this.gridOptions || !this.gridOptions.columns) return this;
      var model = this.model,
          array = model.get(this.column.get('name')),
          error = _.reduce(array, function(result, object, index) {
            if (!_.isEmpty(object.Errors)) {
              _.each(object.Errors, function(error) {
                _.each(_.isArray(error) ? error : [error], function(error) {
                  if (_.indexOf(result, error) == -1) result.push(error);
                });
              });
            }
            return result;
          }, []).join(' ');

      if (error.length)
        this.$el.addClass('invalid').attr('title', error);
      else
        this.$el.removeClass('invalid').removeAttr('title');

      return this;
    },
    grid: Backgrid.Amilia.Grid
  });

  // Adapt the Object Cell editors to Bootstrap 2.3
  Backgrid.Extension.ObjectCellEditor.prototype.modalTemplate = _.template([
    '<div class="modal hide backgrid-object-cell">',
    '  <div class="modal-header">',
    '    <a type="button" class="close" aria-hidden="true">&times;</a>',
    '    <h3><%=title%></h3>',
    '  </div>',
    '  <div class="modal-body"></div>',
    '  <div class="modal-footer">',
    '    <a href="#" class="save btn btnSet3 btn-primary pull-right"><%=AMILIA_APP.Labels.Save%></a>',
    '    <a href="#" class="close btn btn-link pull-right"><%=AMILIA_APP.Labels.Cancel%></a>',
    '  </div>',
    '</div>'
  ].join('\n'));
  Backgrid.Extension.ObjectCellEditor.prototype.stringTemplate = _.template([
    '<div class="control-group">',
    '  <label class="control-label"><%=label%></label>',
    '  <div class="controls">',
    '    <input type="text" name="<%=name%>" value="<%=value%>" placeholder="<%=placeholder%>" />',
    '  </div>',
    '</div>'
  ].join('\n'));

  // Subclass HeaderCell to set the title of the header cell by looking
  // at the option title passed to the column. Also show the sort indicator
  // on hover, and allow passing HTML in the label.
  Backgrid.Amilia.HeaderCell = Backgrid.HeaderCell.extend({
    initialize: function() {
      Backgrid.HeaderCell.prototype.initialize.apply(this, arguments);
      if (this.column.has('title')) this.$el.attr('title', this.column.get('title'));
    },
    render: function() {
      this.$el.empty();
      var column = this.column;
      var sortable = Backgrid.callByNeed(column.sortable(), column, this.collection);
      var $label = $('<a>').html((column.editable() ? '<i class="fa fa-pencil"></i> ' : '') + column.get('label'));

      if (sortable)
        $label.append('<b class="sort-caret"></b>')
              .append('<b class="hover-up-caret"></b><b class="hover-down-caret"></b>');

      this.$el.append($label);
      this.$el.addClass(column.get('name'));
      this.$el.addClass(column.get('direction'));
      this.delegateEvents();
      return this;
    }
  });

  // Subclass HeaderCell to right-align header text
  Backgrid.Amilia.RightAlignedHeaderCell = Backgrid.Amilia.HeaderCell.extend({
    render: function() {
      Backgrid.HeaderCell.prototype.render.apply(this, arguments);
      this.$el.attr('style', 'text-align:right');
      return this;
    }
  });

  // Display the GMT time in a more readable format
  Backgrid.Amilia.GMTDateCell = Backgrid.DateCell.extend({
    render: function() {
      Backgrid.DateCell.prototype.render.apply(this, arguments);
      var date = new Date(this.model.get('DateCreated'));
      var dayOfMonth = date.getUTCDate() < 10 ? ('0' + date.getUTCDate()) : date.getUTCDate();
      var hours = date.getUTCHours() < 10 ? ('0' + date.getUTCHours()) : date.getUTCHours();
      var minutes = date.getUTCMinutes() < 10 ? ('0' + date.getUTCMinutes()) : date.getUTCMinutes();
      this.$el.html(dayOfMonth + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCFullYear() + ' ' + hours + ':' + minutes + ' GMT');
      return this;
    }
  });


  // Subclass Grid to add a title attribute to text overflowing
  // non-editable cells.
  Backgrid.Amilia.Grid = Backgrid.Grid.extend({
    initialize: function() {
      Backgrid.Grid.prototype.initialize.apply(this, arguments);
      this.listenTo(this.collection, 'add remove sort reset', this.addTitleToOverlfowingCells);
    },
    render: function() {
      Backgrid.Grid.prototype.render.apply(this, arguments);
      this.addTitleToOverlfowingCells();
      return this;
    },
    addTitleToOverlfowingCells: function() {
      var $cells = this.$el.find('td:not(.editable)');
      _.delay(function() {
        $cells.each(function() {
          var $el = $(this);
          var title = _.compact($.makeArray($el.find(':not(:has(*))').map(function() { return $(this).text(); }))).join(', ');
          if (checkOverflow(this)) $el.attr('title', title);
        });
      }, 500);
    },
    loading: function(isLoading){
      if(isLoading){
        this.$el.addClass('loading');
        this.$el.append('<i class="fa fa-spinner fa-spin full-screen-loading-spinner grid-spinner"></i>');
      }else{
        this.$el.removeClass('loading');
        this.$el.find('i.grid-spinner').remove();
      }
    }
  });

  // Shallow flattening of the object to allow search in nested objects.
  // For nested arrays of objects, concatenates values to allow search.
  var flatten = window.flatten = function(object) {
    return _.reduce(object, function(flat, value, attr) {
      if (_.isArray(value) && value.length && _.isObject(value[0]))
        _.each(value, function(o) {
          _.each(o, function(v, a) {
            if (_.isString(v)) {
              if (!flat[attr + '.' + a]) flat[attr + '.' + a] = '';
              flat[attr + '.' + a] += v + ' ';
            }
          });
        });
      else if (_.isObject(value))
        _.each(value, function(v, a) {
          flat[attr + '.' + a] = v;
        });
      else
        flat[attr] = value;
      return flat;
    }, {});
  };

  // Subclass Backgrid Filter to remove diacritics during search, to pass an
  // extra 'pick' filter, and to search in nested objects and nested arrays
  // of objects.
  Backgrid.Amilia.ClientSideFilter = Backgrid.Extension.ClientSideFilter.extend({
    makeMatcher: function(query) {
      var regexp = this.makeRegExp(query);
      return function(model) {
        var flat = flatten(model.toJSON());

        // Test the pick filter (if set)
        if (this.pickFilter) {
          var match = _.find(this.pickFilter, function(value, key) {
            return flat[key] == value;
          });
          if (match === undefined) return false;
        }

        // Test the search filter
        var keys = this.fields || model.keys();
        for (var i = 0, l = keys.length; i < l; i++) {
          if (regexp.test(_.escapeRegExp(_.latinize((flat[keys[i]] || '') + '')))) return true;
        }
        return false;
      };
    },
    // Clear the search if required
    clearIfRequired: function() {
      if (this.searchBox().val().length) this.clear();
    },
    // Pass in a hash of attribute-value pairs to filter. Run with the search.
    pickFilter: null,
    setPickFilter: function(attrs) {
      this.pickFilter = attrs;
      this.search();
      return this;
    }
  });

  // PageSizer renders a SELECT to set the page size of a Backgrid table.
  // Assumes the passed collection has a state property with pageSize
  // like that of an instance of PageableCollection.
  Backgrid.Amilia.PageSizer = Backbone.View.extend({
    tagName: 'select',
    className: 'backgrid-page-sizer',
    defaults: {
      pageSizes: [10, 25, 50, 100],
      optionLabel: '{0} per page',
      maxPageSizeIfNotAllowViewAll: 50 // can put 0 or lower to have max page size = max from pageSizes array
    },
    initialize: function (options) {
      _.extend(this, this.defaults, _.pick(options || {}, _.keys(this.defaults)));
      _.bindAll(this, 'onChange');
      this.allowViewAll = !!options.allowViewAll;
      this.listenTo(this.collection, 'reset update:count', this.render);
    },
    render: function () {

      this.$el.empty().off('change.PageSizer');

      var pageSize = this.collection.state.pageSize;
      var size;
      var label;
      var $option;

      for (var i = 0; i < this.pageSizes.length; i++) {
        size = this.pageSizes[i];

        // if ViewAll is on, don't show options higher than number in collection. e.g. 10-25-All
        if (this.allowViewAll && size > this.collection.state.totalRecords) continue;
        // However, if ViewAll is off, show all options up until the max number, if there is a max.
        if (!this.allowViewAll && size > this.maxPageSizeIfNotAllowViewAll && this.maxPageSizeIfNotAllowViewAll > 0) continue;
        label = this.optionLabel && this.optionLabel.length ? this.optionLabel.replace('{0}', size) : size;
        $option = $('<option>').val(size).text(label);
        if (size == pageSize) $option.attr('selected', 'selected');
        this.$el.append($option);
      }

      if (this.allowViewAll) {
        this.$el.append('<option value="all">' + AMILIA_APP.Labels.ViewAll + '</option>');
        if (pageSize > this.collection.state.totalRecords) {
          pageSize = this.collection.state.totalRecords;
        }
        if (pageSize == this.collection.state.totalRecords) {
          this.$('option[value="all"]').attr('selected', 'selected');
        }
      }

      this.$el.on('change.PageSizer', this.onChange);

      this.$el.toggle(!!this.$('option').length);

      return this;
    },
    onChange: function (e) {
      e.preventDefault();
      var pageSize = e.currentTarget.value != 'all' ? Math.floor(e.currentTarget.value) : this.collection.state.totalRecords;
      this.collection.state.pageSize = pageSize;
      this.collection.state.currentPage = 1;
      this.collection.fetch({ reset: true });
    }
  });

  // ItemCounter renders a DIV with the number of items in the Backgrid table.
  // Supports generic Collection as well as PageableCollection.
  Backgrid.Amilia.ItemCounter = Backbone.View.extend({
    className: 'backgrid-item-counter',
    defaults: {
      label: '{0} items'
    },
    initialize: function(options) {
      _.extend(this, this.defaults, _.pick(options || {}, _.keys(this.defaults)));
      this.listenTo(this.collection, 'reset add remove', this.render);
    },
    render: function() {
      this.$el.empty();

      var size = this.collection.state ? (this.collection.state.totalRecords || 0) : this.collection.size();
      var label = this.label && this.label.length ? this.label.replace('{0}', size) : size;

      this.$el.html(label);

      return this;
    }
  });

  // Adapt Backbone ModalView to use Bootstrap 2.3
  Backbone.ModalView.prototype.template = _.template([
    '<div class="modal-header">',
    '  <a type="button" class="close" aria-hidden="true">&times;</a>',
    '  <%=title%>',
    '</div>',
    '<div class="modal-body"><%=body%></div>',
    '<div class="modal-footer"></div>'
  ].join('\n'));
  Backbone.ModalView.prototype.className = 'modal hide backbone-modal';
  Backbone.ModalView.prototype.buttonTemplate = _.template('<a href="<%=href%>" class="btn btnSet3 <%=className%>"><%=label%></a>');

  // Adapt Backform to use Bootstrap 2.3
  Backform.bootstrap2();

  // Adapt Backbone FormView to use Bootstrap 2.3
  Backbone.FormView.prototype.templates = {
    input: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <input type="<%=type%>" class="input-<%=inputSize%> <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-value%>" placeholder="<%-placeholder%>" />',
      '  </div>',
      '</div>'
    ].join("\n")),
    booleanInput: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <label class="checkbox inline">',
      '      <input type="checkbox" class="input-<%=inputSize%> <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-value%>" /> <%-label%>',
      '    </label>',
      '  </div>',
      '</div>'
    ].join("\n")),
    uneditableInput: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <span class="uneditable-input input-<%=inputSize%> <%=controlClassName%>"><%-value%></span>',
      '  </div>',
      '</div>'
    ].join("\n")),
    spacer: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>">&nbsp;</label>',
      '  <div class="controls <%=controlsClassName%>"></div>',
      '</div>'
    ].join("\n")),
    select: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <select class="input-<%=inputSize%> <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-value%>" placeholder="<%-placeholder%>">',
      '      <% for (var i=0; i < options.length; i++) { %>',
      '        <% var option = options[i]; %>',
      '        <option value="<%-option.value%>" <%=option.value == value ? "selected=\'selected\'" : ""%>><%-option.label%></option>',
      '      <% } %>',
      '    </select>',
      '  </div>',
      '</div>'
    ].join("\n")),
    radioInput: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <% for (var i=0; i < options.length; i++) { %>',
      '      <% var option = options[i]; %>',
      '      <label class="radio inline">',
      '        <input type="radio" class="form-control <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-option.value%>" placeholder="<%-placeholder%>" />',
      '        <%=option.label%>',
      '      </label>',
      '    <% } %>',
      '  </div>',
      '</div>'
    ].join("\n")),
    textarea: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <textarea class="input-<%=inputSize%> <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" placeholder="<%-placeholder%>"><%-value%></textarea>',
      '  </div>',
      '</div>'
    ].join("\n")),
    datepicker: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <input type="<%=type%>" class="input-<%=inputSize%> datepicker <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-value%>" placeholder="<%-placeholder%>" />',
      '  </div>',
      '</div>'
    ].join("\n")),
    // New control implementing jQuery File Upload
    fileInput: _.template([
      '<div class="control-group <%=className%>">',
      '  <label class="control-label <%=labelClassName%>"><%-label%></label>',
      '  <div class="controls <%=controlsClassName%>">',
      '    <div class="file-input btn btnSet3 btn-primary">',
      '      <i class="fa fa-cloud-upload"></i>&nbsp;',
      '      <span class="button-text"><%=options.selectFileLabel%></span>',
      '      <input type="file" class="input-<%=inputSize%> <%=controlClassName%>" name="<%=name%>" data-nested="<%=nested%>" value="<%-value%>" />',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n'))
  };
  Backbone.FormView.prototype.field.inputSize = 'xlarge';
  Backbone.FormView.prototype.groupClassName = 'control-group';
  Backbone.FormView.prototype.errorClassName = 'error';
  Backbone.FormView.prototype.helpClassName = 'help-inline';


  Backform.InputControlWithClear = Backform.InputControl.extend({
    events: _.extend({
      'click a.clear': 'clear'
    }, Backform.InputControl.prototype.events),
    render: function() {
      Backform.InputControl.prototype.render.apply(this, arguments);
      this.$el.find('.controls').append('<a href="#" class="clear text-error"><i class="fa fa-times clear"></i></a>');
      return this;
    },
    clear: function(e) {
      e.preventDefault();
      this.$el.find('input').val('').focus().blur().change();
      return false;
    }
  });

  Backform.SelectControlWithClear = Backform.SelectControl.extend({
    events: _.extend({
      'click a.clear': 'clear'
    }, Backform.SelectControl.prototype.events),
    render: function() {
      Backform.SelectControl.prototype.render.apply(this, arguments);
      this.$el.find('.controls').append('<a href="#" class="clear text-error"><i class="fa fa-times clear"></i></a>');
      return this;
    },
    clear: function(e) {
      e.preventDefault();
      this.$el.find('select').focus().blur().val('').change();
      return false;
    }
  });

  // Subclass Backbone.FormView to show errors found in model attribute Errors.
  // Also add support for fileInput control using jQuery File Upload. When
  // defining that control, use field options:
  //  - url:
  //  - reload: Optional. Boolean indicating whether to reload the page after upload
  //            success or not. Default is false.
  //  - selectFileLabel: Optional. Defaults to "Select a file..."
  //  - uploadingLabel: Optional. Defaults to "Uploading..."
  //  - successLabel: Optional. Defaults to "Upload success! Please wait..."
  //  - multiple: Optional. Boolean to allow multiple file upload. Default is false.
  // Triggers one of two events when upload completes: upload-done or upload-fail.
  // Passes the input element and jQuery File Upload data as arguments to the callback
  // bounds to those events.
  Backgrid.Amilia.FormView = Backbone.FormView.extend({
    initialize: function(options) {
      Backbone.FormView.prototype.initialize.apply(this, arguments);

      // Validate input file controls and provide options defaults
      _.each(this.schema, function(record) {
        if (record.control != 'fileInput') return true;
        record.options = _.defaults(record.options || {}, {
          selectFileLabel: 'Select a file...',
          uploadingLabel: 'Uploading...',
          successLabel: 'Upload success! Please wait...',
          reload: false,
          multiple: false
        });
        if (!record.options.url)
          throw new Error('fileInput control is missing required "url" option!');
        if ($().fileupload === undefined)
          throw new Error('fileInput control requires jQuery File Upload. Please ensure that plugin is loaded first.');
      });

      // Fallback to tracking embedded Errors attribute if no errorModel was passed
      if (this.errorModel === undefined) {
        this.errorModel = new Backbone.Model();

        this.listenTo(this.errorModel, 'change sync', this.updateInvalid);
        this.listenTo(this.model, 'change:Errors sync', function() {
          var errors = this.model.get('Errors');

          this.errorModel.clear();

          if (!_.isEmpty(errors) && _.isObject(errors)) {
            this.errorModel.set(errors);
            this.updateInvalid();
          }
        });
      }
    },
    render: function() {
      Backbone.FormView.prototype.render.apply(this, arguments);

      // Bind input file controls with jQuery File Upload
      var view = this,
          $form = this.$el;
      _.each(this.schema, function(record) {
        if (record.control != 'fileInput') return true;
        var options = record.options,
            $el = record.$el,
            $input = $el.find('input[type="file"]'),
            $icon = $el.find('i'),
            $label = $el.find('span.button-text');
        $input.fileupload({
          dataType: 'json',
          url: options.url,
          start: function(e, data) {
            $el.addClass('busy');
            $icon.removeClass().addClass('fa fa-spinner fa-spin');
            $label.text(options.uploadingLabel);
          },
          done: function(e, xhr) {
            $icon.removeClass().addClass('fa fa-check');
            $label.text(options.successLabel);
            setTimeout(function() {
              if (options.reload)
                window.location.href = window.location.href;
              else {
                $el.removeClass('busy');
                $icon.removeClass().addClass('fa fa-cloud-upload');
                $label.text(options.selectFileLabel);
              }
            }, 500);
            view.trigger('upload-done', $input[0], xhr);
          },
          fail: function(e, xhr) {
            $el.removeClass('busy');
            $icon.removeClass().addClass('fa fa-warning');
            alert(xhr.errorThrown);
            $icon.removeClass().addClass('fa fa-cloud-upload');
            $label.text(options.selectFileLabel);
            view.trigger('upload-fail', $input[0], xhr);
          }
        });
      });

      this.updateInvalid();
      return this;
    }
  });

  // Button view
  Backbone.ButtonView = Backbone.View.extend({
    tagName: 'button',
    className: 'btn',
    errorTemplate: _.template([
      '<div class="button-error selenium-toast-danger">',
      '   <div class="alert">',
      '       <i class="fa fa-warning"></i> <%=message%>',
      '   </div>',
      '</div>'
    ].join('\n')),
    successTemplate: _.template([
      '<div class="button-success selenium-toast-success">',
      '   <div class="alert alert-success">',
      '       <i class="fa fa-check"></i> <%=message%>',
      '   </div>',
      '</div>'
    ].join('\n')),
    defaults: {
      text: 'Next',
      html: null,
      busyText: 'Please wait...',
      click: function() { },
      confirm: false,
      confirmTitle: 'Are you sure?',
      confirmText: 'Please confirm.',
      confirmApplyButtonText: 'Yes',
      confirmCancelButtonText: 'No'
    },
    initialize: function(options) {
      this.options = _.clone(this.defaults);
      _.extend(this.options, options || {});
      _.bindAll(this, 'askConfirmation', 'reset', 'disable', 'isDisabled', 'busy', 'error', 'success', 'ajaxFail', 'ajaxSuccess', 'ajaxSuccessReload', 'ajaxSuccessReloadDelay', 'ajaxSuccessFollowHref', 'clearError');
    },
    render: function() {
      var $button = this.$el,
          button = this;
      $button.off('.ButtonView').on('click.ButtonView', _.debounce(function(e) {
        e.preventDefault();
        if (button.isDisabled()) return false;
        button.busy();
        button.options.confirm ? button.askConfirmation(e) : button.options.click(e, button);
        return false;
      }, 150, true));
      return this;
    },
    askConfirmation: function(buttonEvent) {
      var button = this;
      new Backbone.ModalView({
        className: 'modal hide',
        title: '<h3>' + button.options.confirmTitle + '</h3>',
        body: '<strong>' + button.options.confirmText + '</strong>',
        buttons: [{
          className: 'continue btnSet3 btn-primary pull-right',
          label: button.options.confirmApplyButtonText
        }, {
          className: 'cancel btn-link pull-right',
          label: button.options.confirmCancelButtonText,
          close: true
        }],
        events: {
          'click a.continue': function(e) {
            e.preventDefault();
            button.options.click(buttonEvent, button);
            this.close();
            return false;
          }
        }
      }).render().on('close', button.reset);
    },
    reset: function () {
      this.$el.removeClass('disabled');
      if (this.options.html)
        this.$el.html(this.options.html);
      else
        this.$el.text(this.options.text);

      this.clearError();

      return this;
    },
    disable: function() {
      this.$el.addClass('disabled');
      return this;
    },
    isDisabled: function() {
      return this.$el.hasClass('disabled');
    },
    busy: function() {
      this.$el
          .addClass('disabled')
          .html('<i class="fa fa-spinner fa-spin"></i> ' + this.options.busyText);
      return this;
    },
    error: function(message, delay) {
      delay || (delay = 5000);
      this.clearError();

      var $error = this.$error = $(this.errorTemplate({ message: message })).appendTo('body');

      this.errorTimeoutId = setTimeout(function() {
        if ($error && $error.length) $error.fadeOut();
      }, delay);

      return this;
    },
    success: function(message, delay, callback) {
      delay || (delay = 1000);

      var $success = this.$success = $(this.successTemplate({ message: message })).appendTo('body');

      this.successTimeoutId = setTimeout(function() {
        if ($success && $success.length) $success.fadeOut();
        if (typeof callback == 'function') callback();
      }, delay);

      return this;
    },
    clearError: function() {
      if (this.$error && this.$error.remove) this.$error.remove();
      if (this.errorTimeoutId) clearTimeout(this.errorTimeoutId);
      return this;
    },
    ajaxFail: function (xhr, textStatus, errorThrown) {
      this.reset().error((xhr.responseJSON && xhr.responseJSON.errorMessage) || xhr.statusText);
      return this;
    },
    ajaxSuccess: function(data, textStatus, xhr) {
      this.reset().success(xhr.statusText);
      return this;
    },
    ajaxSuccessReload: function() {
      this.ajaxSuccess.apply(this, arguments);
      window.location.reload();
      return this;
    },
    ajaxSuccessReloadDelay: function(data, textStatus, xhr) {
      this.reset().success(xhr.statusText, 2000, function() {
        window.location.reload();
      });
      return this;
    },
    ajaxSuccessFollowHref: function() {
      this.ajaxSuccess.apply(this, arguments);
      window.location.href = this.$el.attr('href');
      return this;
    }
  });

  // Upload Button view
  Backbone.UploadButtonView = Backbone.View.extend({
    className: 'file-input btn btnSet3 btn-primary',
    template: _.template([
      '<i class="fa fa-cloud-upload"></i>&nbsp;',
      '<span class="button-text"><%=selectFileLabel%></span>',
      '<input type="file" class="input-button" name="<%=name%>" <% if (accept) {%>accept="<%=accept%>"<%}%> />'
    ].join('\n')),
    initialize: function(options) {
      options || (options = {});
      this.options = _.defaults(options, {
        url: undefined,
        name: undefined,
        selectFileLabel: 'Select a file...',
        uploadingLabel: 'Uploading...',
        successLabel: 'Upload success! Please wait...',
        reload: false,
        multiple: false,
        accept: undefined
      });
      if (!this.options.url) throw 'Missing required url option.';
    },
    render: function() {
      this.$el.html(this.template(this.options));
      var view = this,
          $el = this.$el,
          $input = $el.find('input[type="file"]'),
          $icon = $el.find('i'),
          $label = $el.find('span.button-text'),
          options = this.options;

      $input.fileupload({
        dataType: 'json',
        url: options.url,
        headers: options.headers,
        start: function() {
          $el.addClass('busy');
          $icon.removeClass().addClass('fa fa-spinner fa-spin');
          $label.text(options.uploadingLabel);
        },
        done: function(e, data) {
          $icon.removeClass().addClass('fa fa-check');
          $label.text(options.successLabel);
          setTimeout(function() {
            if (options.reload)
              window.location.href = window.location.href;
            else {
              $el.removeClass('busy');
              $icon.removeClass().addClass('fa fa-cloud-upload');
              $label.text(options.selectFileLabel);
            }
          }, 500);
          view.trigger('upload-done', $input[0], data);
        },
        fail: function(e, data) {
          $el.removeClass('busy');
          $icon.removeClass().addClass('fa fa-warning');
          new Backbone.ToastMessage({
            message: (data.jqXHR.responseJSON && data.jqXHR.responseJSON.errorMessage) || data.errorThrown,
            delay: 2000,
            type: 'error'
          }).render();
          $icon.removeClass().addClass('fa fa-cloud-upload');
          $label.text(options.selectFileLabel);
          view.trigger('upload-fail', $input[0], data);
        }
      });

      return this;
    }
  });


  // Helper functions

  // Checks to see if an element is overflowing
  // Source: http://stackoverflow.com/questions/143815/how-to-determine-using-javascript-if-html-element-has-overflowing-content
  // TO DO: Consider moving this to a more generally available location. Maybe turn into a jQuery function.
  function checkOverflow(el) {
    var curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === 'visible')
      el.style.overflow = 'hidden';

    var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;

    return isOverflowing;
  }

  var Latinize = {};
  Latinize.latin_map = { 'Á': 'A', 'Ă': 'A', 'Ắ': 'A', 'Ặ': 'A', 'Ằ': 'A', 'Ẳ': 'A', 'Ẵ': 'A', 'Ǎ': 'A', 'Â': 'A', 'Ấ': 'A', 'Ậ': 'A', 'Ầ': 'A', 'Ẩ': 'A', 'Ẫ': 'A', 'Ä': 'A', 'Ǟ': 'A', 'Ȧ': 'A', 'Ǡ': 'A', 'Ạ': 'A', 'Ȁ': 'A', 'À': 'A', 'Ả': 'A', 'Ȃ': 'A', 'Ā': 'A', 'Ą': 'A', 'Å': 'A', 'Ǻ': 'A', 'Ḁ': 'A', 'Ⱥ': 'A', 'Ã': 'A', 'Ꜳ': 'AA', 'Æ': 'AE', 'Ǽ': 'AE', 'Ǣ': 'AE', 'Ꜵ': 'AO', 'Ꜷ': 'AU', 'Ꜹ': 'AV', 'Ꜻ': 'AV', 'Ꜽ': 'AY', 'Ḃ': 'B', 'Ḅ': 'B', 'Ɓ': 'B', 'Ḇ': 'B', 'Ƀ': 'B', 'Ƃ': 'B', 'Ć': 'C', 'Č': 'C', 'Ç': 'C', 'Ḉ': 'C', 'Ĉ': 'C', 'Ċ': 'C', 'Ƈ': 'C', 'Ȼ': 'C', 'Ď': 'D', 'Ḑ': 'D', 'Ḓ': 'D', 'Ḋ': 'D', 'Ḍ': 'D', 'Ɗ': 'D', 'Ḏ': 'D', 'ǲ': 'D', 'ǅ': 'D', 'Đ': 'D', 'Ƌ': 'D', 'Ǳ': 'DZ', 'Ǆ': 'DZ', 'É': 'E', 'Ĕ': 'E', 'Ě': 'E', 'Ȩ': 'E', 'Ḝ': 'E', 'Ê': 'E', 'Ế': 'E', 'Ệ': 'E', 'Ề': 'E', 'Ể': 'E', 'Ễ': 'E', 'Ḙ': 'E', 'Ë': 'E', 'Ė': 'E', 'Ẹ': 'E', 'Ȅ': 'E', 'È': 'E', 'Ẻ': 'E', 'Ȇ': 'E', 'Ē': 'E', 'Ḗ': 'E', 'Ḕ': 'E', 'Ę': 'E', 'Ɇ': 'E', 'Ẽ': 'E', 'Ḛ': 'E', 'Ꝫ': 'ET', 'Ḟ': 'F', 'Ƒ': 'F', 'Ǵ': 'G', 'Ğ': 'G', 'Ǧ': 'G', 'Ģ': 'G', 'Ĝ': 'G', 'Ġ': 'G', 'Ɠ': 'G', 'Ḡ': 'G', 'Ǥ': 'G', 'Ḫ': 'H', 'Ȟ': 'H', 'Ḩ': 'H', 'Ĥ': 'H', 'Ⱨ': 'H', 'Ḧ': 'H', 'Ḣ': 'H', 'Ḥ': 'H', 'Ħ': 'H', 'Í': 'I', 'Ĭ': 'I', 'Ǐ': 'I', 'Î': 'I', 'Ï': 'I', 'Ḯ': 'I', 'İ': 'I', 'Ị': 'I', 'Ȉ': 'I', 'Ì': 'I', 'Ỉ': 'I', 'Ȋ': 'I', 'Ī': 'I', 'Į': 'I', 'Ɨ': 'I', 'Ĩ': 'I', 'Ḭ': 'I', 'Ꝺ': 'D', 'Ꝼ': 'F', 'Ᵹ': 'G', 'Ꞃ': 'R', 'Ꞅ': 'S', 'Ꞇ': 'T', 'Ꝭ': 'IS', 'Ĵ': 'J', 'Ɉ': 'J', 'Ḱ': 'K', 'Ǩ': 'K', 'Ķ': 'K', 'Ⱪ': 'K', 'Ꝃ': 'K', 'Ḳ': 'K', 'Ƙ': 'K', 'Ḵ': 'K', 'Ꝁ': 'K', 'Ꝅ': 'K', 'Ĺ': 'L', 'Ƚ': 'L', 'Ľ': 'L', 'Ļ': 'L', 'Ḽ': 'L', 'Ḷ': 'L', 'Ḹ': 'L', 'Ⱡ': 'L', 'Ꝉ': 'L', 'Ḻ': 'L', 'Ŀ': 'L', 'Ɫ': 'L', 'ǈ': 'L', 'Ł': 'L', 'Ǉ': 'LJ', 'Ḿ': 'M', 'Ṁ': 'M', 'Ṃ': 'M', 'Ɱ': 'M', 'Ń': 'N', 'Ň': 'N', 'Ņ': 'N', 'Ṋ': 'N', 'Ṅ': 'N', 'Ṇ': 'N', 'Ǹ': 'N', 'Ɲ': 'N', 'Ṉ': 'N', 'Ƞ': 'N', 'ǋ': 'N', 'Ñ': 'N', 'Ǌ': 'NJ', 'Ó': 'O', 'Ŏ': 'O', 'Ǒ': 'O', 'Ô': 'O', 'Ố': 'O', 'Ộ': 'O', 'Ồ': 'O', 'Ổ': 'O', 'Ỗ': 'O', 'Ö': 'O', 'Ȫ': 'O', 'Ȯ': 'O', 'Ȱ': 'O', 'Ọ': 'O', 'Ő': 'O', 'Ȍ': 'O', 'Ò': 'O', 'Ỏ': 'O', 'Ơ': 'O', 'Ớ': 'O', 'Ợ': 'O', 'Ờ': 'O', 'Ở': 'O', 'Ỡ': 'O', 'Ȏ': 'O', 'Ꝋ': 'O', 'Ꝍ': 'O', 'Ō': 'O', 'Ṓ': 'O', 'Ṑ': 'O', 'Ɵ': 'O', 'Ǫ': 'O', 'Ǭ': 'O', 'Ø': 'O', 'Ǿ': 'O', 'Õ': 'O', 'Ṍ': 'O', 'Ṏ': 'O', 'Ȭ': 'O', 'Ƣ': 'OI', 'Ꝏ': 'OO', 'Ɛ': 'E', 'Ɔ': 'O', 'Ȣ': 'OU', 'Ṕ': 'P', 'Ṗ': 'P', 'Ꝓ': 'P', 'Ƥ': 'P', 'Ꝕ': 'P', 'Ᵽ': 'P', 'Ꝑ': 'P', 'Ꝙ': 'Q', 'Ꝗ': 'Q', 'Ŕ': 'R', 'Ř': 'R', 'Ŗ': 'R', 'Ṙ': 'R', 'Ṛ': 'R', 'Ṝ': 'R', 'Ȑ': 'R', 'Ȓ': 'R', 'Ṟ': 'R', 'Ɍ': 'R', 'Ɽ': 'R', 'Ꜿ': 'C', 'Ǝ': 'E', 'Ś': 'S', 'Ṥ': 'S', 'Š': 'S', 'Ṧ': 'S', 'Ş': 'S', 'Ŝ': 'S', 'Ș': 'S', 'Ṡ': 'S', 'Ṣ': 'S', 'Ṩ': 'S', 'Ť': 'T', 'Ţ': 'T', 'Ṱ': 'T', 'Ț': 'T', 'Ⱦ': 'T', 'Ṫ': 'T', 'Ṭ': 'T', 'Ƭ': 'T', 'Ṯ': 'T', 'Ʈ': 'T', 'Ŧ': 'T', 'Ɐ': 'A', 'Ꞁ': 'L', 'Ɯ': 'M', 'Ʌ': 'V', 'Ꜩ': 'TZ', 'Ú': 'U', 'Ŭ': 'U', 'Ǔ': 'U', 'Û': 'U', 'Ṷ': 'U', 'Ü': 'U', 'Ǘ': 'U', 'Ǚ': 'U', 'Ǜ': 'U', 'Ǖ': 'U', 'Ṳ': 'U', 'Ụ': 'U', 'Ű': 'U', 'Ȕ': 'U', 'Ù': 'U', 'Ủ': 'U', 'Ư': 'U', 'Ứ': 'U', 'Ự': 'U', 'Ừ': 'U', 'Ử': 'U', 'Ữ': 'U', 'Ȗ': 'U', 'Ū': 'U', 'Ṻ': 'U', 'Ų': 'U', 'Ů': 'U', 'Ũ': 'U', 'Ṹ': 'U', 'Ṵ': 'U', 'Ꝟ': 'V', 'Ṿ': 'V', 'Ʋ': 'V', 'Ṽ': 'V', 'Ꝡ': 'VY', 'Ẃ': 'W', 'Ŵ': 'W', 'Ẅ': 'W', 'Ẇ': 'W', 'Ẉ': 'W', 'Ẁ': 'W', 'Ⱳ': 'W', 'Ẍ': 'X', 'Ẋ': 'X', 'Ý': 'Y', 'Ŷ': 'Y', 'Ÿ': 'Y', 'Ẏ': 'Y', 'Ỵ': 'Y', 'Ỳ': 'Y', 'Ƴ': 'Y', 'Ỷ': 'Y', 'Ỿ': 'Y', 'Ȳ': 'Y', 'Ɏ': 'Y', 'Ỹ': 'Y', 'Ź': 'Z', 'Ž': 'Z', 'Ẑ': 'Z', 'Ⱬ': 'Z', 'Ż': 'Z', 'Ẓ': 'Z', 'Ȥ': 'Z', 'Ẕ': 'Z', 'Ƶ': 'Z', 'Ĳ': 'IJ', 'Œ': 'OE', 'ᴀ': 'A', 'ᴁ': 'AE', 'ʙ': 'B', 'ᴃ': 'B', 'ᴄ': 'C', 'ᴅ': 'D', 'ᴇ': 'E', 'ꜰ': 'F', 'ɢ': 'G', 'ʛ': 'G', 'ʜ': 'H', 'ɪ': 'I', 'ʁ': 'R', 'ᴊ': 'J', 'ᴋ': 'K', 'ʟ': 'L', 'ᴌ': 'L', 'ᴍ': 'M', 'ɴ': 'N', 'ᴏ': 'O', 'ɶ': 'OE', 'ᴐ': 'O', 'ᴕ': 'OU', 'ᴘ': 'P', 'ʀ': 'R', 'ᴎ': 'N', 'ᴙ': 'R', 'ꜱ': 'S', 'ᴛ': 'T', 'ⱻ': 'E', 'ᴚ': 'R', 'ᴜ': 'U', 'ᴠ': 'V', 'ᴡ': 'W', 'ʏ': 'Y', 'ᴢ': 'Z', 'á': 'a', 'ă': 'a', 'ắ': 'a', 'ặ': 'a', 'ằ': 'a', 'ẳ': 'a', 'ẵ': 'a', 'ǎ': 'a', 'â': 'a', 'ấ': 'a', 'ậ': 'a', 'ầ': 'a', 'ẩ': 'a', 'ẫ': 'a', 'ä': 'a', 'ǟ': 'a', 'ȧ': 'a', 'ǡ': 'a', 'ạ': 'a', 'ȁ': 'a', 'à': 'a', 'ả': 'a', 'ȃ': 'a', 'ā': 'a', 'ą': 'a', 'ᶏ': 'a', 'ẚ': 'a', 'å': 'a', 'ǻ': 'a', 'ḁ': 'a', 'ⱥ': 'a', 'ã': 'a', 'ꜳ': 'aa', 'æ': 'ae', 'ǽ': 'ae', 'ǣ': 'ae', 'ꜵ': 'ao', 'ꜷ': 'au', 'ꜹ': 'av', 'ꜻ': 'av', 'ꜽ': 'ay', 'ḃ': 'b', 'ḅ': 'b', 'ɓ': 'b', 'ḇ': 'b', 'ᵬ': 'b', 'ᶀ': 'b', 'ƀ': 'b', 'ƃ': 'b', 'ɵ': 'o', 'ć': 'c', 'č': 'c', 'ç': 'c', 'ḉ': 'c', 'ĉ': 'c', 'ɕ': 'c', 'ċ': 'c', 'ƈ': 'c', 'ȼ': 'c', 'ď': 'd', 'ḑ': 'd', 'ḓ': 'd', 'ȡ': 'd', 'ḋ': 'd', 'ḍ': 'd', 'ɗ': 'd', 'ᶑ': 'd', 'ḏ': 'd', 'ᵭ': 'd', 'ᶁ': 'd', 'đ': 'd', 'ɖ': 'd', 'ƌ': 'd', 'ı': 'i', 'ȷ': 'j', 'ɟ': 'j', 'ʄ': 'j', 'ǳ': 'dz', 'ǆ': 'dz', 'é': 'e', 'ĕ': 'e', 'ě': 'e', 'ȩ': 'e', 'ḝ': 'e', 'ê': 'e', 'ế': 'e', 'ệ': 'e', 'ề': 'e', 'ể': 'e', 'ễ': 'e', 'ḙ': 'e', 'ë': 'e', 'ė': 'e', 'ẹ': 'e', 'ȅ': 'e', 'è': 'e', 'ẻ': 'e', 'ȇ': 'e', 'ē': 'e', 'ḗ': 'e', 'ḕ': 'e', 'ⱸ': 'e', 'ę': 'e', 'ᶒ': 'e', 'ɇ': 'e', 'ẽ': 'e', 'ḛ': 'e', 'ꝫ': 'et', 'ḟ': 'f', 'ƒ': 'f', 'ᵮ': 'f', 'ᶂ': 'f', 'ǵ': 'g', 'ğ': 'g', 'ǧ': 'g', 'ģ': 'g', 'ĝ': 'g', 'ġ': 'g', 'ɠ': 'g', 'ḡ': 'g', 'ᶃ': 'g', 'ǥ': 'g', 'ḫ': 'h', 'ȟ': 'h', 'ḩ': 'h', 'ĥ': 'h', 'ⱨ': 'h', 'ḧ': 'h', 'ḣ': 'h', 'ḥ': 'h', 'ɦ': 'h', 'ẖ': 'h', 'ħ': 'h', 'ƕ': 'hv', 'í': 'i', 'ĭ': 'i', 'ǐ': 'i', 'î': 'i', 'ï': 'i', 'ḯ': 'i', 'ị': 'i', 'ȉ': 'i', 'ì': 'i', 'ỉ': 'i', 'ȋ': 'i', 'ī': 'i', 'į': 'i', 'ᶖ': 'i', 'ɨ': 'i', 'ĩ': 'i', 'ḭ': 'i', 'ꝺ': 'd', 'ꝼ': 'f', 'ᵹ': 'g', 'ꞃ': 'r', 'ꞅ': 's', 'ꞇ': 't', 'ꝭ': 'is', 'ǰ': 'j', 'ĵ': 'j', 'ʝ': 'j', 'ɉ': 'j', 'ḱ': 'k', 'ǩ': 'k', 'ķ': 'k', 'ⱪ': 'k', 'ꝃ': 'k', 'ḳ': 'k', 'ƙ': 'k', 'ḵ': 'k', 'ᶄ': 'k', 'ꝁ': 'k', 'ꝅ': 'k', 'ĺ': 'l', 'ƚ': 'l', 'ɬ': 'l', 'ľ': 'l', 'ļ': 'l', 'ḽ': 'l', 'ȴ': 'l', 'ḷ': 'l', 'ḹ': 'l', 'ⱡ': 'l', 'ꝉ': 'l', 'ḻ': 'l', 'ŀ': 'l', 'ɫ': 'l', 'ᶅ': 'l', 'ɭ': 'l', 'ł': 'l', 'ǉ': 'lj', 'ſ': 's', 'ẜ': 's', 'ẛ': 's', 'ẝ': 's', 'ḿ': 'm', 'ṁ': 'm', 'ṃ': 'm', 'ɱ': 'm', 'ᵯ': 'm', 'ᶆ': 'm', 'ń': 'n', 'ň': 'n', 'ņ': 'n', 'ṋ': 'n', 'ȵ': 'n', 'ṅ': 'n', 'ṇ': 'n', 'ǹ': 'n', 'ɲ': 'n', 'ṉ': 'n', 'ƞ': 'n', 'ᵰ': 'n', 'ᶇ': 'n', 'ɳ': 'n', 'ñ': 'n', 'ǌ': 'nj', 'ó': 'o', 'ŏ': 'o', 'ǒ': 'o', 'ô': 'o', 'ố': 'o', 'ộ': 'o', 'ồ': 'o', 'ổ': 'o', 'ỗ': 'o', 'ö': 'o', 'ȫ': 'o', 'ȯ': 'o', 'ȱ': 'o', 'ọ': 'o', 'ő': 'o', 'ȍ': 'o', 'ò': 'o', 'ỏ': 'o', 'ơ': 'o', 'ớ': 'o', 'ợ': 'o', 'ờ': 'o', 'ở': 'o', 'ỡ': 'o', 'ȏ': 'o', 'ꝋ': 'o', 'ꝍ': 'o', 'ⱺ': 'o', 'ō': 'o', 'ṓ': 'o', 'ṑ': 'o', 'ǫ': 'o', 'ǭ': 'o', 'ø': 'o', 'ǿ': 'o', 'õ': 'o', 'ṍ': 'o', 'ṏ': 'o', 'ȭ': 'o', 'ƣ': 'oi', 'ꝏ': 'oo', 'ɛ': 'e', 'ᶓ': 'e', 'ɔ': 'o', 'ᶗ': 'o', 'ȣ': 'ou', 'ṕ': 'p', 'ṗ': 'p', 'ꝓ': 'p', 'ƥ': 'p', 'ᵱ': 'p', 'ᶈ': 'p', 'ꝕ': 'p', 'ᵽ': 'p', 'ꝑ': 'p', 'ꝙ': 'q', 'ʠ': 'q', 'ɋ': 'q', 'ꝗ': 'q', 'ŕ': 'r', 'ř': 'r', 'ŗ': 'r', 'ṙ': 'r', 'ṛ': 'r', 'ṝ': 'r', 'ȑ': 'r', 'ɾ': 'r', 'ᵳ': 'r', 'ȓ': 'r', 'ṟ': 'r', 'ɼ': 'r', 'ᵲ': 'r', 'ᶉ': 'r', 'ɍ': 'r', 'ɽ': 'r', 'ↄ': 'c', 'ꜿ': 'c', 'ɘ': 'e', 'ɿ': 'r', 'ś': 's', 'ṥ': 's', 'š': 's', 'ṧ': 's', 'ş': 's', 'ŝ': 's', 'ș': 's', 'ṡ': 's', 'ṣ': 's', 'ṩ': 's', 'ʂ': 's', 'ᵴ': 's', 'ᶊ': 's', 'ȿ': 's', 'ɡ': 'g', 'ᴑ': 'o', 'ᴓ': 'o', 'ᴝ': 'u', 'ť': 't', 'ţ': 't', 'ṱ': 't', 'ț': 't', 'ȶ': 't', 'ẗ': 't', 'ⱦ': 't', 'ṫ': 't', 'ṭ': 't', 'ƭ': 't', 'ṯ': 't', 'ᵵ': 't', 'ƫ': 't', 'ʈ': 't', 'ŧ': 't', 'ᵺ': 'th', 'ɐ': 'a', 'ᴂ': 'ae', 'ǝ': 'e', 'ᵷ': 'g', 'ɥ': 'h', 'ʮ': 'h', 'ʯ': 'h', 'ᴉ': 'i', 'ʞ': 'k', 'ꞁ': 'l', 'ɯ': 'm', 'ɰ': 'm', 'ᴔ': 'oe', 'ɹ': 'r', 'ɻ': 'r', 'ɺ': 'r', 'ⱹ': 'r', 'ʇ': 't', 'ʌ': 'v', 'ʍ': 'w', 'ʎ': 'y', 'ꜩ': 'tz', 'ú': 'u', 'ŭ': 'u', 'ǔ': 'u', 'û': 'u', 'ṷ': 'u', 'ü': 'u', 'ǘ': 'u', 'ǚ': 'u', 'ǜ': 'u', 'ǖ': 'u', 'ṳ': 'u', 'ụ': 'u', 'ű': 'u', 'ȕ': 'u', 'ù': 'u', 'ủ': 'u', 'ư': 'u', 'ứ': 'u', 'ự': 'u', 'ừ': 'u', 'ử': 'u', 'ữ': 'u', 'ȗ': 'u', 'ū': 'u', 'ṻ': 'u', 'ų': 'u', 'ᶙ': 'u', 'ů': 'u', 'ũ': 'u', 'ṹ': 'u', 'ṵ': 'u', 'ᵫ': 'ue', 'ꝸ': 'um', 'ⱴ': 'v', 'ꝟ': 'v', 'ṿ': 'v', 'ʋ': 'v', 'ᶌ': 'v', 'ⱱ': 'v', 'ṽ': 'v', 'ꝡ': 'vy', 'ẃ': 'w', 'ŵ': 'w', 'ẅ': 'w', 'ẇ': 'w', 'ẉ': 'w', 'ẁ': 'w', 'ⱳ': 'w', 'ẘ': 'w', 'ẍ': 'x', 'ẋ': 'x', 'ᶍ': 'x', 'ý': 'y', 'ŷ': 'y', 'ÿ': 'y', 'ẏ': 'y', 'ỵ': 'y', 'ỳ': 'y', 'ƴ': 'y', 'ỷ': 'y', 'ỿ': 'y', 'ȳ': 'y', 'ẙ': 'y', 'ɏ': 'y', 'ỹ': 'y', 'ź': 'z', 'ž': 'z', 'ẑ': 'z', 'ʑ': 'z', 'ⱬ': 'z', 'ż': 'z', 'ẓ': 'z', 'ȥ': 'z', 'ẕ': 'z', 'ᵶ': 'z', 'ᶎ': 'z', 'ʐ': 'z', 'ƶ': 'z', 'ɀ': 'z', 'ﬀ': 'ff', 'ﬃ': 'ffi', 'ﬄ': 'ffl', 'ﬁ': 'fi', 'ﬂ': 'fl', 'ĳ': 'ij', 'œ': 'oe', 'ﬆ': 'st', 'ₐ': 'a', 'ₑ': 'e', 'ᵢ': 'i', 'ⱼ': 'j', 'ₒ': 'o', 'ᵣ': 'r', 'ᵤ': 'u', 'ᵥ': 'v', 'ₓ': 'x' };
  _.mixin({
    latinize: function(str) {
      return str.replace(/[^A-Za-z0-9\[\] ]/g, function(a) {
        return Latinize.latin_map[a] || a;
      });
    },
    escapeRegExp: function(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    },
    removeTimestampFromDateString: function(value) {
      if (!_.isString(value)) return value;
      return value.replace(/T\d{2}:\d{2}:\d{2}Z?/, "");
    },
    humanJoin: function(list, and) {
      if (list.length == 0) return '';
      if (list.length == 1) return list[0];
      if (list.length == 2) return list[0] + ' ' + (and || '&') + ' ' + list[1];
      return list.slice(0, -2).join(', ') + ', ' + list.slice(-2).join(' ' + (and || '&') + ' ');
    },
    formatPhoneNumber: function(number) {
      var value = ('' + number).replace(/[\D]/g, '');
      if (value[0] == 1) {
        var m = value.match(/^(\d)(\d{3})(\d{3})(\d{4})(\d*)$/);
        var ext = '';
        if (!(m == null) && m[5]) {
          ext = ' Ext. ' + m[5];
        }
        value = (!m) ? value : m[1] + ' ' + m[2] + '-' + m[3] + '-' + m[4] + ext;
      } else {
        var m = value.match(/^(\d{3})(\d{3})(\d{4})(\d*)$/);
        var ext = '';
        if (!(m == null) && m[4]) {
          ext = ' Ext. ' + m[4];
        }
        value = (!m) ? value : m[1] + '-' + m[2] + '-' + m[3] + ext;
      }
      return value;
    },
    formatPostalCode: function(code) {
      var value = ('' + code).replace(/\s/g, '');
      if (value.length == 6) {
        var m = value.match(/^(\S{3})(\S{3})$/);
        value = (!m) ? value : m[1].toUpperCase() + ' ' + m[2].toUpperCase();
      }
      return value;
    },
    formatCityName: function(city) {
      return city.toLowerCase().replace(/([^a-z]|^)([a-z])(?=[a-z]{1})/g, function(_, g1, g2) {
        return g1 + g2.toUpperCase();
      }).replace(/(^l')/g, function(g3) {
        return g3.toUpperCase();
      }).replace(/\(([^)]+)\)/, function(sub) {
        return sub.toUpperCase();
      });
    }
  });

  // TABLE TOOLTIP
  // Displays a tooltip at the mouse cursor containing a table of sub-attributes.
  // Can be placed on any html element, and works well in Backgrid tables.

  // To set up DOM, make sure to put the model id in a "data-id" attribute of
  // the item to be displayed in the tooltip; also add the class "table-tooltip"
  // to this item.

  // Example model:
  //   {'InvoiceItems': [
  //     {
  //       'Description': 'Red unicycle',
  //       'Total': 89.50
  //     },
  //     {
  //       'Description': 'Circus training registration',
  //       'Total': 50.00
  //     }
  //   ]}

  // Example declaration:
  // var tableTooltip = new Backgrid.Amilia.TableTooltip({
  //   collection: this.invoiceCollection,
  //   tooltipAttr: 'InvoiceItems',
  //   tooltipSubAttrs: ['Description', 'Total'],
  //   format: {
  //      Total: 'currency'
  //   },
  //   align: {
  //      Total: 'right'
  //   },
  //   hoverDelay: 2500
  // }).render();

  // This will create a tooltip that displays a zebra-striped table
  // of the sub-attributes. (NB: fomat, align, and hoverDelay are optional)

  // To alter the way the tooltip displays data, simply override the
  // fillTooltipContent method; if this method is overridden, tooltipAttr
  // and tooltipSubAttrs will not be used -- the display must be created manually

  Backgrid.Amilia.TableTooltip = Backbone.View.extend({
    initialize: function(options) {
      this.options = _.defaults(options, {
        shiftPressed: false,
        mouseIsOver: false,
        hoverDelayOver: false,
        tooltipX: 0,
        tooltipY: 0,
        bottomX: 0,
        format: {},
        align: {},
        hoverDelay: 1000
      });

      this.name = options.name;
      this.collection = options.collection;
    },

    render: function() {
      var self = this;
      this.$tableTooltip = $('<div class="table-tooltip-div" name="' + this.name + '"></div>').appendTo($('body'));
      $('body').on('keydown', function(e) {
        if (!self.options.shiftPressed && e.shiftKey) {
          self.options.shiftPressed = true;
          self.displayAndUpdateTooltip.apply(self, arguments);
        }
      }).on('keyup', function(e) {
        self.hideTooltip.apply(self, arguments);
        self.options.shiftPressed = false;
      });

      $('body').off('mousemove mouseenter mouseleave', '.table-tooltip' + (this.name ? '[name="' + this.name + '"]' : ''));

      $('body')
        .on('mousemove', '.table-tooltip' + (this.name ? '[name="' + this.name + '"]' : ''), function(e) {
          self.displayAndUpdateTooltip.apply(self, arguments);
        })
        .on('mouseenter', '.table-tooltip' + (this.name ? '[name="' + this.name + '"]' : ''), function(e) {
          self.options.mouseIsOver = true;
          self.fillTooltipContent.apply(self, arguments);
          if (self.options.shiftPressed) {
            self.displayAndUpdateTooltip.apply(self, arguments);
          }
          else {
            var x = setTimeout(function() {
              self.options.hoverDelayOver = true;
              self.displayAndUpdateTooltip.apply(self, arguments);
            }, self.options.hoverDelay);
          }
        })
        .on('mouseleave', '.table-tooltip' + (this.name ? '[name="' + this.name + '"]' : ''), function(e) {
          self.hideTooltip.apply(self, arguments);
        });
    },

    fillTooltipContent: function(e) {
      var $target = $(e.currentTarget),
          id = $target.attr('data-id'),
          html = '<table>',
          model = this.collection.get(id),
          items = this.getItems(model, this.options.tooltipAttr);

      for (var item in items) {
        html += '<tr>';
        for (var subAttr in this.options.tooltipSubAttrs) {
          var align = this.options.align[this.options.tooltipSubAttrs[subAttr]] || 'left';
          var value = items[item][this.options.tooltipSubAttrs[subAttr]];
          if (this.options.format[this.options.tooltipSubAttrs[subAttr]] == 'currency') {
            var parsedValue = parseFloat(value);
            value = parsedValue > 0 ? '$' + parsedValue.toFixed(2) : '($' + Math.abs(parsedValue).toFixed(2) + ')';
          }

          html += '<td style="text-align:' + align + ';">' + value + '</td>';
        }
        html += '</tr>';
      }

      html += '</table>';
      this.$tableTooltip.html(html);
    },

    getItems: function(model, path) {
      path = path.split('.');
      var res = model.get(path.shift());
      for (var i = 0; i < path.length; i++) {
        if (res[path[i]]) res = res[path[i]];
      }
      return res;
    },

    displayAndUpdateTooltip: function(e) {
      this.$tableTooltip.toggle((this.options.shiftPressed || this.options.hoverDelayOver) && this.options.mouseIsOver);
      if (e) {
        this.options.tooltipX = e.pageX;
        this.options.tooltipY = e.pageY;
        this.options.bottomX = e.clientY + this.$tableTooltip.outerHeight();
      }

      var verticalOffset = (this.options.bottomX + 20) > $(window).outerHeight() ? this.$tableTooltip.outerHeight() : 0;

      var max_width = ($(window).width() / 2) - 100;

      var horizontalOffset = this.options.tooltipX > ($(window).width() / 2) ? max_width < this.$tableTooltip.outerWidth() ? -(max_width + 20) : -(this.$tableTooltip.outerWidth() + 20) : 10;

      this.$tableTooltip.css({
        left: this.options.tooltipX + horizontalOffset,
        top: this.options.tooltipY - verticalOffset,
        'max-width': max_width
      });
    },

    hideTooltip: function() {
      this.$tableTooltip.hide();
      this.options.mouseIsOver = false;
      this.options.hoverDelayOver = false;
    }
  });

  Backform.BirthdayControl = Backform.SelectControl.extend({
    defaults: {
      showAdultOrChildHelper: false,
      extraClasses: '',
      options: {
        years: (function() {
          var years = [{
            label: '--',
            value: null
          }];
          var now = new Date().getFullYear();
          for (var i = now; i >= now - 100; i--) {
            years.push({
              label: i,
              value: i
            });
          }
          return years;
        }).call(this),
        months: (function() {
          var months = _.map(moment.months(), function(month, ix) {
            return {
              label: month,
              value: ix
            };
          });
          months.unshift({
            label: '--',
            value: null
          });
          return months;
        }).call(this),
        days: (function() {
          var days = [{
            label: '--',
            value: null
          }];
          for (var i = 1; i <= 31; i++) {
            days.push({
              label: i,
              value: i
            });
          }
          return days;
        }).call(this)
      }
    },
    template: _.template([
      '<label class="<%=Backform.controlLabelClassName%>"><%=label%></label>',
      '<div class="<%=Backform.controlsClassName%>">',
      '  <select class="input auto-width year-select <%=extraClasses%>" name="<%=name%>" value="<%-JSON.stringify(value)%>" <%=disabled ? "disabled" : ""%> <%=required ? "required" : ""%> >',
      '    <% for (var i=0; i < options.years.length; i++) { %>',
      '      <% var option = options.years[i]; %>',
      '      <option value="<%-JSON.stringify(option.value)%>" <%=option.value == value ? "selected=\'selected\'" : ""%>><%-option.label%></option>',
      '    <% } %>',
      '  </select>&nbsp;&nbsp;&nbsp;',
      '  <select class="input auto-width month-select <%=extraClasses%>" name="<%=name%>" value="<%-JSON.stringify(value)%>" <%=disabled ? "disabled" : ""%> <%=required ? "required" : ""%> >',
      '    <% for (var i=0; i < options.months.length; i++) { %>',
      '      <% var option = options.months[i]; %>',
      '      <option value="<%-JSON.stringify(option.value)%>" <%=option.value == value ? "selected=\'selected\'" : ""%>><%-option.label%></option>',
      '    <% } %>',
      '  </select>&nbsp;&nbsp;&nbsp;',
      '  <select class="input auto-width day-select <%=extraClasses%>" name="<%=name%>" value="<%-JSON.stringify(value)%>" <%=disabled ? "disabled" : ""%> <%=required ? "required" : ""%> >',
      '    <% for (var i=0; i < options.days.length; i++) { %>',
      '      <% var option = options.days[i]; %>',
      '      <option value="<%-JSON.stringify(option.value)%>" <%=option.value == value ? "selected=\'selected\'" : ""%>><%-option.label%></option>',
      '    <% } %>',
      '  </select>',
      '  <span class="help-inline adult-or-child auto-width"></span>',
      '</div>'
      ].join('\n')),
    initialize: function() {
      Backform.SelectControl.prototype.initialize.apply(this, arguments);
      var name = this.field.get("name").split('.').shift();
      if (this.field.get('showAdultOrChildHelper')) {
        this.listenTo(this.model, 'change:' + name, this.renderAdultOrChild);
        this.listenTo(this.model, 'change:Gender', this.renderAdultOrChild);
      }
    },
    render: function() {
      Backform.SelectControl.prototype.render.apply(this, arguments);
      var date = this.keyPathAccessor(this.model.toJSON(), this.field.get('name'));
      if (!date) {
        this.$('.year-select').find('option[value="null"]').attr('selected', 'selected');
        this.$('.month-select').find('option[value="null"]').attr('selected', 'selected');
        this.$('.day-select').find('option[value="null"]').attr('selected', 'selected');
      } else {
        var birthday = new Date(date);
        birthday.setTime(birthday.getTime() + (birthday.getTimezoneOffset() * 60000));
        this.$('.year-select').find('option[value="' + birthday.getFullYear() + '"]').attr('selected', 'selected');
        this.$('.month-select').find('option[value="' + birthday.getMonth() + '"]').attr('selected', 'selected');
        this.$('.day-select').find('option[value="' + birthday.getDate() + '"]').attr('selected', 'selected');
      }
      if (this.field.get('showAdultOrChildHelper')) this.renderAdultOrChild();
      return this;
    },
    renderAdultOrChild: function() {
      var ageTobeShown = '';
      var date = this.keyPathAccessor(this.model.attributes, this.field.get('name')),
          isAdult = true;

      if (date)
        isAdult = Math.floor(moment(new Date()).diff(moment(new Date(date)), 'years', true)) >= 18;

      var gender = this.model.get('Gender') || 2,
          iconHtml = '<i class="fa fa-fw ';
      if (isAdult && gender == 2)
        iconHtml += 'fa-male male-icon';
      else if (isAdult && gender == 4)
        iconHtml += 'fa-female female-icon';
      else if (!isAdult && gender == 2)
        iconHtml += 'fa-child male-icon';
      else if (!isAdult && gender == 4)
        iconHtml += 'fa-child female-icon';
      iconHtml += '"></i> ';

      if (date && moment(new Date()).diff(moment(new Date(date))) > 0) {
        var birth = moment(date);
        ageTobeShown = AMILIA_APP.utils.displayAge(birth, moment());
      }

      this.$('.adult-or-child').html(ageTobeShown);


      return this;
    },
    getValueFromDOM: function() {

      var year = parseInt(this.$('.year-select').val());
      var month = parseInt(this.$('.month-select').val());
      var date = parseInt(this.$('.day-select').val());

      if (_.isNaN(year) || _.isNaN(month) || _.isNaN(date)) {
        return null;
      }

      var birthday = new Date(year, month, date, 0, 0, 0);
      return birthday.toJSON().replace('Z', '');
    }
  });

  Backbone.ToastMessage = Backbone.View.extend({
    errorTemplate: _.template([
      '<div class="button-error selenium-toast-danger">',
      '   <div class="alert alert-warning">',
      '       <i class="fa fa-warning"></i> <%=message%>',
      '   </div>',
      '</div>'
    ].join('\n')),
    successTemplate: _.template([
      '<div class="button-success selenium-toast-success">',
      '   <div class="alert alert-success">',
      '       <i class="fa fa-check"></i> <%=message%>',
      '   </div>',
      '</div>'
    ].join('\n')),
    defaultOptions: {
      type: 'success', // success or error
      message: '',
      delay: 1000, // defaults to 5000 when type is error
      callback: function() {},
      ephemeral: true // destroy after use
    },
    initialize: function(options) {
      this.options = _.extend({}, this.defaultOptions, options);
      if (this.options.type !== 'success' && this.options.type !== 'error')
        throw 'Invalid ToastMessage type "' + options.type + '". Must be "success" or "error".';
      if (!this.options.message) throw 'ToastMessage message is empty!';
      if (this.options.type == 'error' && !options.delay) this.options.delay = 5000;
      if (!_.isNumber(this.options.delay)) throw 'ToastMessage delay must be a number.';
    },
    render: function() {
      var template = this[this.options.type + 'Template'];
      this.$el = $(template({message: this.options.message})).appendTo('body');

      var callback = _.bind(function() {
        if (this.options.ephemeral) _.defer(_.bind(this.remove, this));
        if (typeof this.options.callback == 'function') this.options.callback();
      }, this);

      this.timeoutId = setTimeout(_.bind(function() {
        this.$el.fadeOut(400, callback);
      }, this), this.options.delay);

      return this;
    },
    remove: function() {
      Backbone.View.prototype.remove.apply(this, arguments);
      if (this.timeoutId) clearTimeout(this.timeoutId);
      return this;
    }
  });

  Backbone.toast = function(type, message) {
    new Backbone.ToastMessage({
      type: type,
      message: message
    }).render();
  };

  Backbone.toastSuccess = function(message) {
    Backbone.toast('success', message);
  };

  Backbone.toastError = function(message) {
    Backbone.toast('error', message);
  };

  Backform.HorizontalRadioControl = Backform.RadioControl.extend({
    template: _.template([
      '<label class="<%=Backform.controlLabelClassName%>"><%=label%></label>',
      '<div class="<%=Backform.controlsClassName%>">',
      '  <% for (var i=0; i < options.length; i++) { %>',
      '    <% var option = options[i]; %>',
      '    <div class="radio">',
      '      <label>',
      '        <input type="<%=type%>" class="<%=extraClasses.join(\' \')%>" name="<%=name%>" value="<%-formatter.fromRaw(option.value)%>" <%=rawValue == option.value ? "checked=\'checked\'" : ""%> <%=disabled ? "disabled" : ""%> <%=required ? "required" : ""%> /> <%-option.label%>',
      '        <% if(option.helpText) { %>',
      '          <span class="<%=Backform.helpMessageClassName%> mv--none"><small><%=option.helpText%></small></span>',
      '        <% } %>',
      '      </label>',
      '    </div>',
      '  <% } %>',
      '  <% if (helpMessage && helpMessage.length) { %>',
      '    <span class="<%=Backform.helpMessageClassName%>"><%=helpMessage%></span>',
      '  <% } %>',
      '</div>'
    ].join('\n'))
  });
}).call(this);
;
(function() {
  window._amiliaIframeHelper = (function() {
    var _parentOrigin = '';
    var _domIsOk = false;

    function isIframe() {
      return window.self !== window.top;
    }

    function setDomIsOk() {
      _domIsOk = true;
    }

    function setParentOrigin(parentOrigin) {
      _parentOrigin = parentOrigin;
    }

    function getParentOrigin() {
      return _parentOrigin;
    }

    function isReadyToStart() {
      return _parentOrigin && _domIsOk;
    }

    function postMessageToParent(command, value) {
      if (!isIframe()) return false;

      var targetOrigin = getParentOrigin();
      if (!targetOrigin) return false;

      var commandValue = typeof value === 'undefined' ? null : value;

      window.parent.postMessage(JSON.stringify({
        amiliaCmd: command,
        value: commandValue
      }), targetOrigin);

      return true;
    }


    return {
      isIframe: isIframe,
      isReadyToStart: isReadyToStart,
      setDomIsOk: setDomIsOk,
      setParentOrigin: setParentOrigin,
      getParentOrigin: getParentOrigin,
      postMessageToParent: postMessageToParent,
    };
  }());

  window.AllowIFrameEmbed = function(iframeOptions) {
    if (!window._amiliaIframeHelper.isIframe()) return;

    document.body.classList.add('iframe-detected');

    var options = $.extend({
      header: '.layoutSecCtn.pgHd',
      footer: 'footer.footer-absolute',
      container: '.layoutSecCtn.pgBd'
    }, iframeOptions || {});

    if (!options.container) {
      throw new Error('Missing option container!');
    }

    var height;
    var lastCheck;
    var lastEvent;
    var checkHeightTimeout;
    var $container = $(options.container);

    /* DOM MANIPULATION */

    var hideFooter = function() {
      if (!options.footer) return;
      $(options.footer).hide();
    };

    var addPoweredBy = function(isStorageAccessFlow) {
      if (!window.AmiliaIframePoweredBy || !window.AmiliaIframePoweredByUrl || $container.length <= 0) return;

      $container.append([
        '<div class="logo-wrapper amilia ' + (isStorageAccessFlow ? 'text-center' : 'pull-right text-right') + '">',
        '  <a class="tagline" href="' + window.AmiliaIframePoweredByUrl + '" target="_blank">' + window.AmiliaIframePoweredBy + '</a>',
        '</div>'
      ].join('\n'));
    };

    var handleRegularFlow = function() {
      // Hide/Modify header, organization details and footer
      $('.pgHd').children('div').not('.optional-cart').remove();
      $('.js-admin-header').children().not('.js-optional-cart').remove();
      $('.pgHd.pgHd-1').css('background-color', 'none');
      $('.header-organization').css('display', 'none');

      // Hide powered by Amilia (because it shows up as undefined)
      $('.logo-wrapper').css('display', 'none');

      // Don't hide header if user links to organization info page (i.e. url without /shop)
      $('#orgPresentation').toggle($('#orgPresentationCt').length !== 0);
    };

    var handleStorageAccessFlow = function() {
      var iframeSrc = window.self.location;
      var $header = $(options.header);

      $('.pgCtn').addClass('storage-has-access-flow');

      $header.remove();

      var titleStyleByLanguage = window.AmiliaIframeCulture === 'en'
        ? 'width: 380px;'
        : 'width: 520px;';

      $container.html([
        '<div class="text-center">',
        '  <p id="storageAccessFlowTitle" style="font-size: 24.5px; line-height: 1.3em; margin: 0 auto 1.5rem auto; max-width: 90%; ' + titleStyleByLanguage + '">',
        '    ' + window.AmiliaIframeStorageAccessTitle,
        '  </p>',
        '  <button id="storageAccessFlowButton" class="btn btnSet3 btn-primary">',
        '    ' + window.AmiliaIframeStorageAccessClickHere,
        '  </button>',
        '</div>'
      ].join('\n'));

      var $storageAccessFlowButton = $('#storageAccessFlowButton');
      $storageAccessFlowButton.on('click', function(event) {
        event.preventDefault();
        $storageAccessFlowButton.attr('disabled', 'disabled');

        document.requestStorageAccess()
          .then(
            function requestStorageAccessGranted() {
              window.location.reload();
            },
            function requestStorageAccessDenied() {
              $storageAccessFlowButton.removeAttr('disabled');

              window.parent.location.href = iframeSrc;
            }
          );

        return false;
      });
    };

    var hasToHandleStorageAccessApi = function() {
      var browserImplementsStorageAccessApi = typeof document.requestStorageAccess === 'function'
        && typeof document.hasStorageAccess === 'function';

      if (!browserImplementsStorageAccessApi) return false;

      // We only target Safari since its Storage Access API implementation
      // may block our iFrame's cookies from being set
      // https://webkit.org/blog/8311/intelligent-tracking-prevention-2-0/
      var userAgent = window.navigator.userAgent;

      // The User Agent (UA) in Chrome for iOS is the same as the Mobile Safari user agent,
      // with CriOS/<ChromeRevision> instead of Version/<VersionNum>
      // https://developer.chrome.com/docs/multidevice/user-agent/#chrome-for-ios
      var isChromeInstance = userAgent.indexOf('Chrome') !== -1 || userAgent.indexOf('CriOS') !== -1;
      // The UA string for Firefox on iPadOS is not included in this, however.
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/User-Agent/Firefox#firefox_for_ios
      var isFirefoxInstance = userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('FxiOS') !== -1;
      var isSafari = userAgent.indexOf('Safari') !== -1 && !isChromeInstance && !isFirefoxInstance;

      return isSafari;
    };

    var start = function() {
      if (!window._amiliaIframeHelper.isReadyToStart()) return;

      window._amiliaIframeHelper.postMessageToParent('get_color'); // Will then run the command "render_color", then "show_iframe"
      window._amiliaIframeHelper.postMessageToParent('ready');
    }

    var applyDomModifications = function() {
      hideFooter();

      if (!hasToHandleStorageAccessApi()) {
        handleRegularFlow();
        addPoweredBy(false);
        window._amiliaIframeHelper.setDomIsOk();
        start();
        return;
      }

      // Handle Storage Access API
      document.hasStorageAccess()
        .then(function (hasAccess) {
          if (hasAccess) {
            handleRegularFlow();
          } else {
            handleStorageAccessFlow();
          }

          addPoweredBy(!hasAccess);
          window._amiliaIframeHelper.setDomIsOk();
          start();
        });
    };


    /* CUSTOM CSS */

    var renderCustomCSS = function(colorCode) {
      $('[name="iframe_css_override"]').remove();

      var overrideCSS = [
        '<style type="text/css" name="iframe_css_override">',
        ':root { --store-primary-color: ' + (colorCode === "null" /* yes, a string */ ? "#2B91E1" : colorCode) + '; }',
        'body',
        '{',
        '   background: transparent;',
        '}',
        '.storage-has-access-flow',
        '{',
        '   min-height: auto !important;',
        '}',
        '.storage-has-access-flow .pgBd',
        '{',
        '   padding-bottom: 50px !important;',
        '   padding-top: 50px !important;',
        '}',
        '.storage-has-access-flow .logo-wrapper.amilia',
        '{',
        '   display: block;',
        '   margin-top: 1.5rem;',
        '   width: auto;',
        '}',
        '.optional-cart, .toast-container.large',
        '{',
        '   top: 4px;',
        '}',
        '.pgHd.pgHd-1, .toast-container.large',
        '{',
        '   z-index: initial;',
        '   background: transparent;',
        '}',
        '@media (min-width: 767px) {',
        '  .modal',
        '  {',
        '    top: 100px;',
        '  }',
        '}',
        '@media (max-height: 700px) {',
        '  .modal',
        '  {',
        '    top: 20px;',
        '  }',
        '}',
        AMILIA_APP.overrideColorCss && AMILIA_APP.overrideColorCss(colorCode),
        '#theContainer',
        '{',
        '   max-width: none;',
        '   padding-right: 0;',
        '   padding-left: 0;',
        '}',
        '.store-notification-bar.admin-bar',
        '{',
        '   display: none;',
        '}',
        'div.logo-wrapper .tagline {font-weight: normal; font-size: 0.85em;  color: #666;}',
        'div.logo-wrapper .tagline:hover {color: #999;}',
        'div.logo-wrapper {display: inline-block; width: 62px;}',
        'div.logo-wrapper.amilia {width: 112px;}',
        'div.logo-wrapper.separator {padding: 0 8px; width: 2px;}',
        '</style>'
      ].join('\n');

      $('head').append(overrideCSS);
    };


    /* IFRAME COMMUNICATION */

    var runCommand = function(commandOptions) {
      var cmd = commandOptions.amiliaCmd;
      var value = commandOptions.value;

      switch (cmd) {
        case 'render_color':
          renderCustomCSS(value);
          window._amiliaIframeHelper.postMessageToParent('show_iframe');
          break;

        case 'checkout_only':
          $('.continue-shopping').hide();
          break;

        case 'top_url':
          $('.providerLink').attr('href', function() {
            return this.href + '&topLocation=' + value;
          });
          break;

        case 'self-diagnose':
          $('#iframe-diagnostics').show();
          break;

        case 'css':
          if (value.indexOf('https://') === 0) {
            var lnk = document.createElement('link');
            lnk.href = value;
            lnk.rel = 'stylesheet';
            lnk.type = 'text/css';
            (document.head || document.documentElement).appendChild(lnk);
          } else {
            var head = document.head || document.getElementsByTagName('head')[0];
            var style = document.createElement('style');
            style.type = 'text/css';
            if (style.styleSheet) {
              style.styleSheet.cssText = value;
            } else {
              style.appendChild(document.createTextNode(value));
            }
            head.appendChild(style);
          }
          break;

        default:
          throw new Error('Invalid cmd "' + cmd + '"');
      }
    };

    var setParentOrigin = function(currentOrigin, originToSet) {
      var isOriginAlreadySet = !!currentOrigin;
      if (isOriginAlreadySet) return;

      window._amiliaIframeHelper.setParentOrigin(originToSet);
      start();
    };

    var processMessage = function(processMessageEvent) {
      var JSONdata;

      try {
        JSONdata = JSON.parse(processMessageEvent.data);
      } catch (e) {
        JSONdata = {};
      }

      if (!JSONdata.amiliaCmd) return;

      var parentOrigin = window._amiliaIframeHelper.getParentOrigin();

      if (JSONdata.amiliaCmd === 'set_origin')
      {
        setParentOrigin(parentOrigin, JSONdata.value);
        return;
      }

      if (processMessageEvent.origin !== parentOrigin) return;

      runCommand(JSONdata, processMessageEvent);
    };


    /* HEIGHT MANAGEMENT */

    // Check if the height has changed and if so, tell the parent document
    // to resize the iframe to the proper height
    var checkHeight = function() {
      var now = new Date().getTime();
      var delay = lastEvent && now - lastEvent < 2000 ? 100 : 500;

      if (!lastCheck || now - lastCheck > delay) {
        var $shoppingCart = $('#cart-content');
        var newHeight = $shoppingCart.length && $shoppingCart.is(':visible') && $shoppingCart.outerHeight() > $container.outerHeight()
          ? $shoppingCart.outerHeight() + 50
          : $container.outerHeight();

        if (newHeight !== height) {
          if (window._amiliaIframeHelper.postMessageToParent('height', newHeight)) {
            height = newHeight;
          }
        }
      }

      lastCheck = now;
      checkHeightTimeout = setTimeout(checkHeight, delay);
    };

    var checkHeightOnEvent = function() {
      lastCheck = null;

      if (checkHeightTimeout) {
        clearTimeout(checkHeightTimeout);
      }

      checkHeightTimeout = setTimeout(checkHeight, 100);
      lastEvent = new Date().getTime();
    };

    var checkHeightAndSetCurrentUrl = function() {
      checkHeightOnEvent();
      window._amiliaIframeHelper.postMessageToParent('current_url', window.location.href);
    };


    /* SELF DIAGNOSTICS */

    function selfDiagnose() {
      var errors = [];
      var lang = $('html').attr('lang');
      var width = window.innerWidth;
      var isParentTop = window.parent === window.top;
      var isHttps = window.location.protocol.indexOf('https') === 0;

      if (!isHttps) {
        errors.push(lang === 'fr'
          ? 'La boutique n\'est pas sécurisée. Veuillez vous assurer que l\'attribut "src" du iframe Amilia a bel et bien "https" comme protocole.'
          : 'The store is not secured. Ensure the "src" attribute of the Amilia iframe uses the "https" protocol.');
      }

      if (width < 800) {
        errors.push(lang === 'fr'
          ? 'La boutique est trop étroite. Veuillez vous assurer que le iframe Amilia est 800 pixels de large ou plus.'
          : 'The store is too narrow. Please ensure the Amilia iframe is 800 pixels or larger.');
      }

      if (!isParentTop) {
        errors.push(lang === 'fr'
          ? 'Le iframe Amilia se trouve dans un autre iframe.'
          : 'The Amilia iframe is embedded inside another iframe.');
      }

      var $diagnostics = $('<div id="iframe-diagnostics" class="alert"></div>').hide();

      if (errors.length) {
        $diagnostics.addClass('alert-warning');

        for (var i = 0; i < errors.length; i++) {
          $diagnostics.append('<p><i class="fa fa-warning"></i> ' + errors[i] + '</p>');
        }
      } else {
        $diagnostics
          .addClass('alert-success')
          .append('<p><i class="fa fa-check"></i> ' +
            (lang === 'fr'
              ? 'Aucun problème détecté. Félicitations votre boutique est bien intégrée!'
              : 'No problems detected. Congrats your store is well integrated!') +
            '</p>')
          .append('<p>' +
            (lang === 'fr'
              ? 'Veuillez maintenant intégrer le "Code de production" pour cacher cette boîte de diagnostiques.'
              : 'Please now integrate the "Production code" to hide this diagnostics box.') +
            '</p>');
      }

      $('body').prepend($diagnostics);
    }


    /* LISTENERS & INIT */

    // Hide iframe while navigating
    // Prevents flickering from original CSS to modified CSS
    window.onbeforeunload = function() {
      window._amiliaIframeHelper.postMessageToParent('hide_iframe');
    };

    // Listen for messages from parent window
    if (window.addEventListener) {
      window.addEventListener('message', processMessage, false);
    } else {
      window.attachEvent('onmessage', processMessage);
    }

    $(document)
      .ready(checkHeightAndSetCurrentUrl)
      .click(checkHeightAndSetCurrentUrl);

    selfDiagnose();

    applyDomModifications();
  };
}).call(this);
;
(function() {
  'use strict';

  AMILIA_APP.notifyToast = function(message, options) {
    var $toast = $('<div></div>');
    var $symbol = $('<i></i>');
    var $message = $('<span>' + message + '</span>');
    var $messageContainer = $('<div></div>');
    var defaults = {
      symbolClasses: 'fa fa-check',
      wait: 2000,
      color: '#00bd44',
      top: '10px',
      large: false
    };

    options = $.extend({}, defaults, options);

    var removeByFade = function() {
      $(this).delay(options.wait).fadeOut(function() {
        $(this).remove();
      });
    };

    var removeBySlide = function() {
      $(this).delay(options.wait).animate({ width: 0, opacity: 0 }, {
        duration: 400,
        easing: 'swing',
        complete: function() {$(this).remove();}
      });
    };

    $toast.addClass('toast-container' + (options.large ? ' large' : '')).css('top', '70px');
    $symbol.addClass(options.symbolClasses);
    $messageContainer
      .append($symbol)
      .append('&nbsp;')
      .append($message)
      .addClass('toast-message').css('background-color', options.color).appendTo($toast);

    $toast.appendTo(document.body);

    $toast.delay(100).fadeIn(options.large ? removeBySlide : removeByFade);
  };

  AMILIA_APP.notifyToastError = function(message, options) {
    AMILIA_APP.notifyToast(message, _.extend({
      symbolClasses: 'fa fa-exclamation-triangle',
      color: '#de1316',
      wait: 3000,
      top: '40%'
    }, options || {}));
  };

}).call(this);
;
(function() {
  var self = AMILIA_APP.Store_ns;

  self.apiurl = {};

  /* eslint-disable key-spacing, no-undef */
  $.extend(true, self.apiurl, {
    base: '/store/' + culture + '/' + urlOrgName + '/',
    shop: '/store/' + culture + '/' + urlOrgName + '/shop/',
    api:  '/store/' + culture + '/' + urlOrgName + '/api/',
    apiV3: '/api/v3/' + culture + '/',
    checkout:  '/store/' + culture + '/' + urlOrgName + '/checkout/step/0',
    addPerson:                    function() { return this.api + 'Account/addPersonToAccount'; },
    getContactForCurrentAccount:  function() { return this.api + 'Account/GetContactForCurrentAccount'; },
    createCorporateAccount:       function() { return this.api + 'Account/CreateCorporateAccount'; },
    shopWithCorporateAccount:     function(userAccountId) { return this.api + 'Account/ShopWithUserAccount?userAccountId=' + userAccountId; },
    purchase:                     function() { return this.api + 'shoppingcart/CartItem/'; },
    purchaseMultiple:             function () { return this.api + 'shoppingcart/CartItems/'; },
    purchaseGiftCard:             function() { return this.api + 'shoppingcart/GiftCardCartItem'; },
    getCart:                      function() { return this.api + 'shoppingcart/Cart/'; },
    getCartActivityAndSegmentIds: function() { return this.api + 'shoppingcart/CartActivityAndSegmentIds/'; },
    emptyCart:                    function() { return this.api + 'shoppingcart/EmptyCart/'; },
    getCartSummary:               function() { return this.api + 'shoppingcart/GetCartSummary/'; },
    checkIfCartIsExpired:         function() { return this.api + 'shoppingcart/CheckIfCartIsExpired/'; },
    checkMandatoryMemberships:    function() { return this.api + 'membership/CheckIfPersonHasRequiredMembership/'; },
    checkMandatoryMultipass:      function() { return this.api + 'multipass/CheckIfPersonHasRequiredMultipass/'; },
    checkMembershipProducts:      function() { return this.api + 'membership/CheckIfMembershipHasRequiredProducts/'; },
    checkActivityProducts:        function() { return this.api + 'activity/CheckIfActivityHasRequiredProducts/'; },
    checkSegmentProducts:         function() { return this.api + 'segment/CheckIfSegmentHasRequiredProducts/'; },
    checkProductProducts:         function() { return this.api + 'catalog/CheckIfProductHasRequiredProducts/'; },
    sortProducts:                 function() { return this.api + 'catalog/GetProductsSorted/'; },
    fetchProducts:                function() { return this.api + 'catalog/FetchProducts/'; },
    registerProduct:              function() { return this.api + 'catalog/Register'; },
    registerSegment:              function() { return this.api + 'segment/Register'; },
    registerActivity:             function() { return this.api + 'activity/Register'; },
    activityContainsCommSegRegError: function() { return this.api + 'activity/ContainsCommunitySegmentRegistrationError'; },
    actSegContainsCommSegRegError:function() { return this.api + 'segment/ContainsCommunitySegmentRegistrationError'; },
    registerMembership:           function() { return this.api + 'membership/Register'; },
    registerMultipass:            function() { return this.api + 'multipass/Register'; },
    redeemMultipass:              function() { return this.api + 'multipass/RedeemTokenForDropIn'; },
    unregisterSpot:               function() { return this.api + 'segment/UnbookSpot'; },
    getMultiPassActivities:       function() { return this.api + 'multipass/EligibleActivities'; },
    getMultiPassPrivateLessons:   function() { return this.api + 'multipass/EligiblePrivateLessons'; },
    getMultiPaymentTable:         function() { return this.api + 'MultiPayment/GetPaymentsFor'; },
    getSubscriptionTable:         function() { return this.api + 'Subscription/GetOptionsFor'; },
    getInstallmentsTable:         function() { return this.api + 'Installments/GetOptionsFor'; },
    getInstallmentPaymentsTable:  function() { return this.api + 'Installments/GetOptionPayments'; },
    getInvoiceDetailView:         function() { return '/Clients/' + culture + '/' + urlOrgName + '/Invoice/'; },
    getActivitySync:              function() { return this.api + 'Activity/SyncActivitySearch'; },
    getDataPrivacyConsentRootUrl: function() { return this.base + 'Account/DataPrivacyConsent'; },
    getMembershipActivities:      function() { return this.api + 'membership/EligibleActivities'; },
    getCommunitySegmentPromos:    function(params) { return this.api + 'Promotion/GetResidentDiscount' + params; },
    getAddressDiscount:           function(params) { return this.api + 'Promotion/GetAddressDiscount' + params; },
    getIsAddressAResident:         function(params) { return this.api + 'CommunitySegment/IsAddressAResident' + params; },
    getIsGenuinePersonAResident:         function() { return this.api + 'CommunitySegment/IsGenuinePersonAResident'; }
  });
  /* eslint-enable */
}).call(this);
;
(function() {
  var self = AMILIA_APP.Store_ns,
    modalView = {};

  self.ui = {};

  var popoverOptions = {
    html: true,
    placement: function() {
      return this.$element.attr('data-popover-placement') || 'top';
    },
    trigger: 'manual',
    template: [
      '<div class="popover" role="tooltip">',
      '   <h3 class="popover-title"></h3>',
      '   <div class="popover-content"></div>',
      '</div>'
    ].join('\n'),
    title: function() {
      return $(this).attr('data-popover-title');
    },
    content: function() {
      return $(this).attr('data-popover-text');
    }
  };

  $.extend(true, self.ui, {

    listeners: {
      startListening: function() {
        $(function() {

          /**
           * Listenner on the error response of ajax request
           * if 401 - unauthorized, redirect loginUrl (set on the layout page)
           * if 307 - temp redirect, redirect to rewriteUrl (set by the server)
           */
          $.ajaxSetup({
            error: function(jqXHR) {
              switch (jqXHR.status) {
                case 401:
                  window.location = loginUrl + '?ReturnUrl=' + encodeURIComponent(location.href);
                  break;
                case 307:
                  // Quick register popups gracefully handle login/account creation - no need to redirect
                  window.location.reload();
                  break;
                default:
                  break;
              }
            }
          });

          if (hasCart && remainingTime) {
            self.ui.cart.launchCountdown(remainingTime, timeToRemind);
          }
        });

        $(document)
          .on('submit', '.search-membership-form', function(e) { e.preventDefault(); })
          .on('keyup', '.search-memberships', _.debounce(self._searchMemberships, 250))
          .on('change', '.membership-season-filter[name="season"]', self._searchMemberships)
          .on('change', '#membership-filter-container input[name="selectedTags"]', self._searchMemberships)
          .on('change', '#activity-filter-container input[name="selectedTags"]', self._clickSubmit)
          .on('change', '#activity-filter-container input[name="selectedLocations"]', self._clickSubmit)
          .on('click', '#activity-filter-container button[name="selectedAges"]', self._clickSubmit)
          .on('click', '#activity-filter-container button[name="selectedProgram"]', self._clickSubmit)
          .on('click', '#activity-filter-container button[name="selectedCategory"]', self._clickSubmit)
          .on('click', '#activity-filter-container button[name="selectedSubCategory"]', self._clickSubmit)
          .on('submit', '#searchActivity form', self._submitActivitySearchForm)
          .on('click', 'input.days-checkbox', self._clickSubmit)
          .on('click', '#selectAllDays', self._clickSubmit)
          .on('click', '#selectAllDays', self.ui.toggleAllDays)
          .on('click', '.selected-filter-close.ages-filter', self._removeSelectedAge)
          .on('click', '.selected-filter-close.tags-filter', self._removeSelectedFilter)
          .on('click', '.selected-filter-close.textCriteria-filter', self._removeTextCriteria)
          .on('click', '.selected-filter-close.clear-all-filter', self._clearAll)
          .on('click', '.selected-filter-close.locations-filter', self._removeSelectedFilter)
          .on('click', '.selected-filter-close.days-filter', self._removeSelectedFilter)
          .on('click', '.selected-filter-close.program-filter', self._removeSelectedProgram)
          .on('click', '.selected-filter-close.category-filter', self._removeSelectedCategory)
          .on('click', '.selected-filter-close.sub-category-filter', self._removeSelectedSubCategory)
          .on('click', 'input.days-checkbox', self.ui.toggleStateAllDay)
          .on('click', '.clearJS', self._clearContent)
          .on('click', '.removeFromCart', self._removeItemFromCart)
          .on('keydown', '.removeFromCart', self._removeItemFromCart)
          .on('click', '.decreaseQuantity ', self.ui.product.decreaseQuantity)
          .on('click', '.increaseQuantity ', self.ui.product.increaseQuantity)
          .on('click', '#merchandise-as-a-service input', self.ui.product.selectAMerchandiseAsAService)
          .on('click', '.legalConditionsControlJS', self._showLegalsConditions)
          .on('click', '.cart-section, .timer-section', self._toggleCartVisibility)
          .on('keydown', '.cart-section', self._toggleCartVisibility)
          .on('click', '#back-link', self.navigateBack)
          .on('click', 'a.membershipListItem, a#searchActivityLink', self.appendSpinner)
          .on('click', '.main-nav .nav-pill i.edit-module', self.moduleEditClick)
          .on('click', '#custom-message-toggle', self.toggleProgramCustomMessage)
          .on('click', '.multipass-eligible-activities', self.toggleMultiPassActivities)
          .on('keydown', '.multipass-eligible-activities', self.toggleMultiPassActivities)
          .on('click', '.membership-eligible-activities', self.toggleMembershipActivities)
          .on('click', '.multipass-eligible-private-lessons', self.toggleMultiPassPrivateLessons)
          .on('keydown', '.multipass-eligible-private-lessons', self.toggleMultiPassPrivateLessons)
          .on('submit', '.addPersonForm', self._addPersonToAccount)
          .on('submit', '.addPersonFormMini', self._addPersonToAccountQuick)
          .on('submit', '.multi-pass-form', self._registerWithMultiPass)
          .on('submit', '.addFamilyMultiPassToCartForm', { transType: 'multipass' }, self._addToCart)
          .on('submit', '.addFamilyMembershipToCartForm', { transType: 'membership' }, function(e) { self._addToCart(e, null, null, self.onFamilyMembershipAddedToCart)})
          .on('submit', '.formRegister-membership', { transType: 'membership' }, self._addToOrRemoveFromCart)
          .on('submit', '.formRegister-activity', { transType: 'membership' }, self._addToOrRemoveFromCart)
          .on('submit', '.addProductToCartForm', { transType: 'merchandise' }, self._addToCart)
          .on('submit', '.addDonationToCart', { transType: 'merchandise' }, self._addToCart)
          .on('change', '.productVariants', self.ui.product.changeProductVariant)
          .on('keypress', 'input#donationAmount', self.preventChars)
          .on('focusin focusout keyup', 'input#donationAmount', self.displayDonationAmount)
          .on('calendar:loaded', self.initializeCalendarEvents)
          .on('click', '.item-long-description', self._toggleDescription)
          .on('click', '.product-minus', self.ui.productRequiredOrSuggested.lowerQauntity)
          .on('click', '.product-add', self.ui.productRequiredOrSuggested.augmentQuantity)
          .on('click', '.change-variant', self.ui.productRequiredOrSuggested.changeVariant)
          .on('click', '.formAdd-reqProducts .toggle-payments-popover.installments', self.ui.productRequiredOrSuggested.productInstallmentPopover)
          .on('click', '.product-installment-option-label', self.ui.productRequiredOrSuggested.selectInstallmentOption)
          .on('click', '.add-suggested-products', self.ui.productRequiredOrSuggested.toggleSuggestedProduct)
          .on('change', '.membership-season-filter', self._onMembershipSeasonFilterChange)
          .on('change', '.select-payment-family-membership', self._toggleFamilyMembershipBuyButton)
          .on('change', '.select-payment-plan' , self._onInstallmentOptionSettingChange)
          .on('submit', '.prevent-form-submit', function() {
            return false;
          })
          // TODO: ActivitySearch to remove
          .on('click', '#activity-synch-search', self._synchActivitySearch)
          .ready(function() {
            $('.search-memberships').trigger('input');
          });
      }
    },

    misc: {
      validateForm: function($form) {
        if (typeof $form !== 'object' || $form.data('form-to-validate')) return false;
        var nbError = 0;

        $form.find('.input-ctn-js').removeClass('amilia-error');
        $form.find('input[value-required]').each(function(i, input) {
          if (!input.value) {
            $(input).parents('.input-ctn-js').addClass('amilia-error');
            nbError = i;
          }
        });
        return nbError;
      },

      fancybox: function(el) {
        $(el).fancybox();
      }
    },

    cart: {
      destroyCart: function(reload) {
        $('div.countdown-container').countdown('stop');
        $('div#cart-summary').remove();
        $.post(self.apiurl.emptyCart()).done(function() {
          if (reload) location.reload();
        });
      },

      launchCountdown: function(remainingTime, timeToRemind) {
        AMILIA.checkout = {};

        remainingTime = parseInt(remainingTime, 10);
        timeToRemind = parseInt(timeToRemind || 0, 10);

        $('div.countdown-container').countdown({
          time: remainingTime,
          template: $('div.countdown-container'),
          callback: this.countdownEnds,
          reminder: {
            duration: timeToRemind,
            callback: this.countdownEndsSoon
          }
        });
        $('div.countdown-container').show();
        if (timeToRemind && remainingTime <= timeToRemind) {
          $('div.countdown-container div.countdown').addClass('time-warning-animate');
        }
      },

      stopCountdown: function() {
        $('div.countdown-container').countdown('stop');
      },

      restartCountdown: function(time, timeToRemind) {
        this.stopCountdown();
        this.launchCountdown(time, timeToRemind);
      },

      countdownEnds: function() {
        var req = $.post(self.apiurl.checkIfCartIsExpired());

        req.success(function(resp) {
          if (resp.cartIsExpired) {
            $.post(self.apiurl.emptyCart());
            modalView = self.ui.modal
              .create({
                title: AMILIA_APP.Labels.expiredOrderTitle,
                body: AMILIA_APP.Labels.expiredOrderText,
                okButtonClose: true,
                cancelButtonHide: true,
                onHidden: function() {
                  location.reload(true);
                }
              })
              .render();
          } else {
            self.ui.cart.restartCountdown(Math.round(resp.timeRemaining, resp.timeToRemind));
          }
        });
      },

      countdownEndsSoon: function() {
        $('div.countdown-container div.countdown').addClass('time-warning-animate');
      }
    },

    product: {
      decreaseQuantity: function(e) {
        var $inputQuantity = $(e.currentTarget)
          .parents('div.chooseQuantity')
          .find('input.productQuantity'),
          quantity = parseInt($inputQuantity.val(), 10) || 1;

        if (quantity > 1) {
          quantity--;
          $inputQuantity.val(quantity);
        } else $inputQuantity.val(1);
      },

      increaseQuantity: function(e) {
        var $inputQuantity = $('input.productQuantity'),
          quantity = parseInt($inputQuantity.val(), 10),
          maxQuantity = parseInt($('input.maximumQuantity').val(), 10) || 0;

        if (quantity > 0) {
          quantity++;
          if (maxQuantity === 0 || quantity <= maxQuantity) {
            $inputQuantity.val(quantity);
          }
        } else $inputQuantity.val(1);
      },

      selectAMerchandiseAsAService: function(e) {
        var oneMerchandiseAtLeastChoosed = $('#merchandise-as-a-service input:checked').length > 0;

        if(oneMerchandiseAtLeastChoosed) {
            $('button#add-to-cart, button.quick-product-installments').removeClass('btn-disable').addClass('btn-primary').prop('disabled', false);
          } else {
            $('button#add-to-cart, button.quick-product-installments').removeClass('btn-primary').addClass('btn-disable').prop('disabled', true);
        }
      },

      changeProductVariant: function(e) {
        var $opt = $('option:selected', e.currentTarget),
          $inputQuantity = $('input.productQuantity'),
          maxQuantity = parseInt($opt.data('quantity'), 10) || 0,
          inventoryStatus = $opt.data('inventory-status'),
          $inventoryStatusText = $('span#inventory-status'),
          validateQty = $opt.data('validate-qty');

        $('input.maximumQuantity').val(maxQuantity);

        if (validateQty == 'true' && $inputQuantity.val() > maxQuantity) $inputQuantity.val(maxQuantity);

        $inventoryStatusText.removeClass()
          .addClass('status-product ' + inventoryStatus)
          .text($opt.data('availability'))
          .attr('itemtype', 'https://schema.org/' + $opt.data('meta-url'));

        if (inventoryStatus == 'available') {
          $('button#add-to-cart, button.quick-product-installments').removeClass('btn-disable').addClass('btn-primary').prop('disabled', false);
        } else {
          $('button#add-to-cart, button.quick-product-installments').removeClass('btn-primary').addClass('btn-disable').prop('disabled', true);
        }
      }
    },
    productRequiredOrSuggested: {
      lowerQauntity: function(e) {
        var $btn = $(e.currentTarget);
        var dataId = $btn.data('id');

        var $inputQuantity = $('input.product-quantity[data-id="' + dataId + '"]'),
          quantity = parseInt($inputQuantity.val(), 10) || 1;

        if (quantity > 1) {
          quantity--;
          $inputQuantity.val(quantity);
        } else $inputQuantity.val(1);
      },

      augmentQuantity: function(e) {
        var $btn = $(e.currentTarget);
        var dataId = $btn.data('id');

        var $inputQuantity = $('input.product-quantity[data-id="' + dataId + '"]'),
          quantity = parseInt($inputQuantity.val(), 10),
          maxQuantity = parseInt($inputQuantity.data('available'), 10) || 0;

        if (quantity > 0) {
          quantity++;
          if (maxQuantity === 0 || quantity <= maxQuantity) {
            $inputQuantity.val(quantity);
          }
        } else $inputQuantity.val(1);
      },

      changeVariant: function(e) {
        var $btn = $(e.currentTarget);
        var dataId = $btn.data('id');
        var $opt = $('option:selected', e.currentTarget),
          $inputQuantity = $('input.product-quantity[data-id="' + dataId + '"]'),
          maxQuantity = parseInt($opt.data('available'), 10) || 0,
          available = parseInt($inputQuantity.data('available'), 10) || 0,
          choice = parseInt($inputQuantity.val(), 10) || 0;

        $inputQuantity.data('available', maxQuantity);

        if (choice > maxQuantity && maxQuantity != 0) {
          $inputQuantity.val(maxQuantity);
        }
      },
      toggleSuggestedProduct: function(e) {
        e.preventDefault();
        var $button = $(e.target);
        var $lineDiv = $button.closest('.required-line-item');
        var $input = $lineDiv.find('.switch-checkbox');
        var $personIdInput = $lineDiv.find('.suggested-product-person-id');

        if ($input.is(':checked')) {
          $input.prop('checked', false);
          $personIdInput.prop('value', null);
          $button.text(AMILIA_APP.Labels.Add).removeClass('btn-default').addClass('btn-primary');
          $lineDiv.find('.installment-option-container').hide();
        } else {
          $input.prop('checked', true);
          $personIdInput.prop('value', AMILIA_APP.Store_ns.currentPersonIdForSuggProduct);
          $button.text(AMILIA_APP.Labels.RemoveItem).removeClass('btn-primary').addClass('btn-default');
          $lineDiv.find('.installment-option-container').show();
        }
        self.ui.productRequiredOrSuggested.validateAndToggleOkButton(e);
      },
      selectInstallmentOption: function(e) {
        var selectedInstallmentOptionId = $(this).data('option-id');
        $(this).closest('.installment-option-container').find('input[name="Options.SelectedInstallmentOptionId"]').val(selectedInstallmentOptionId);
        $(this).closest('.installment-option-container').find('i').removeClass('fa-check').addClass('fa-user-plus').closest('button').removeClass('selected').addClass('unselected');
        $(this).find('i').removeClass('fa-user-plus').addClass('fa-check').closest('button').removeClass('unselected').addClass('selected');
        $(this).closest('.installment-option-container').find('.installment-option-not-selected-warning').hide();
        self.ui.productRequiredOrSuggested.validateAndToggleOkButton(e);
      },
      validateAndToggleOkButton: function(e) {
        var installmentDivs = $('.installment-option-choice');
        var disableOkButton = false;
        $.each(installmentDivs, function(index, elem) {
          var isMandatory = $(elem).data('is-mandatory') === 'True';
          var hasSelectedValue = $(elem).find('input[name="Options.SelectedInstallmentOptionId"]').val() !== '';
          var isSuggestedAndSelected = $(elem).closest('.required-line-item').find('.switch-checkbox').is(':checked');
          if ((isMandatory || isSuggestedAndSelected) && !hasSelectedValue) {
            disableOkButton = true;
          }
        });
        $(e.currentTarget).closest('.modal').find('button.ok').prop('disabled', disableOkButton);
      },
      productInstallmentPopover: function(e) {
        e.stopPropagation();
        $(e.currentTarget).popover(_.extend({}, popoverOptions, {
          content: function() {
            if (!this.cache) {
              this.cache = self._loadRemoteInstallmentsPopover(self.apiurl.getInstallmentPaymentsTable(),
                'installment-content-' + $(this).attr('data-id'),
                { id: $(this).attr('data-id'), amount: $(this).attr('data-amount') },
                this,
                '');
            }
            return this.cache;
          }
        })).click(self.ui.popHandler);
        $(e.currentTarget).click();
      }
    },

    modal: {
      changeModalToCorrectBootstrapVersion: function() {
        var modalReactTemplate = [
          '<div class="modal-dialog" role="document">',
          '  <div class="modal-content">',
          '    <div class="modal-header">',
          '      <%=title%>',
          '      <button type="button" class="close" data-dismiss="modal">',
          '        <span aria-hidden="true">&times;</span>',
          '      </button>',
          '    </div>',
          '    <div class="modal-body"><%=body%></div>',
          '    <div class="modal-footer"></div>',
          '  </div>',
          '</div>'
        ].join('\n');

        var modalBS2 = [
          '<div class="modal-header">',
          '  <button type="button" class="close">×</button>',
          '  <%=title%>',
          '</div>',
          '<div class="modal-body"><%=body%></div>',
          '<div class="modal-footer"></div>'
        ].join('\n');

        Backbone.ModalView.prototype.template = _.template(AMILIA_APP.isReact ? modalReactTemplate : modalBS2);
        Backbone.ModalView.prototype.className = AMILIA_APP.isReact ? 'modal' : 'modal backbone-modal modal-set-1';
      },

      render: function() {
        this.render();
        return this;
      },

      create: function(args) {
        args = args || {};
        var href = args.anchor || document.URL,
          okButtonClose = args.okButtonClose || false,
          cancelButtonHide = args.cancelButtonHide || false,
          customButtonTemplate = args.customButtonTemplate || Backbone.ModalView.prototype.buttonTemplate;

        var buttons = args.buttons || [{
            label: AMILIA_APP.Labels.cancel,
            className: 'cancel btnSet3 btn-special ' + (cancelButtonHide ? 'hidden d-none' : ''),
            close: true,
            href: href
          }, {
            label: AMILIA_APP.Labels.continueOn,
            className: 'ok btnSet3 btn-primary',
            close: okButtonClose,
            href: href
          }];

        if (typeof modalView.close === 'function') modalView.close();

        modalView = Backbone.ModalView.extend({
          title: '<h3 class="modal-title">' + args.title + '</h3>',
          body: args.body,
          backdrop: typeof args.backdrop === 'undefined' ? true : args.backdrop,
          buttonTemplate: customButtonTemplate,
          buttons: buttons,
          events: {
            'click .modal-footer .ok': 'onOk',
            'click .modal-footer .secondary': 'onSecondary',
            'click .modal-footer .cancel': 'onCancel',
            'hidden': 'onHidden',
          },
          postRender: function() {
            this.$el.hide().fadeIn('fast');
            this.$el.find('input:first').trigger('focus') ;
            if (typeof args.onPostRender === 'function') args.onPostRender();
          },
          close: function(e) {
            if (e) e.preventDefault();
            var view = this;
            view.$el.fadeOut('fast', function() {
              view.$el.modal('hide');
              view.remove();
            });
          },
          onOk: function(e) { if (typeof args.onOk === 'function') args.onOk(e); },
          onSecondary: function(e) { if (typeof args.onSecondary === 'function') args.onSecondary(e); },
          onCancel: function(e) { if (typeof args.onCancel === 'function') args.onCancel(e); },
          onHidden: function(e) {
             if (e.target === this.$el[0] && typeof args.onHidden === 'function') args.onHidden();
          }
        });

        return new modalView();
      }
    },

    waitingIndicator: {
      identifier: '.amilia-ajax-loader-js',
      classNames: 'fa fa-spinner fa-spin amilia-ajax-loader amilia-ajax-loader-js',

      prependToItem: function($el) {
        var ajaxLoader = $('<i class="' + this.classNames + '"></i>');
        if ($el.find(this.identifier).length > 0) return false;
        $el.prepend(ajaxLoader[0]);
      },

      kill: function($el) {
        $el.find(this.identifier).remove();
      },

      killAll: function() {
        $(this.identifier).each(function(i, $item) {
          if ($item.remove !== undefined) $item.remove();
        });
      }
    },

    toggleStateAllDay: function(e) {
      var $this = $(e.currentTarget),
        $form = $this.closest('form'),
        $allDayBox = $form.find('#selectAllDays'),
        nbInputChecked = $form.find('input.days-checkbox:checked').length;

      switch (nbInputChecked) {
        case 0:
          $allDayBox.prop('checked', false);
          $allDayBox.prop('indeterminate', false);
          break;

        case 7:
          $allDayBox.prop('checked', true);
          $allDayBox.prop('indeterminate', false);
          break;

        default:
          $allDayBox.prop('indeterminate', true);
          break;
      }
    },

    toggleAllDays: function (e) {
      var $this = $(e.currentTarget),
        $form = $this.closest('form'),
        state = $this.prop('checked');

      $form.find('input.days-checkbox').not(':disabled').prop('checked', state);
      self._clickSubmit();
    },

    bindBirthdayPicker: function() {
      $('div.add-person-form').find('.birthday-date')
        .birthdaypicker({
          lang: culture,
          name: 'person.dateofbirth',
          size: { year: 'span4', month: 'span4', day: 'span4' }
        });
    },

    popHandler: function(e) {
      e.stopPropagation();

      var alreadyOpen = $('body').attr('data-popover-id'),
        $curtarget = $(e.currentTarget);

      if (alreadyOpen !== undefined && alreadyOpen !== $curtarget.attr('id')) $('#' + alreadyOpen).popover('hide');
      $curtarget.popover('toggle');

      var $popover = $curtarget.data('popover').$tip;
      $popover.toggleClass('show');
      if (!$curtarget.hasClass('toggle-price-popover') && !$curtarget.hasClass('activity-segment')) {
        $popover.find('.arrow').css('top', $popover.height() / 2);
      }
    }
  });

}).call(this);
;
window.AMILIA_APP = window.AMILIA_APP || {};
AMILIA_APP.modules = AMILIA_APP.modules || {};

AMILIA_APP.modules.addressForm = AMILIA_APP.modules.addressForm || (function($) {
  var defaultOptions = {
    autoInit: true,
    onPlaceChanged: null,
    onInitSuccess: null
  };

  function loadGoogleMapsApiIfNeeded(apiKey, callback) {
    var script;
    var scriptSrc = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&signed_in=true&libraries=geometry,places';

    if ((typeof google === 'undefined' || typeof google.maps === 'undefined') && !$('script[src="' + scriptSrc + '"]').length) {
      script = document.createElement('script');
      script.onload = callback;
      script.setAttribute('async', 'true');
      script.setAttribute('defer', 'true');
      script.src = scriptSrc;
      document.head.appendChild(script);
    } else {
      callback();
    }
  }

  function sendCallInfoToElastic(addressFound) {
    var addressData = {
      Address: addressFound.address1,
      City: addressFound.city,
      PostalCode: addressFound.postalCode,
      Country: addressFound.country,
      StateProv: addressFound.stateProv
    };

    if (AMILIA_APP.urlSyncApiCallToElastic) {
      $.post(AMILIA_APP.urlSyncApiCallToElastic, addressData);
    }
  }
  function getFoundAddress(place) {
    var addressComponents = place.address_components;
    var geometry = place.geometry;

    var addressFound = { // default empty
      address1: '',
      city: '',
      postalCode: '',
      country: '',
      stateProv: ''
    };

    var streetNumber = addressComponents.filter(function(x) { return x.types.indexOf('street_number') >= 0; });
    streetNumber = streetNumber.length >= 1 ? streetNumber : [{ long_name: "" }];
    var route = addressComponents.filter(function(x) { return x.types.indexOf('route') >= 0; });
    if (streetNumber.length >= 1 && route.length >= 1) {
      addressFound.address1 = streetNumber[0].long_name + ' ' + route[0].long_name;
    }

    var city = addressComponents.filter(function(x) { return x.types.indexOf('locality') >= 0; });
    var neighborhood = addressComponents.filter(function(x) { return x.types.indexOf('neighborhood') >= 0; });
    var sublocality = addressComponents.filter(function(x) { return x.types.indexOf('sublocality') >= 0; });
    if (city.length >= 1) {
      addressFound.city = city[0].long_name;
    } else if (neighborhood.length >= 1) {
      addressFound.city = neighborhood[0].long_name;
    } else if (sublocality.length >= 1) {
      addressFound.city = sublocality[0].long_name;
    }

    var postalCode = addressComponents.filter(function(x) { return x.types.indexOf('postal_code') >= 0; });
    if (postalCode.length >= 1) { addressFound.postalCode = postalCode[0].long_name; }

    var country = addressComponents.filter(function(x) { return x.types.indexOf('country') >= 0; });
    if (country.length >= 1) { addressFound.country = country[0].short_name; }

    var stateProv = addressComponents.filter(function(x) { return x.types.indexOf('administrative_area_level_1') >= 0; });
    if (stateProv.length >= 1) { addressFound.stateProv = stateProv[0].short_name; }

    if (geometry && geometry.location) {
      addressFound.latitude = geometry.location.lat();
      addressFound.longitude = geometry.location.lng();
    }

    return addressFound;
  }

  function addressIsComplete (address) {
    if (address) {
      return address.address1 !== '' && address.city !== '' && address.postalCode !== '' && address.country !== '' && address.stateProv !== '';
    }
    return false;
  }

  function getTimeSpentInSec (startTime) {
    var endTime = Math.round((new Date()).getTime() / 1000);
    return endTime - startTime;
  }

  function applyAutoCompleteHack() {
    var self = this;
    var autoCompleteAttribute = 'googleautocomplete';

    // hack - begin -- https://stackoverflow.com/a/49161445
    var observerHack = new MutationObserver(function() {
      observerHack.disconnect();
      self.$autoComplete.attr('autocomplete', autoCompleteAttribute);
    });
    observerHack.observe(this.addressAutocomplete, {
      attributes: true,
      attributeFilter: ['autocomplete']
    });
    // hack - end
  }

  function getGenuinePersonId (addressSectionContainer) {
    var parentForm = addressSectionContainer.closest('form');
    var genuinePersonId = parentForm.attr('data-gp');
    if (!genuinePersonId) {
      genuinePersonId = $('#Person_GenuinePersonId', parentForm).val();
    }

    if (!genuinePersonId) {
      genuinePersonId = 0;
    }

    return genuinePersonId;
  }

  function getHasSpecifiedSin (addressSectionContainer) {
    var formWrapper = addressSectionContainer.closest('.form-wrapper');
    var refuseSinCheckbox = $('.refuse-to-give-sin', formWrapper);
    if (refuseSinCheckbox.length === 1) {
      return !refuseSinCheckbox.prop('checked');
    }
    return false;
  }

  function AddressAutocomplete(addressSectionContainer, options) {
    this.options = $.extend({}, defaultOptions, options);

    this.sendTrackingStatsToElastic = function() {
      this.tracking.timeSpentInSec = getTimeSpentInSec(this.startTime);
      this.tracking.hasSpecifiedSin = getHasSpecifiedSin(this.$addressSectionContainer);
      this.tracking.currentDeviceInnerWidth = window.innerWidth;

      var genuinePersonId = getGenuinePersonId(this.$addressSectionContainer);

      var params = {
        id: genuinePersonId,
        orgId: AMILIA_APP.orgId
      };

      if (AMILIA_APP.urlAddressValidationTracking) {
        $.ajax({
          type: 'POST',
          data: this.tracking,
          url: AMILIA_APP.urlAddressValidationTracking + '?' + $.param(params)
        });
      }
    };

    this.fillAddressWithPlace = function(place) {
      this.$addressDetailsFields.removeClass('hide');
      this.$addressFields.address2.val('');
      if (place && place.address_components) {
        var addressFound = getFoundAddress(place);
        if (addressFound != null) {
          this.$addressFields.address1.val(addressFound.address1);
          this.$addressFields.city.val(addressFound.city);
          this.$addressFields.postalCode.val(addressFound.postalCode);
          this.$addressFields.country.val(addressFound.country).trigger('change'); // To update the state/province dropdown
          this.$addressFields.stateProv.val(addressFound.stateProv);
          this.$addressFields.stateProvHidden.val(addressFound.stateProv);
          this.$addressFields.latitude.val(addressFound.latitude);
          this.$addressFields.longitude.val(addressFound.longitude);

          if (addressIsComplete(addressFound)) { // found and complete
            this.$addressValidCheck.prop('checked', true);
          }

          sendCallInfoToElastic(addressFound);
        }
      } else { // nothing found, set address1 field only
        this.$addressFields.address1.val(place.name);
        this.$addressFields.city.val('');
        this.$addressFields.postalCode.val('');
        this.$addressFields.country.val('').trigger('change');
        this.$addressFields.stateProvHidden.val('');
      }
    };

    this.fillAddress = function() {
      if (this.options.autoInit) {
        this.$cantFindYourAddress.hide();
      }
      var place = this.autocomplete.getPlace();
      if (typeof this.options.onPlaceChanged === 'function') {
        var addressFound;
        if (place && place.address_components) {
          addressFound = getFoundAddress(place);
        }
        this.options.onPlaceChanged(addressFound);
      } else {
        this.fillAddressWithPlace(place);
      }
    };

    this.geolocate = function() {
      var self = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          });
          self.autocomplete.setBounds(circle.getBounds());
        });
      }
    };

    this.bindHasValidAddressCheck = function () {
      var self = this;
      this.$addressValidCheck.change(function() {
        if (self.$addressValidCheck.prop('checked')) {
          self.tracking.autocompleteDetails.tookHappyPath = false;
        }
        $('.can-skip-form.ignore', self.$addressDetailsFields).removeClass('ignore').attr('data-val', 'true');
      });
    };

    this.bindCantFindYourAddressLink = function () {
      var self = this;
      this.$cantFindYourAddress.click(function() {
        self.$cantFindYourAddress.hide();
        self.$addressDetailsFields.removeClass('hide');
        self.tracking.autocompleteDetails.couldNotFindAddress = true;
      });
    };

    this.bindEditAddressLink = function() {
      var self = this;
      var readonly = $('.address-readonly-section', this.$addressSectionContainer);
      var edit = $('.address-section', this.$addressSectionContainer);
      $('.edit-address-link', this.$addressSectionContainer).click(function () {
        readonly.toggleClass('hide');
        edit.toggleClass('hide');
        self.$cantFindYourAddress.hide();

        // focus the first field for a11y
        var $personSearchAddress = edit.find('#person-search-address');
        if ($personSearchAddress.length === 1) {
          $personSearchAddress.focus();
        } else {
          edit.find('input.address-line').first().focus();
        }
      });
    };

    this.bindLinksEvents = function() {
      this.bindEditAddressLink();
      this.bindCantFindYourAddressLink();
      this.bindHasValidAddressCheck();
    };

    this.bindAddressFieldEditingEvents = function(addressSection) {
      var self = this;
      addressSection.find('.autocompleted-field').on('keyup change', function() {
        $('.can-skip-form.ignore', self.$addressDetailsFields).removeClass('ignore').attr('data-val', 'true');
        self.$addressValidCheck.prop('checked', false);
        self.tracking.autocompleteDetails.editedAfterAutoComplete = true;
      });
    };

    this.postApiLoad = function() {
      var self = this;

      this.addressAutocomplete = this.$autoComplete.first()[0];
      if (this.addressAutocomplete) {
        applyAutoCompleteHack.call(this);

        var autoCompleteOptions = {
          componentRestrictions: {
            country: ['ca', 'us']
          }
        };
        if (window.google && google.maps.places) {
          this.autocomplete = new google.maps.places.Autocomplete(this.addressAutocomplete, autoCompleteOptions);
          this.autocomplete.setFields(['address_components', 'geometry']); // So that getPlace only ask for basic data
          google.maps.event.addDomListener(this.addressAutocomplete, 'focus', function () {
            self.geolocate();
          });
          this.autocomplete.addListener('place_changed', function () {
            $.post(AMILIA_APP.googleApi.urlPlacesDetails, { area: AMILIA_APP.area, rewriteUrl: AMILIA_APP.rewriteUrl });

            self.fillAddress();
          });
          this.$autoComplete.addClass('initialized');
        }

        if (this.options.autoInit) {
          // set jquery variables
          var $addressSection = $('.address-section', this.$addressSectionContainer);
          this.$cantFindYourAddress = $addressSection.find('.cant-find-address');
          this.$addressFields = {
            address1: $addressSection.find('input[name="Person.Address.Address1"]'),
            address2: $addressSection.find('input[name="Person.Address.Address2"]'),
            city: $addressSection.find('input[name="Person.Address.City"]'),
            postalCode: $addressSection.find('input[name="Person.Address.PostalCode"]'),
            country: $addressSection.find('select[name="Person.Address.Country"]'),
            stateProv: $addressSection.find('.stateprov-select'),
            stateProvHidden: $addressSection.find('input[name="Person.Address.SubDivision"]'),
            latitude: $addressSection.find('input[name="Person.Address.Latitude"]'),
            longitude: $addressSection.find('input[name="Person.Address.Longitude"]')
          };

          // In fr value is with ',' and this cause a validation error so we need to change it for a '.'
          if (this.$addressFields.latitude.val() && this.$addressFields.longitude.val()) {
            this.$addressFields.latitude.val(this.$addressFields.latitude.val().replace(',', '.'));
            this.$addressFields.longitude.val(this.$addressFields.longitude.val().replace(',', '.'));
          }

          this.$addressDetailsFields = $addressSection.find('.address-details-fields');
          this.$addressValidCheck = $addressSection.find('input[name$="AddressValidation.HasValidAddress"]');

          this.bindAddressFieldEditingEvents($addressSection);
        }
      }

      if (this.options.autoInit) {
        this.bindLinksEvents();
      }

      if (typeof this.options.onInitSuccess === 'function') {
        this.options.onInitSuccess(this.$autoComplete);
      }
    };

    this.getGlobalFields = function (globalFieldsName) {
      if (globalFieldsName) {
        if (globalFieldsName === 'addressFields') { return this.$addressFields; }
        if (globalFieldsName === 'addressDetailsFields') { return this.$addressDetailsFields; }
        if (globalFieldsName === 'addressValidCheck') { return this.$addressValidCheck; }
      }
      return undefined;
    };

    this.initAutoComplete = function () {
      var self = this;
      if (this.$addressSectionContainer.length === 1) {
        this.$autoComplete = $('.address-autocomplete', this.$addressSectionContainer);
        if (this.$autoComplete.length === 1) {
          this.tracking.autoCompleteEnabled = true;
          loadGoogleMapsApiIfNeeded(AMILIA_APP.googleBrowserApiKey, function () {
            self.postApiLoad();
          });
        }
      }
    };

    this.init = function() {
      this.$addressSectionContainer = $(addressSectionContainer);
      this.tracking = {
        hasQuit: false, // on unload
        autoCompleteEnabled: false,
        autocompleteDetails: {
          tookHappyPath: true,
          couldNotFindAddress: false,
          editedAfterAutoComplete: false
        },
        hasSpecifiedSin: false,
        timeSpentInSec: 0
      };

      this.startTime = Math.round((new Date()).getTime() / 1000);
      this.initAutoComplete();
    };

    this.init();
  }

  AddressAutocomplete.prototype.addressIsComplete = addressIsComplete;
  AddressAutocomplete.prototype.getFoundAddress = getFoundAddress;

  return {
    AddressAutocomplete: AddressAutocomplete,
    loadGoogleMapsApiIfNeeded: loadGoogleMapsApiIfNeeded
  };
}(jQuery));
;
window.AMILIA_APP = window.AMILIA_APP || {};

AMILIA_APP.a11y = AMILIA_APP.a11y || (function($) {
  var focusableQueryString = 'button:visible:not([disabled]), a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"])';
  var KEYBOARD_EVENT_CODES = {
    SPACE: 32,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    ESC: 27
  };

  function focusFirstElement($modalContainer) {
    $modalContainer.find('button:not(.close):visible, a:visible, input:visible, select:visible, textarea:visible, [tabindex]:not([tabindex="-1"])').first().trigger('focus');
  }

  function trapFocusInsideModal($modalContainer) {
    $modalContainer.on('keydown', function(e) {
      if (!e || !e.currentTarget) return;

      var $dialog = $(e.currentTarget);
      // accessibility - trap the focus into the modal
      // TAB key moves focus
      var TAB_KEY = KEYBOARD_EVENT_CODES.TAB;

      if (e.keyCode !== TAB_KEY)  return;

      var currentFocusedElement = $dialog.find(':focus');
      var firstFocusableElement = $dialog.find(focusableQueryString).first();
      var lastFocusableElement = $dialog.find(focusableQueryString).last();

      if (e.shiftKey) {
        if (currentFocusedElement.is(firstFocusableElement)) {
          e.preventDefault();
          lastFocusableElement.trigger('focus');
        }
        return;
      }

      if (currentFocusedElement.is(lastFocusableElement)) {
        e.preventDefault();
        firstFocusableElement.trigger('focus');
      }

    });
  }

  function focusFirstElementAndTrapFocus($modalContainer) {
    focusFirstElement($modalContainer);
    trapFocusInsideModal($modalContainer);
  }

  return {
    focusFirstElementAndTrapFocus: focusFirstElementAndTrapFocus,
    focusFirstElement: focusFirstElement,
    trapFocusInsideModal: trapFocusInsideModal,
    KEYBOARD_EVENT_CODES: KEYBOARD_EVENT_CODES
  };
}(jQuery));
;

(function($, Store, Labels, accounting) {
  'use strict';

  function isPlaceComplete(place) {
    return place && place.address1 && place.city && place.postalCode && place.country && (place.stateProv || place.subDivision);
  }

  function getCheckQueryParameters(id, type) {
    var typeToParamName = {
      membership: 'membershipId',
      activity: 'activityId',
      segment: 'dropInId',
      multipass: 'multipassId',
      merchandise: 'productId'
    };

    var idParamName = typeToParamName[type];
    if (!idParamName || !id) {
      // Correct values not found.
      return '';
    }

    return '?' + idParamName + '=' + id;
  }

  function getPossibleResidentDiscount(settings) {
    var queryParameters = getCheckQueryParameters(settings.id, settings.type);
    var getDiscountUrl = Store.apiurl.getCommunitySegmentPromos(queryParameters);

    // If we have an id and valid query params, send a request to find the discount.
    var getDiscountRequest = settings.id && queryParameters
      ? $.ajax({ url: getDiscountUrl })
      : $.when(); // Will return an empty promise.

    return (
      getDiscountRequest.then(
        function(discount) {
          return discount || null;
        },
        function () {
          return null;
        }
      ));
  }

  function getAddressDiscount(currentPlace, settings) {
    var queryParameters = getCheckQueryParameters(settings.id, settings.type);
    var getAddressDiscountUrl = Store.apiurl.getAddressDiscount(queryParameters);

    var addressDiscountResult = {
      discount: null,
      isError: false
    };

    var discountRequest = $.ajax({
      url: getAddressDiscountUrl,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        address1: currentPlace.address1,
        city: currentPlace.city,
        postalCode: currentPlace.postalCode,
        country: currentPlace.country,
        subdivision: currentPlace.subDivision,
        longitude: currentPlace.longitude || null,
        latitude: currentPlace.latitude || null
      })
    }).then(
      function (addressDiscount) {
        if (addressDiscount && addressDiscount > 0) {
          addressDiscountResult.discount = addressDiscount;
        }

        return addressDiscountResult;
      },
      function () {
        // Error result.
        addressDiscountResult.error = true;
        return addressDiscountResult;
      }
    );

    return discountRequest;
  }

  function isAddressInCommunitySegment(currentPlace, settings) {
    var queryParameters = getCheckQueryParameters(settings.id, settings.type);
    var isAddressAResidenttUrl = Store.apiurl.getIsAddressAResident(queryParameters);

    $.ajax({
      url: isAddressAResidenttUrl,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        address1: currentPlace.address1,
        city: currentPlace.city,
        postalCode: currentPlace.postalCode,
        country: currentPlace.country,
        subdivision: currentPlace.subDivision,
        longitude: currentPlace.longitude || null,
        latitude: currentPlace.latitude || null
      }),
      success: function (data) {
        settings.callback(data ? true : false);
      },
      error: function () {
        settings.callback(false);
      }
    });
  }

  function constructPromoModalOptions(target, settings) {
    var currentPlace = {};

    var eligibleForPromoPrompt = settings.discount
      ? Labels.MayBeEligibleForDiscountWithValue.replace('{0}', accounting.formatMoney(settings.discount))
      : Labels.MayBeEligibleForDiscount;

    var successModalOptions = {
      title: Labels.ConfirmYourAddress,
      body: [
        '<div>',
        '  <form id="formPromoResident" action="' + AMILIA_APP.GetSetGenuineValidAddressUrl + '" method="post">',
        '    <div class="mb--less">' + eligibleForPromoPrompt + '</div>',
        '    <div>' + Labels.EnterYourAddressToCheckIfEligible + '</div>',
        '    <div class="form-group address-container mt--less">',
        '      <label class="w-100">' + Labels.Address,
        '        <input type="text" autocomplete="confirmYourAddress" class="form-control address-autocomplete resident-address-autocomplete" placeholder="' + Labels.EnterYourAddressHere + '" />',
        '        <span id="promoAddressError" class="amilia-error-ctn" style="display:none">' + Labels.AnAddressIsRequired + '</span>',
        '      </label>',
        '      <div class="residency-address-2" hidden>',
        '        <label>' + Labels.AddressLine2,
        '         <input type="text" class="form-control resident-address-autocomplete" placeHolder="' + Labels.AddressLine2Placeholder + '" id="addressLine2" maxlength="20" />',
        '        </label>',
        '      </div>',
        '    </div>',
        '    <div id="addressInASegmentStatus"></div>',
        '    <div id="addressVerificationNote"></div>',
        '    <input type="hidden" name="id" val="' + (settings.genuinePersonId || 0) + '"/>',
        '    <input type="hidden" name="orgId" val="' + (AMILIA_APP.orgId || 0) + '"/>',
        '    <input type="hidden" id="promoResidentAddress1" name="address1" val=""/>',
        '    <input type="hidden" id="promoResidentCity" name="city" val=""/>',
        '    <input type="hidden" id="promoResidentPostalCode" name="postalCode" val=""/>',
        '    <input type="hidden" id="promoResidentCountry" name="country" val=""/>',
        '    <input type="hidden" id="promoResidentStateProv" name="subDivision" val=""/>',
        '  </form>',
        '</div>'].join(''),
      buttons: [{
        label: Labels.Skip,
        className: 'btn-special btn-store-resident-cancel',
        close: true
      }, {
        label: Labels.Save,
        className: 'btn-primary secondary resident-save-button',
        close: false
      }],
      onHidden: function() {
        $('.modal-backdrop').show();
        $('.quick-registration-modal').show();
        settings.callback(target);
      },
      onSecondary: function() {
        var addressError = $('#promoAddressError').hide();
        var address2 = $('#addressLine2').val();
        if (!_.isEmpty(address2)) {
          currentPlace.address2 = address2;
        }

        if (isPlaceComplete(currentPlace)) {
          $.ajax({
            url: AMILIA_APP.GetSetGenuineValidAddressUrl + '?id=' + settings.genuinePersonId + '&orgId=' + AMILIA_APP.orgId,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(currentPlace),
            complete: function() {
              $('.btn-store-resident-cancel').trigger('click');
            }
          });
        } else {
          addressError.show();
        }
      },
      onPostRender: function() {
        var saveButton = $('.resident-save-button');
        var addressFields = $('.address-autocomplete');
        var addressTwoFields = $('.residency-address-2');
        var addressInASegmentStatus = $('#addressInASegmentStatus');
        var addressVerificationNote = $('#addressVerificationNote');

        saveButton.addClass('disabled').prop('disabled', true);
        addressFields.on('blur', function() {
          if (!addressFields.val()) {
            addressTwoFields.hide();
            addressInASegmentStatus.hide();
            addressVerificationNote.hide();
          }
        });

        // Attach auto-complete to address field (using a side effect in a constructor).
        var storeResidentAutoComplete = new AMILIA_APP.modules.addressForm.AddressAutocomplete($('.address-container'), {
          onPlaceChanged: function(place) {
            if (place) {
              if (!saveButton.hasClass('disabled')) {
                saveButton.addClass('disabled').prop('disabled', true);
              }
              addressTwoFields.show();

              currentPlace = {
                address1: place.address1,
                city: place.city,
                postalCode: place.postalCode,
                country: place.country,
                subDivision: place.stateProv,
                longitude: place.longitude || null,
                latitude: place.latitude || null
              };

              $('#promoResidentAddress1').val(place.address1);
              $('#promoResidentCity').val(place.city);
              $('#promoResidentPostalCode').val(place.postalCode);
              $('#promoResidentCountry').val(place.country);
              $('#promoResidentStateProv').val(place.stateProv);

              if (isPlaceComplete(place)) {
                getAddressDiscount(currentPlace, settings).always(function (result) {
                  addressInASegmentStatus.show();
                  addressVerificationNote.show();
                  if (result.error) {
                    $('#addressInASegmentStatus').text(Labels.AddressEligibleError);
                  } else if (result.discount > 0) {
                    var eligibleForDiscountMessage = Labels.AddressEligibleForDiscount.replace('{0}', accounting.formatMoney(result.discount));
                    $('#addressInASegmentStatus').html(eligibleForDiscountMessage);
                    $('#addressVerificationNote').text(Labels.VerifiedAddressNote);
                  } else {
                    $('#addressInASegmentStatus').text(Labels.AddressNotEligibleForDiscount);
                  }

                  saveButton.removeClass('disabled').prop('disabled', false);
                });
              }
            }

            if (!place || !isPlaceComplete(place)) {
              addressTwoFields.hide();
              addressInASegmentStatus.hide();
              addressVerificationNote.hide();
            }
          },
          onInitSuccess: function (elem) {
            if (elem) {
              elem.keydown(function(e) {
                if (e.which === 13) {
                  e.preventDefault();
                }
              });
            }
          }
        });
      }
    };

    return successModalOptions;
  }

  function constructModalOptions(target, settings) {
    var success = false;
    var currentPlace = {};
    var successModalOptions = {
      title: Labels.ConfirmYourAddress,
      body: [
        '<div>',
        '  <form id="formPromoResident" action="' + AMILIA_APP.GetSetGenuineValidAddressUrl + '" method="post">',
        '    <div>' + Labels.EnterYourAddressToCheckIfEligible + '</div>',
        '    <div class="form-group address-container mt--less">',
        '      <label class="w-100">' + Labels.Address,
        '        <input type="text" autocomplete="confirmYourAddress" class="form-control address-autocomplete resident-address-autocomplete" placeholder="' + Labels.EnterYourAddressHere + '" />',
        '        <span id="promoAddressError" class="amilia-error-ctn" style="display:none">' + Labels.AnAddressIsRequired + '</span>',
        '      </label>',
        '      <div class="residency-address-2" hidden>',
        '        <label>' + Labels.AddressLine2,
        '         <input type="text" class="form-control resident-address-autocomplete" placeHolder="' + Labels.AddressLine2Placeholder + '" id="addressLine2" maxlength="20" />',
        '        </label>',
        '      </div>',
        '    </div>',
        '    <div id="addressInASegmentStatus"></div>',
        '    <div id="addressVerificationNote"></div>',
        '    <input type="hidden" name="id" val="' + (settings.genuinePersonId || 0) + '"/>',
        '    <input type="hidden" name="orgId" val="' + (AMILIA_APP.orgId || 0) + '"/>',
        '    <input type="hidden" id="promoResidentAddress1" name="address1" val=""/>',
        '    <input type="hidden" id="promoResidentCity" name="city" val=""/>',
        '    <input type="hidden" id="promoResidentPostalCode" name="postalCode" val=""/>',
        '    <input type="hidden" id="promoResidentCountry" name="country" val=""/>',
        '    <input type="hidden" id="promoResidentStateProv" name="subDivision" val=""/>',
        '  </form>',
        '</div>'].join(''),
      buttons: [{
        label: Labels.Skip,
        className: 'btn-special btn-store-resident-cancel',
        close: true
      }, {
        label: Labels.Save,
        className: 'btn-primary secondary resident-save-button',
        close: false
      }],
      onHidden: function() {
        $('.modal-backdrop').show();
        $('.quick-registration-modal').show();

        if (success) {
          settings.success(target);
        } else {
          settings.error(target);
        }
      },
      onSecondary: function() {
        var addressError = $('#promoAddressError').hide();
        var address2 = $('#addressLine2').val();
        if (!_.isEmpty(address2)) {
          currentPlace.address2 = address2;
        }

        if (isPlaceComplete(currentPlace)) {
          $.ajax({
            url: AMILIA_APP.GetSetGenuineValidAddressUrl + '?id=' + settings.genuinePersonId + '&orgId=' + AMILIA_APP.orgId,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify(currentPlace),
            complete: function() {
              $('.btn-store-resident-cancel').trigger('click');
            }
          });
        } else {
          addressError.show();
        }
      },
      onPostRender: function() {
        var saveButton = $('.resident-save-button');
        var addressFields = $('.address-autocomplete');
        var addressTwoFields = $('.residency-address-2');

        saveButton.addClass('disabled').prop('disabled', true);
        addressFields.on('blur', function() {
          if (!addressFields.val()) {
            addressTwoFields.hide();
          }
        });

        // Attach auto-complete to address field (using a side effect in a constructor).
        var storeResidentAutoComplete = new AMILIA_APP.modules.addressForm.AddressAutocomplete($('.address-container'), {
          onPlaceChanged: function(place) {
            if (place) {
              if (!saveButton.hasClass('disabled')) {
                saveButton.addClass('disabled').prop('disabled', true);
              }
              addressTwoFields.show();

              currentPlace = {
                address1: place.address1,
                city: place.city,
                postalCode: place.postalCode,
                country: place.country,
                subDivision: place.stateProv,
                longitude: place.longitude || null,
                latitude: place.latitude || null
              };

              $('#promoResidentAddress1').val(place.address1);
              $('#promoResidentCity').val(place.city);
              $('#promoResidentPostalCode').val(place.postalCode);
              $('#promoResidentCountry').val(place.country);
              $('#promoResidentStateProv').val(place.stateProv);

              if (isPlaceComplete(place)) {
                var currentSettings = {
                  id: settings.id,
                  type: settings.type,
                  callback: function (result) {
                    if (result) {
                      success = true;
                    }
                  }
                };
                if (settings.skipIsAddressAResidentCheck) {
                  success = true;
                } else {
                  isAddressInCommunitySegment(currentPlace, currentSettings);
                }
                saveButton.removeClass('disabled').prop('disabled', false);
              }
            }

            if (!place || !isPlaceComplete(place)) {
              addressTwoFields.hide();
            }
          },
          onInitSuccess: function (elem) {
            if (elem) {
              elem.keydown(function(e) {
                if (e.which === 13) {
                  e.preventDefault();
                }
              });
            }
          }
        });
      }
    };

    return successModalOptions;
  }

  AMILIA_APP.StoreResident = AMILIA_APP.StoreResident || {};
  var self = AMILIA_APP.StoreResident;

  self.config = {
    residenciesClass: 'Residencies'
  };

  self.hasResidenciesPromo = function (id, addRemovePersonBtn) {
    var modalBody = addRemovePersonBtn.closest('.modal-body');
    if (modalBody.length === 1 && modalBody.hasClass(self.config.residenciesClass)) {
      return true;
    }

    if (id) {
      var classes = self.getRegisterVisiblePromoClasses($('#' + id));
      return classes.indexOf(self.config.residenciesClass) >= 0;
    }
    return false;
  };

  self.handleResidenciesCheck = function (event, options) {
    var settings = options || {};
    if (typeof settings.success !== 'function') { settings.success = function() {}; }
    if (typeof settings.error !== 'function') { settings.error = function() {}; }
    if (!settings.genuinePersonId) { settings.genuinePersonId = 0; }

    var target = event.currentTarget;
    $.ajax({
      url: AMILIA_APP.GetGenuineHasValidAddressUrl,
      data: { id: settings.genuinePersonId, orgId: AMILIA_APP.orgId }
    }).then(
      function (hasValidAddress) {
        if (!hasValidAddress) {
          self.openEnterYourAddressModal(target, {
            success: settings.success,
            error: settings.error,
            genuinePersonId: settings.genuinePersonId,
            id: options.id,
            type: options.type,
            skipIsAddressAResidentCheck: options.skipIsAddressAResidentCheck
          });
        } else {
          var queryParameters = getCheckQueryParameters(options.id, options.type);
          $.ajax({
            url: Store.apiurl.getIsGenuinePersonAResident() + queryParameters + '&genuinePersonId=' + settings.genuinePersonId,
            success: function (result) {
              if (result) {
                settings.success(target);
              } else {
                settings.error(target);
              }
            },
            error: function () {
              settings.error(target);
            }
          });
        }
      },
      function () {
        settings.error(target);
      }
    );
  };

  self.handleResidenciesCheckForPromo = function (event, options) {
    var settings = options || {};
    if (typeof settings.done !== 'function') { settings.done = function() {}; }
    if (!settings.genuinePersonId) { settings.genuinePersonId = 0; }

    var target = event.currentTarget;
    $.ajax({
      url: AMILIA_APP.GetGenuineHasValidAddressUrl,
      data: { id: settings.genuinePersonId, orgId: AMILIA_APP.orgId }
    }).then(
      function (hasValidAddress) {
        if (!hasValidAddress) {
          self.openEnterYourAddressPromoModal(target, {
            callback: settings.done,
            genuinePersonId: settings.genuinePersonId,
            id: options.id,
            type: options.type
          });
        } else {
          settings.done(target);
        }
      },
      function () {
        settings.done(target);
      }
    );
  };

  self.getRegisterVisiblePromoClasses = function(registerButton) {
    var promoBtn = [];
    var modalBodyClasses = [];
    var $registerButton = $(registerButton);

    var registerGroup = $registerButton.closest('.register-group');
    if (registerGroup.length > 0) {
      promoBtn = registerGroup.find('.show-promo-btn');
    } else {
      promoBtn = $('.show-promo-btn');
    }

    // for dropIns calendar
    var dropInsCalendar = $registerButton.closest('.calendar-container');
    if (dropInsCalendar.length === 1) {
      if (dropInsCalendar.hasClass('drop-in-residencies-promo')) {
        modalBodyClasses.push('Residencies');
      }
    }

    if (promoBtn.length === 1) {
      var classes = promoBtn.attr('class').split(' ');
      $.each(classes, function(i, elem) {
        var trimmedElem = elem.trim();
        if (trimmedElem !== '' && trimmedElem !== 'show-promo-btn' && trimmedElem.indexOf('popover') < 0) {
          modalBodyClasses.push(trimmedElem);
        }
      });
    }
    return modalBodyClasses;
  };

  self.merchandise = {
    hasResidencyPromo: function ($form) {
      var dataProductPromotions = $form.data('product-promotions');
      if (dataProductPromotions) {
        var productPromotions = dataProductPromotions.split(' ');
        return productPromotions.indexOf('Residencies') >= 0;
      }
      return false;
    },
    getSelectedPerson: function ($form) {
      var $productPersonSelect = $('#product-person', $form);
      return $productPersonSelect.find(':selected');
    },
    getSelectedGenuinePersonId: function ($form) {
      return this.getSelectedPerson($form).data('gp-id');
    },
    getMerchandiseId: function () {
      // A better way to do this would be _great_
      var pathname = window.location.pathname;

      // For merch the id should be the last path segment.
      var pathSegments = pathname.split('/');
      var lastSegment = pathSegments[pathSegments.length - 1];

      if (lastSegment && !Number.isNaN(lastSegment)) {
        return lastSegment;
      }

      return null;
    },
    selectedPersonHasAddressValidated: function($form) {
      return this.getSelectedPerson($form).data('address-is-validated');
    },
    shouldShowAddressValidationModal: function ($form) {
      return this.hasResidencyPromo($form) && !this.selectedPersonHasAddressValidated($form);
    }
  };

  self.addClassesToSelectParticipantsModalBody = function (modalBody, modalBodyClasses) {
    $.each(modalBodyClasses, function(i, className) {
      modalBody.addClass(className);
    });
  };

  self.openEnterYourAddressModal = function(target, options) {
    $('.quick-registration-modal').hide();
    $('.modal-backdrop').hide();

    var settings = options || {};

    if (typeof settings.success !== 'function') { settings.success = function() {}; }
    if (typeof settings.error !== 'function') { settings.error = function() {}; }

    var successModalOptions = constructModalOptions(
      target,
      {
        id: settings.id,
        type: settings.type,
        genuinePersonId: settings.genuinePersonId,
        success: settings.success,
        error: settings.error,
        skipIsAddressAResidentCheck: settings.skipIsAddressAResidentCheck
      }
    );

    Store.ui.modal.create(successModalOptions).render();
  };

  self.openEnterYourAddressPromoModal = function(target, options) {
    $('.quick-registration-modal').hide();
    $('.modal-backdrop').hide();

    var settings = options || {};

    if (typeof settings.callback !== 'function') {
      settings.callback = function() {};
    }

    getPossibleResidentDiscount(settings).always(function (discount) {
      var successModalOptions = constructPromoModalOptions(
        target,
        {
          id: settings.id,
          type: settings.type,
          discount: discount,
          genuinePersonId: settings.genuinePersonId,
          callback: settings.callback
        }
      );

      Store.ui.modal.create(successModalOptions).render();
    });
  };
}(jQuery, AMILIA_APP.Store_ns, AMILIA_APP.Labels, window.accounting));
;
(function() {
  'use strict';

  /* eslint-disable no-underscore-dangle,no-param-reassign */
  var self = AMILIA_APP.Store_ns;

  var isIFrame = window.self !== window.top;

  function setUpAccount(callBackInsteadOfReloadingThePage) {
    $.get(AMILIA_APP.ReinitializeUserContextUrl)
      .done(function(hasToSetupAccount) {
        if (hasToSetupAccount) {
          $.get('/UserAccountPersons/' + AMILIA_APP.lang + '/ShouldUserConfirmEmail').done(function(needsToConfirm) {
            if (needsToConfirm) {
              var EmailNotConfirmedModal = Backbone.ModalView.extend({
                events: _.extend({}, Backbone.ModalView.prototype.events, {
                  'click .btn.continue': 'onResend'
                }),
                onResend: function() {
                  window.location = AMILIA_APP.EmailConfirmationUrl;
                }
              });

              new EmailNotConfirmedModal({
                title: '<h4>' + AMILIA_APP.Labels.YourEmailIsNotConfirmed + '</h4>',
                body: '<p style="font-size: 14px">' + AMILIA_APP.Labels.EmailNotConfirmedDetailedMessage + '</p>',
                buttons: [{
                  className: 'cancel',
                  label: AMILIA_APP.Labels.Close,
                  close: true
                }, {
                  className: 'continue btn-primary',
                  label: AMILIA_APP.Labels.ResendYourConfirmation
                }]
              }).render();
            } else {
              $.get('/UserAccountPersons/' + AMILIA_APP.lang + '/GetAdults').done(function(adults) {
                if (adults.length) {
                  new Backbone.SelectPersonAccountFormModal({
                    model: new Backbone.Model({ Adults: adults })
                  })
                    .on('close', onQuickRegisterModalClose)
                    .on('close:add-person:modal', onQuickRegisterModalClose)
                    .render();
                } else {
                  new Backbone.PersonAccountFormModal({ model: new Backbone.PersonAccountModel() })
                    .on('close', onQuickRegisterModalClose)
                    .render();
                }
              });
            }
          });
        } else if (callBackInsteadOfReloadingThePage) {
          callBackInsteadOfReloadingThePage();
        } else {
          window.location.reload();
        }
      });
  }

  function scrollToTop() {
    if (!window._amiliaIframeHelper || !window._amiliaIframeHelper.isIframe()) return;

    window._amiliaIframeHelper.postMessageToParent('scroll_iframe_top');
  }

  function updateQueryString(query) {
    var queryString = $.param(query);
    if (queryString.length) queryString = '?' + queryString;
    var uri = window.location.pathname + queryString;
    window.history.replaceState(undefined, undefined, uri);
  }

  function updateQueryStringWithArray(query) {
    var queryString = $.param(query, true);
    if (queryString.length) queryString = '?' + queryString;
    var uri = window.location.pathname + queryString;
    window.history.replaceState(undefined, undefined, uri);
  }

  // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript#answer-21152762
  function parseParamsAsArrays() {
    var qd = {};
    window.location.search.substr(1).split('&').forEach(function(item) {
      if (item !== '') {
        var s = item.split('=');
        var k = s[0];
        var v = s[1] && decodeURIComponent(s[1]);

        (k in qd) ? qd[k].push(v) : qd[k] = [v];
      }
    });
    return qd;
  }

  function updateQuickRegisterIdInQueryString(value) {
    if (typeof window.history.pushState !== 'undefined') {
      var query = $.parseParams(window.location.href);
      if (value === undefined) {
        delete query.quickRegisterId;
      } else {
        query.quickRegisterId = value;
      }
      updateQueryString(query);
    }
  }

  function deleteNewPersonIdInQueryString() {
    if (typeof window.history.pushState !== 'undefined') {
      var query = $.parseParams(window.location.href);
      delete query.newPersonId;
      updateQueryString(query);
    }
  }

  function onQuickRegisterModalClose() {
    $('#calendar').fullCalendar('refetchEvents');
    updateQuickRegisterIdInQueryString(undefined);
  }

  function closeOpenedModals() {
    $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
  }

  function returnToQuickRegistration() {
    $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
    $('#' + window.selectedModalId).trigger('click');
    try {
      delete window.selectedModalId;
    } catch (e) {
      window.selectedModalId = undefined;
    }
  }

  // Popovers
  var popoverOptions = {
    html: true,
    placement: function() {
      var isBelowHalfway = this.$element[0].getBoundingClientRect().top > (window.innerHeight / 2);
      return this.$element.attr('data-popover-placement') || (isBelowHalfway ? 'top' : 'bottom');
    },
    trigger: 'manual',
    template: [
      '<div class="popover" role="tooltip">',
      '   <h3 class="popover-title"></h3>',
      '   <div class="popover-content"></div>',
      '</div>'
    ].join('\n'),
    title: function() {
      return $(this).attr('data-popover-title');
    },
    content: function() {
      return $(this).attr('data-popover-text');
    }
  };

  $.extend(true, self, {

    mobileWidth: 767,

    init: function() {
      this.ui.listeners.startListening();
      this.ui.modal.changeModalToCorrectBootstrapVersion();
    },

    modalCallbackMessage: function(message, alertType) {
      message = message || AMILIA_APP.Labels.CartUpdated;
      alertType = alertType || 'success';
      return [
        '<div class="alert alert-' + alertType + ' alert-dismissible fade in" role="alert">',
        message,
        '</div>'
      ].join('\n');
    },

    renderAuthenticationModal: function() {
      new Backbone.AuthenticationModalView({
        url: AMILIA_APP.LoginUrl + '?ReturnUrl=' + encodeURIComponent(window.location.href)
      })
        .on('close', function() {
          updateQuickRegisterIdInQueryString(undefined);
        })
        .render();
    },

    checksBeforeRenderingRegistrationModal: function(e, extras) {
      if (e && e.type === 'keydown' && e.keyCode !== 13) return;

      extras = extras || {};
      var originalData = e.data;

      updateQuickRegisterIdInQueryString($(this).attr('id'));

      if (!AMILIA_APP.isLoggedIn) {
        if (!AMILIA_APP.allowsOnlineRegistrations) {
          new Backbone.OnlineTransactionsNotAvailableModalView().render();
          updateQuickRegisterIdInQueryString(undefined);
          scrollToTop();
          return;
        }

        self.renderAuthenticationModal();
        scrollToTop();
        return;
      }

      if (AMILIA_APP.hasToSetupAccount) {
        if (!AMILIA_APP.allowsOnlineRegistrations) {
          new Backbone.OnlineTransactionsNotAvailableModalView().render();
          updateQuickRegisterIdInQueryString(undefined);
          scrollToTop();
          return;
        }

        setUpAccount();
        scrollToTop();
        return;
      }

      // legacy code
      var $button = this;

      if (AMILIA_APP.HasDataPrivacyConsent) {
        self.renderRegistrationModal.apply($button, [e, extras]);
      } else {
        var model = new Backbone.Model({
          HasConsentDataPrivacy: false
        });

        var dataPrivacyConsentModalView = new Backbone.DataPrivacyConsentModalView({
          model: model,
          onContinue: function(dataPrivacyContinueEvent) {
            dataPrivacyContinueEvent.preventDefault();

            if (!this.model.get('HasConsentDataPrivacy')) {
              dataPrivacyConsentModalView.$footer.find('.continue .fa-spinner').remove();
              return false;
            }
            $.ajax({ url: self.apiurl.getDataPrivacyConsentRootUrl(), type: 'PUT', data: { HasDataPrivacyConsent: true } })
              .done(function() {
                e.data = originalData;
                AMILIA_APP.HasDataPrivacyConsent = true;
                dataPrivacyConsentModalView.close();
                self.renderRegistrationModal.apply($button, [e, extras]);
              })
              .fail(function() {
                self.displayErrorModal(AMILIA_APP.Labels.GenericUserError);
                scrollToTop();
              });
            return false;
          }
        })
          .on('modal:close:withoutConsent', function() { updateQuickRegisterIdInQueryString(undefined); })
          .render();
        scrollToTop();
      }
    },

    renderRegistrationModal: function(e, extras) {
      var id = $(this).attr('id');
      var type = e.data && e.data.type || null;

      var islinkedtomonthlysubscription = $(this).data('monthly-subscription-price-list') > 0;
      var postTypes = {
        segment: {
          registerUrl: self.apiurl.registerSegment(),
          containsCommSegRegErrorUrl: self.apiurl.actSegContainsCommSegRegError(),
          data: { id: id },
          title: AMILIA_APP.Labels.SelectParticipantsToRegister
        },
        activity: {
          registerUrl: self.apiurl.registerActivity(),
          containsCommSegRegErrorUrl: self.apiurl.activityContainsCommSegRegError(),
          data: { activityId: id },
          title: AMILIA_APP.Labels.SelectParticipantsToRegister
        },
        membership: {
          registerUrl: self.apiurl.registerMembership(),
          data: { id: id },
          title: AMILIA_APP.Labels.SelectNewMembers
        },
        multipass: {
          registerUrl: self.apiurl.registerMultipass(),
          data: { id: id },
          title: AMILIA_APP.Labels.SelectMultiPassUser
        },
        subscription: {
          registerUrl: self.apiurl.registerActivity(),
          containsCommSegRegErrorUrl: self.apiurl.activityContainsCommSegRegError(),
          data: { activityId: id },
          title: AMILIA_APP.Labels.SelectParticipantsToRegister
        },
        product: {
          registerUrl: self.apiurl.registerProduct(),
          data: {
            id: id, quantity: $('#product-quantity').val(), selectedPersonId: $('#product-person').val(), variantId: $('#Options_VariantId').val()
          },
          title: AMILIA_APP.Labels.SelectPaymentOptionForProduct
        }
      };
      var options = {
        title: postTypes[e.data.type].title,
        body: '<div style="text-align: center;"><i class="fa fa-3x fa-spinner fa-spin" style="color: #2B91E1;"></i></div>',
        buttons: [{
          label: AMILIA_APP.Labels.continueShopping,
          className: 'cancel btn-outline-secondary',
          close: true
        }, {
          label: AMILIA_APP.Labels.Checkout,
          className: 'ok btn-primary',
          close: false
        }],
        customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
        onHidden: onQuickRegisterModalClose
      };
      var $quickRegModal = self.ui.modal.create(options);

      scrollToTop();

      function getRegistrationModalContent(registerUrl, registerBody, currentTarget) {
        $quickRegModal.render();
        $.post(registerUrl, registerBody, function(resp) {
          if (!_.isUndefined(resp.OrgHasChanged) && resp.OrgHasChanged) {
            // Add item to cart unless it is from another organization
            self._orgChangeControl(resp);
            return;
          }

          var setCheckoutStatus = function() {
            var $okButton = $quickRegModal.$footer.find('button.ok');
            var cartQty = $('.number-content').text();
            $okButton.prop('disabled', !cartQty);
            // Hide the checkout button when not inside the registration period and empty cart
            if ($quickRegModal.$body.find('.registration-not-available').length === 1 && !cartQty) {
              $quickRegModal.$header.find('.modal-title').text(AMILIA_APP.Labels.CannotRegister);
              $okButton.hide();
            }
          };

          var updateQuantity = function() {
            var cartQty = $('.number-content').text();
            var cartInfo = $('.mini-cart-info');

            $quickRegModal.$body.animate({ scrollTop: 0 }, 'fast');
            cartInfo[cartQty ? 'slideDown' : 'slideUp']('fast').find('.count').html(cartQty);
            setCheckoutStatus();
          };
          var updateMessage = function(event, data) {
            data = data || {};
            $quickRegModal.$body.find('.quick-registration-message')
              .html(self.modalCallbackMessage(data.message, data.alertType))
              .find('.alert')
              .fadeTo(3500, 500)
              .slideUp('fast', function() { $(this).alert('close'); });
            updateQuantity();
          };

          // Set and fill modal with registrants
          $quickRegModal.$el.addClass('quick-registration-modal');
          $quickRegModal.$body.html(resp);

          // accessibility - setup aria-label & focus
          var modalTitle = $quickRegModal.$header.find('.modal-title').text();
          $quickRegModal.$el.attr('aria-label', modalTitle);
          // need to focus first element again because we injected html in the modal
          AMILIA_APP.a11y.focusFirstElement($quickRegModal.$body);

          if (AMILIA_APP.StoreResident && currentTarget && currentTarget.classList
              && (currentTarget.classList.contains('register-compact-btn')
                  || currentTarget.classList.contains('quick-multipass')
                  || currentTarget.classList.contains('quick-membership')
                  || (currentTarget.classList.contains('activity-segment') && currentTarget.classList.contains('can-register'))
              )
          ) {
            var modalBodyClasses = AMILIA_APP.StoreResident.getRegisterVisiblePromoClasses(currentTarget);
            AMILIA_APP.StoreResident.addClassesToSelectParticipantsModalBody($quickRegModal.$body, modalBodyClasses);
          }

          if (islinkedtomonthlysubscription) {
            $('#monthly-subscription-price').hide();
          }
          // Bail out if online transactions are just not available for this org
          if ($quickRegModal.$body.find('#online-transactions-not-available').length > 0) {
            $quickRegModal.close();
            return new Backbone.OnlineTransactionsNotAvailableModalView().render();
          }

          // Begin registration chain for clicking a user's plus button
          $quickRegModal.$body.on('click', 'button.compact-submit', { type: type, id: id }, self._quickAddOrRemoveBox);

          $quickRegModal.$body.on('click', 'a.restriction-goto-your-account', function() {
            $quickRegModal.close();
          });

          // Show user's multipass options, if they have any
          $quickRegModal.$body.on('click', 'button.expand', function() {
            var $button = $(this);
            var icon = $button.find('i');

            icon.hasClass('fa-plus')
              ? icon.removeClass('fa-plus').addClass('fa-minus')
              : icon.removeClass('fa-minus').addClass('fa-plus');
            $button.closest('.person-form-row').find('.pass-container').slideToggle('fast');
          });

          $quickRegModal.$body.find('.toggle-payments-popover.installments').popover(_.extend({}, popoverOptions, {
            content: function() {
              if (!this.cache) {
                this.cache = self._loadRemoteInstallmentsPopover(
                  self.apiurl.getInstallmentPaymentsTable(),
                  'multipayment-content-' + $(this).attr('data-id'),
                  { id: $(this).attr('data-id'), amount: $(this).attr('data-amount') },
                  this,
                  'installments-popover'
                );
              }
              return this.cache;
            }
          })).click(self.ui.popHandler);

          // Show already-in-cart options if inside an expandable well
          $quickRegModal.$body
            .find('button.compact-submit.in-cart')
            .closest('div.person-form-row')
            .find('button.expand')
            .click();

          // Allow user to unregister themselves if they have already used a multi-pass
          $quickRegModal.$body.on('click', 'button.unregister-multipass', self._unregisterDropIn);

          // Immediately go to checkout step 1 if user clicks mini-cart or checkout button
          function goToCheckout() {
            self.ui.waitingIndicator.prependToItem($(this));
            window.location.href = $('a.checkout-link').attr('href');
          }
          $quickRegModal.$body.on('click', '.mini-cart-info', goToCheckout);
          $quickRegModal.$footer.on('click', 'button.ok', goToCheckout);

          // Switch to the add-person modal
          $quickRegModal.$body.on('click', 'button.add-a-person, span.add-a-person', {
            id: $quickRegModal.$body.find('[name="itemId"]').val()
          }, self.renderAddPersonModal);

          $quickRegModal.$body.on('click', 'a.modify-age-gender', {
            id: $quickRegModal.$body.find('[name="itemId"]').val()
          }, self.renderModifyPersonModal);

          // Listen for response messages to display to user after actions complete
          $quickRegModal.$body.on('update:message', updateMessage);

          // Enable tooltips for registrant messages
          $quickRegModal.$body
            .find('span[data-toggle]')
            .tooltip()
            .on('hidden', function(event) {
              event.stopPropagation();
            });

          // Register new person if user just added them
          var query = $.parseParams(window.location.href);

          if (query.newPersonId) {
            deleteNewPersonIdInQueryString();
            var $expandButton = $('button[id="person_' + query.newPersonId + '_checkbox_expand"]');
            if ($expandButton) {
              $expandButton.click();
            }
          }

          $quickRegModal.$body
            .find('#create-a-new-corporate-account')
            .on('click', self.onCreateNewCorporateUserAccountModal);

          if (extras.message) updateMessage(undefined, { message: extras.message, alertType: extras.alertType || undefined });
          updateQuantity();
        });
      }

      var registerUrl = postTypes[e.data.type].registerUrl;
      var registerBody = $.extend(true, {}, postTypes[e.data.type].data);
      var currentTarget = $.extend(true, {}, e.currentTarget);

      function containsCommSegRegErrorCallback(response) {
        if (response) {
          AMILIA_APP.StoreResident.handleResidenciesCheck(e, {
            id: id,
            type: e.data && e.data.type || null,
            genuinePersonId: AMILIA_APP.accountOwnerGenuinePersonId,
            skipIsAddressAResidentCheck: true,
            success: function () { getRegistrationModalContent(registerUrl, registerBody, currentTarget); },
            error: function () { getRegistrationModalContent(registerUrl, registerBody, currentTarget); }
          });
        } else {
          getRegistrationModalContent(registerUrl, registerBody, currentTarget);
        }
      }

      // check if contains reg period community segment blocker(s) when account owner doesn't have valid address
      if (postTypes[e.data.type].containsCommSegRegErrorUrl && !AMILIA_APP.accountOwnerHasValidAddress) {
        $.get(postTypes[e.data.type].containsCommSegRegErrorUrl, postTypes[e.data.type].data, containsCommSegRegErrorCallback);
      } else {
        getRegistrationModalContent(registerUrl, registerBody, currentTarget);
      }
    },

    _registerWithMultiPass: function(e) {
      function buildValidityText($form) {
        var validity = $form.find('[name="validity"]').val();
        var timeFrame = $form.find('[name="validityTimeFrame"]').val();

        var magnitude = +validity;
        if (Number.isNaN(magnitude) || magnitude < 1 || !timeFrame) {
          return '';
        }

        var isPlural = magnitude > 1;
        var timeFrameText = '';
        if (timeFrame === 'Day') {
          timeFrameText = isPlural ? AMILIA_APP.Labels.Days : AMILIA_APP.Labels.Day;
        } else if (timeFrame === 'Week') {
          timeFrameText = isPlural ? AMILIA_APP.Labels.Weeks : AMILIA_APP.Labels.Week;
        } else if (timeFrame === 'Month') {
          timeFrameText = isPlural ? AMILIA_APP.Labels.Months : AMILIA_APP.Labels.Month;
        } else if (timeFrame === 'Year') {
          timeFrameText = isPlural ? AMILIA_APP.Labels.Years : AMILIA_APP.Labels.Year;
        } else {
          // Unknown timeframe, cannot show message.
          return '';
        }

        return validity + ' ' + timeFrameText.toLowerCase();
      }

      e.preventDefault();
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

      var $form = $(e.target);
      var dropinName = $form.data('name-with-schedule');

      window.selectedModalId = $form.find('[name="segmentId"]').val();

      // If using this pass now will update the effective date (and perhaps expiration date) of the multipass, show a warning.
      var updatingPassDatesWarning = '';
      var updatedEffectiveDate = moment($form.find('[name="updatedEffectiveDate"]').val());
      if (updatedEffectiveDate.isValid()) {
        var warningDateFormat = 'MMMM Do';

        var expirationDate = moment($form.find('[name="expirationDate"]').val());
        var validityText = buildValidityText($form);

        var updatingPassDatesWarningText = '';

        if (expirationDate.isValid() && validityText) {
          // There is an expriation date, and we know the valid time frame of the valid period (e.g. 1 month).
          updatingPassDatesWarningText = AMILIA_APP.Labels.UpdatingMultiPassEffectiveDateWithExpirationDateWithValidTimeFrame
            .replace('{0}', updatedEffectiveDate.format(warningDateFormat))
            .replace('{1}', validityText)
            .replace('{2}', expirationDate.format(warningDateFormat));
        } else if (expirationDate.isValid()) {
          // There is an expiration date, but it's not defined in an easily quantifiable period.
          updatingPassDatesWarningText = AMILIA_APP.Labels.UpdatingMultiPassEffectiveDateWithExpirationDate
            .replace('{0}', updatedEffectiveDate.format(warningDateFormat))
            .replace('{1}', expirationDate.format(warningDateFormat));
        } else {
          // There is only an effective date. Hopefully they are choosing the earliest activity they wish to book for.
          updatingPassDatesWarningText = AMILIA_APP.Labels.UpdatingMultiPassEffectiveDate
            .replace('{0}', updatedEffectiveDate.format(warningDateFormat));
        }

        updatingPassDatesWarning = '<div>' + updatingPassDatesWarningText + '</div><br/>';
      }

      var confirmModalOptions = {
        title: 'Confirmation',
        body: _.template([
          '<div><%=AMILIA_APP.Labels.ConfirmUseMultiPass%></div>',
          '<br/>',
          updatingPassDatesWarning,
          '<div class="checkbox"><label><input type="checkbox" name="sendConfirmMail" <%=sendConfirmMail ? "checked" : ""%>/> <%=AMILIA_APP.Labels.SendConfirmMail%></label></div>'
        ].join('\n'))({
          sendConfirmMail: !window.localStorage || !(typeof window.localStorage['Amilia.MultiPass.SendConfirmMail'] === 'string') || window.localStorage['Amilia.MultiPass.SendConfirmMail'] == 'true'
        }),
        buttons: [{
          label: AMILIA_APP.Labels.cancel,
          className: 'cancel btn-special',
          close: false
        }, {
          label: AMILIA_APP.Labels.continueOn,
          className: 'ok btn-primary',
          close: false
        }],
        customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
        onOk: redeemPass,
        onCancel: returnToQuickRegistration,
        onHidden: returnToQuickRegistration
      };

      var modalView = self.ui.modal.create(confirmModalOptions).render();

      function redeemPass() {
        self.ui.waitingIndicator.prependToItem($('.btn.ok').prop('disabled', true));

        var sendConfirmMail = modalView.$el.find('input[name="sendConfirmMail"]').is(':checked');
        if (window.localStorage) window.localStorage['Amilia.MultiPass.SendConfirmMail'] = '' + sendConfirmMail;
        $form.find('input[name="sendConfirmMail"]').val(sendConfirmMail);

        $.post(self.apiurl.redeemMultipass(), $form.serialize(), function(resp) {
          $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

          if (resp.success == false) {
            // reload drop-in modal and show error message
            $('#' + window.selectedModalId).trigger('click', {
              message: resp.message,
              alertType: 'warning'
            });
            try {
              delete window.selectedModalId;
            } catch (e) {
              window.selectedModalId = undefined;
            }
          } else {
            // show success modal
            var template = _.template([
              '<div>',
              '  <h4>' + dropinName + '</h4>',
              '  <p>',
              '    <strong><%=Name%></strong><br/>',
              '    <% if (!HasUnlimitedTokens) { %>',
              '       <%=NbTokens%> <%=AMILIA_APP.Labels.UsesRemaining%><br/>',
              '    <% } %>',
              '    <% if (!IsExpired && ExpirationDate != null) { %>',
              '      <%=AMILIA_APP.Labels.ExpiresOn%> <%=moment(ExpirationDate).format("YYYY-MM-DD")%>',
              '    <% } %>',
              '  </p>',
              '  <% if (SendConfirmMail) {%>',
              '    <p><%=AMILIA_APP.Labels.MultiPassEmailConfirmationMessage%></p>',
              '  <% } %>',
              '  <input type="hidden" name="InvoiceId" value="<%=InvoiceId%>"/>',
              '</div>'
            ].join('\n'));
            var successModalOptions = {
              title: AMILIA_APP.Labels.SuccessfulRegistration,
              body: template(resp),
              buttons: [{
                label: AMILIA_APP.Labels.close,
                className: 'btn-special',
                close: true
              }, {
                label: AMILIA_APP.Labels.Print,
                className: 'ok btn-primary',
                close: false
              }],
              customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
              onHidden: function() {
                $('#' + window.selectedModalId).trigger('click', {
                  message: AMILIA_APP.Labels.SuccessfulRegistration,
                  alertType: 'success'
                });
                try {
                  delete window.selectedModalId;
                } catch (e) {
                  window.selectedModalId = undefined;
                }
              },
              onOk: function() {
                var invoiceId = $('input[name="InvoiceId"]').val();
                var url = self.apiurl.getInvoiceDetailView() + invoiceId + '?showReconciledAmount=false';

                this.popupWnd = window.open(url, 'info', 'toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=1,width=550,height=400');
                if (window.focus) this.popupWnd.focus();
              }
            };
            self.ui.modal.create(successModalOptions).render();
          }
        });
      }
    },

    renderAddPersonModal: function(e) {
      // close existing quick registration modal
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

      window.selectedModalId = e.data.id;
      var archivedPeopleForAccount = new Backbone.ArchivedPersonCollection();
      archivedPeopleForAccount.fetch({ async: false });

      new Backbone.BackbonePersonAddAndUnarchiveModalView({ model: new Backbone.PersonModel(), collection: archivedPeopleForAccount })
        .on('close', function() {
          $('#' + window.selectedModalId).click();
          try {
            delete window.selectedModalId;
          } catch (e) {
            window.selectedModalId = undefined;
          }
        })
        .render();
    },

    renderModifyPersonModal: function(e) {
      e.preventDefault();

      // close existing quick registration modal
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

      window.selectedModalId = e.data.id;

      var personId = parseInt($(e.currentTarget).attr('data-person-id'), 10);
      var genuineId = parseInt($(e.currentTarget).attr('data-genuine-id'), 10);
      var isGenuine = $(e.currentTarget).attr('data-is-genuine');
      var requiresGender = $(e.currentTarget).attr('data-requires-gender');

      var model = new Backbone.PersonModel({
        Id: personId,
        IsGenuine: isGenuine,
        ShowGender: requiresGender === 'true'
      });

      if ((model.get('IsGenuine') === true || model.get('IsGenuine') == 'true') && !isNaN(genuineId)) {
        model.set('Id', genuineId);
      }

      model.fetch({
        url: model.urlRoot + '/' + model.id + '?isGenuine=' + model.get('IsGenuine')
      }).done(function() {
        var ModalView = model.get('IsAccountOwner') ? Backbone.ModifyPersonAccountFormModal : Backbone.ModifyPersonFormModal;
        var modal = new ModalView({ model: model })
          .on('close', function() {
            $('#' + window.selectedModalId).click();
            try {
              delete window.selectedModalId;
            } catch (e) {
              window.selectedModalId = undefined;
            }
          })
          .render();
      });
    },

    onCreateNewCorporateUserAccountModal: function(e) {
      e.preventDefault();

      // the select an account modal that opened this screen needs to be closed.
      closeOpenedModals();

      new Backbone.CreateNewCorporateAccountModal({ model: new Backbone.Model() })
        .render();
    },

    initializeCalendarEvents: function() {
      $('.activity-segment[rel="quick-reg"]').off('click');
      $('.activity-segment[rel="quick-reg"]').on('click keydown', {
        type: 'segment'
      }, self.checksBeforeRenderingRegistrationModal);

      var query = $.parseParams(window.location.href);
      if (query.quickRegisterId) $('.calendar-container #' + query.quickRegisterId).click();
    },
    registerInstallmentPopover: function(e) {
      e.stopPropagation();
      $(e.currentTarget).popover(_.extend({}, popoverOptions, {
        content: function() {
          if (!this.cache) {
            this.cache = self._loadRemoteInstallmentsPopover(
              self.apiurl.getInstallmentsTable() + $(this).attr('data-type'),
              'installment-content-' + $(this).attr('data-id'),
              { id: $(this).attr('data-id') },
              this,
              'installments-popover'
            );
          }
          return this.cache;
        }
      })).click(self.ui.popHandler);
      $(e.currentTarget).click();
    },
    registerButtonsAndPopovers: function(elem) {
      // Register buttons that load quick registration modal
      $(elem).find('button.quick-activity[rel="quick-reg"]').on('click', {
        type: 'activity'
      }, self.checksBeforeRenderingRegistrationModal);
      $(elem).find('button.quick-membership[rel="quick-reg"]').on('click', {
        type: 'membership'
      }, self.checksBeforeRenderingRegistrationModal);
      $(elem).find('button.quick-multipass').on('click', {
        type: 'multipass'
      }, self.checksBeforeRenderingRegistrationModal);
      $(elem).find('button.register-compact-btn').on('click', {
        type: 'activity'
      }, self.checksBeforeRenderingRegistrationModal);
      $(elem).find('button.register-subscription-btn').on('click', {
        type: 'subscription'
      }, self.checksBeforeRenderingRegistrationModal);
      $(elem).find('button.quick-product[rel="quick-reg"]').on('click', {
        type: 'product'
      }, self.checksBeforeRenderingRegistrationModal);

      $(elem).find('button.go-to-calendar').on('click', function() {
        if ($(this).data('href').indexOf('?') !== -1) {
          window.location = $(this).data('href') + '&scrollToCalendar=true';
        } else {
          window.location = $(this).data('href') + '?scrollToCalendar=true';
        }
      });

      // Promotion/Fee popovers
      $(elem).find('.toggle-price-popover.promotion-fee').popover(_.extend({}, popoverOptions, {
        template: [
          '<div class="popover" role="tooltip">',
          '   <div class="arrow"></div>',
          '   <h3 class="popover-title"></h3>',
          '   <div class="popover-content"></div>',
          '</div>'
        ].join('\n')
      })).click(self.ui.popHandler);

      // MultiPayement popovers
      $(elem).find('.toggle-price-popover.multipayment').popover(_.extend({}, popoverOptions, {
        content: function() {
          return self._loadRemotePopover(
            self.apiurl.getMultiPaymentTable() + $(this).attr('data-type'),
            'multipayment-content-' + $(this).attr('data-id'),
            { id: $(this).attr('data-id') }
          );
        }
      })).click(self.ui.popHandler);

      // Subscription popovers
      $(elem).find('.toggle-price-popover.subscription').popover(_.extend({}, popoverOptions, {
        content: function() {
          return self._loadSubscriptionOptionsPopover(
            self.apiurl.getSubscriptionTable() + $(this).attr('data-type'),
            'multipayment-content-' + $(this).attr('data-id'),
            { id: $(this).attr('data-id') }
          );
        }
      })).click(self.ui.popHandler);

      // register schedule list toggle
      $(elem).find('.toggle-activity-schedule-list').on('click', self._toggleActivityScheduleList);
      // wish list
      $(elem).find('a.wish-list-cta').on('click', AMILIA_APP.StoreWishlist.toggleWishListItem);
      $(elem).find('.remove-from-wish-list').on('click', AMILIA_APP.StoreWishlist.removeWishListItem);

      $(elem).find('input.wish-list-search').keydown(function (e) {
        if (e.keyCode === 13) {
          AMILIA_APP.StoreWishlist.sortAndSearchWishListItems(e);
        }
      });

      $(elem).find('select.wish-list-sort').on('change', AMILIA_APP.StoreWishlist.sortAndSearchWishListItems);
    },
    delegateEvents: function() {
      $(document).ready(function() {
        // Shopping cart scroll lock
        var $mainBar = $('.store div.pgHd');
        var $cartBar = $('div.optional-cart');
        var $topHeight = $mainBar.outerHeight();
        var $window = $(window);
        var locked = {
          top: '-4px',
          left: '0',
          right: '0',
          position: 'fixed'
        };

        var unlocked = { position: 'static' };

        var viewport = function() {
          var e = window;
          var a = 'inner';
          var d = document;

          if (!('innerWidth' in window)) {
            a = 'client';
            e = d.documentElement || d.body;
          }
          return { width: e[a + 'Width'], height: e[a + 'Height'] };
        };

        $window.resize(_.debounce(function() {
          if (viewport().width > self.mobileWidth) $cartBar.removeAttr('style');
          else $(window).scroll();
        }, 50));

        $window.scroll(function() {
          var $cartCheck = $('span.cart-check');
          if ($cartCheck.is(':visible') && $cartCheck.siblings().length) {
            $window.scrollTop() > $topHeight ? $cartBar.css(locked) : $cartBar.css(unlocked);
          }
        });

        // Enable search-bar expand on button click for mobile
        $('button.show-searchActivity').click(function() {
          var $container = $(this).closest('.row-fluid');
          $container.slideUp('fast', function() { $(this).remove(); });
          $('#searchActivity').hide().removeClass('hidden-phone').slideDown('fast');
        });

        // Initialize inventory counts and colors for variants
        $('select#Options_VariantId').trigger('change');

        // Animate fundraising amount bars
        $('div.mercury').each(function() {
          var $this = $(this);
          $this.animate({ width: $this.data('amount') }, 1500);
        });

        // initialize tooltips of nav pills
        $('.edit-module').tooltip();

        // show extra program information if never collapsed before
        if ($('div.custom-message-wrapper').length && !docCookies.hasItem(self.getPathKey())) {
          $('i.custom-message-icon').removeClass('fa-rotate-270');
          $('#custom-message').show();
          docCookies.setItem(self.getPathKey(), true, null, '/');
        } else if ($('div.custom-message-wrapper').length && docCookies.hasItem(self.getPathKey())) {
          if (self.getCookiesValue()) {
            $('i.custom-message-icon').removeClass('fa-rotate-270');
            $('#custom-message').show();
          }
        }

        // Bind birthday picker
        if ($('.birthday-date').length) self.ui.bindBirthdayPicker();

        $(document).ready(function() {
          // Automatically expand specific categories and sub-categories
          var subCategoriesInCart = $('.in-cart').closest('.subcat-list-item');

          var query = parseParamsAsArrays();
          var subCategoriesInQueryStringSelectors = [];
          var subCategoryInQueryStringIds = query.subCategoryIds;
          if (Array.isArray(subCategoryInQueryStringIds) && subCategoryInQueryStringIds.length > 0) {
            for (var i = 0; i < subCategoryInQueryStringIds.length; i++) {
              subCategoriesInQueryStringSelectors.push('.subcat-list-item[data-id="' + subCategoryInQueryStringIds[i] + '"]:not(.minus-icon)');
            }
          }
          var subCategoriesInQueryString = $(subCategoriesInQueryStringSelectors.join(','));

          var subCategoriesToOpen = $()
            .add(subCategoriesInCart)
            .add(subCategoriesInQueryString);

          var categoriesToOpen = subCategoriesToOpen.parents('.category-list-item:not(.minus-icon)');

          categoriesToOpen.click();
          subCategoriesToOpen.click();

          // Scroll to the first opened sub-category
          var $el = $('.subcat-list-item.minus-icon').first();
          if ($el.length) $('html, body').scrollTop($el.offset().top);

          // Open the quick register modal
          if (query.quickRegisterId) $('#' + query.quickRegisterId).click();
        });

        // Category click handler
        $('.category-list-item').on('click keydown', function(e) {

          // accessibility - keyboard interaction
          if (e.target !== e.currentTarget || (e.keyCode && e.keyCode !== 13 && e.keyCode !== 32 )) return;

          $('.active-popover').trigger('click');
          $(this).toggleClass('minus-icon').children('ul.subcat-list').slideToggle();

          // accessibility - update aria-expanded status
          $(this).attr('aria-expanded', $(this).hasClass('minus-icon') ? 'true' : 'false');
        });

        // SubCategory click handler
        $('.subcat-list-item').on('click keydown', function(e) {

          // accessibility - keyboard interaction
          if (e.target !== e.currentTarget || (e.keyCode && e.keyCode !== 13 && e.keyCode !== 32 )) return;

          e.stopPropagation();
          $('.active-popover').trigger('click');

          var showHide = $(this).children('div.table').is(':visible') ? 'hide' : 'show';

          $(this).toggleClass('minus-icon')
            .find('div.table').animate({
              opacity: showHide,
              margin: showHide,
              padding: showHide,
              height: showHide
            }, 200);

          // accessibility - update aria-expanded status
          $(this).attr('aria-expanded', $(this).hasClass('minus-icon') ? 'true' : 'false');
          $(this).parent('.category-list-item').attr('aria-expanded', 'true');

          if (typeof window.history.pushState !== 'undefined') {
            var id = $(this).attr('data-id');
            var query = parseParamsAsArrays();
            var subCategoryIds = Array.isArray(query.subCategoryIds) && query.subCategoryIds.length > 0 ? query.subCategoryIds : [];

            if ($(this).hasClass('minus-icon')) {
              if (_.indexOf(subCategoryIds, id) === -1) subCategoryIds.push(id);
            } else {
              subCategoryIds = _.without(subCategoryIds, id);
            }
            if (subCategoryIds.length) {
              query.subCategoryIds = subCategoryIds;
            } else {
              delete query.subCategoryIds;
            }
            updateQueryStringWithArray(query);
            var detailDiv = this;
            if ($(this).data('already-loaded') === false) {
              $(this).find('.subcat-list-table').empty().append('<div class"row-fluid" style="color:#2B91E1"><i class="fa fa-3x fa-spinner fa-spin"></i></div>');
              $.ajax({
                type: 'POST',
                url: $(this).data('detail-link'),
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({ subCategoryId: parseInt(id), programId: $(this).data('program-id') })
              }).done(function(response) {
                $(detailDiv).data('already-loaded', true);
                $(detailDiv).find('.subcat-list-table').empty().append(response);
                self.registerButtonsAndPopovers(detailDiv);
              });
            }
          }
        });

        self.registerButtonsAndPopovers(document);

        // Prevent table clicks from closing on other clicks
        $(document).find('.table').click(function(e) {
          e.stopPropagation();
          $('.active-popover').trigger('click');
        });

        $(document).find('.table').on('click', '.popover', function(e) {
          e.stopPropagation();
        });

        $(document).on('click', '#contentContainer .toggle-price-popover.installments', self.registerInstallmentPopover);

        $(document).find('.table').on('click', '.toggle-price-popover.installments', self.registerInstallmentPopover);

        // Close popovers if the user clicks anywhere else.
        $(document).find('body').on('show.bs.popover', function(e) {
          if (!$(e.target).data('popover')) return;

          var $body = $('body');
          $body.addClass('active-popover');
          $body.attr('data-popover-id', $(e.target).attr('id'));
        });

        $(document).find('body').on('hide.bs.popover', function(e) {
          if (!$(e.target).data('popover')) return;

          var $body = $('body');
          $body.removeClass('active-popover');
          $body.removeAttr('data-popover-id');
        });

        $(document).on('click', '.active-popover', function(e) {
          e.stopPropagation();

          if (!$(e.target).closest('.popup-marker, .popover-title, .popover-content').length
              && !$(e.target).is(':input')
              && !$(e.target).closest('.modal').length) {
            var $body = $('body');
            var openPopover = $body.attr('data-popover-id');

            $body.removeClass('active-popover');
            $body.removeAttr('data-popover-id');
            $('#' + openPopover).trigger('click');
          }
        });
      });

      var params = parseParamsAsArrays();

      if (!_.isEmpty(params)) {
        if (!_.isEmpty(params.search)) {
          $('#appendedInputButton').val(params.search[0]);
        }
      }
    },

    _quickAddOrRemoveBoxCallback: function(target) {
      var $ctarg = $(target);
      if (_.isEmpty($ctarg.attr('data-id'))) {
        $ctarg.find('i').removeClass('fa-user-plus').addClass('fa-spinner fa-spin');
        $ctarg.closest('form').submit();
      } else {
        if ($ctarg.hasClass('in-cart')) {
          $ctarg.removeClass('in-cart')
            .find('i')
            .removeClass('fa-check')
            .addClass('fa-spinner fa-spin');

          if (document.querySelectorAll('.register-compact-container i.fa.fa-fw.fa-ban').length > 0) {
            self._removeItemFromCart(target, false);
            return null;
          }
        }

        self._removeItemFromCart(target, true);
      }
    },

    _setAddOrRemoveState: function($element, enabled) {
      $element.prop('disabled', !enabled);
      $element.closest('.pass-container')
        .find('button.multi-pass').prop('disabled', !enabled);
    },

    _getParticipantGenuinePersonId: function ($elem) {
      var genuinePersonInput = $elem.closest('form').find('[name="Options.GenuinePersonId"]');
      if (genuinePersonInput.length === 1) {
        return genuinePersonInput.val();
      }
      return 0;
    },

    _quickAddOrRemoveBox: function(e) { // when you choose a person in the QuickRegistration modal
      e.preventDefault();
      var $ctarg = $(e.currentTarget);
      self._setAddOrRemoveState($ctarg, false);
      self.currentPersonIdForSuggProduct = $ctarg.attr('data-current-person-id');

      var isAdding = $ctarg.find('.fa').hasClass('fa-user-plus');
      var id = e.data && e.data.id || null;
      var hasCommunitySegmentRestrictions = $('.community-segments-eligibility-warning', $ctarg.closest('.modal-body')).length === 1;

      if (isAdding && hasCommunitySegmentRestrictions) { // activity restrictions
        AMILIA_APP.StoreResident.handleResidenciesCheck(e, {
          id: id,
          type: e.data && e.data.type || null,
          genuinePersonId: self._getParticipantGenuinePersonId($ctarg),
          success: self._quickAddOrRemoveBoxCallback,
          error: function () { self.displayInformationModal(AMILIA_APP.Labels.EligibilityResidencies); }
        });
      } else if (isAdding && AMILIA_APP.StoreResident.hasResidenciesPromo(id, $ctarg)) { // promo on activity
        AMILIA_APP.StoreResident.handleResidenciesCheckForPromo(e, {
          id: id,
          type: e.data && e.data.type || null,
          genuinePersonId: self._getParticipantGenuinePersonId($ctarg),
          done: self._quickAddOrRemoveBoxCallback
        });
      } else {
        self._quickAddOrRemoveBoxCallback(e.currentTarget);
      }
    },

    _unregisterDropIn: function(e) {
      e.preventDefault();

      var $button = $(e.currentTarget);
      var personId = $button.data('person-id');
      var segmentId = $button.data('segment-id');

      $button.prop('disabled', true).find('i').removeClass('fa fa-times');
      self.ui.waitingIndicator.prependToItem($button);
      window.selectedModalId = segmentId;

      $.post(self.apiurl.unregisterSpot(), {
        segmentId: segmentId,
        personId: personId,
        giveTokenBack: true
      }, function(resp) {
        $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

        var message = AMILIA_APP.Labels.SuccessfulUnregistration;
        var alertType = 'success';

        if (resp.Failed) {
          message = resp.Message;
          alertType = 'danger';
        }

        // reload drop-in modal and show success message
        $('#' + window.selectedModalId).trigger('click', {
          message: message,
          alertType: alertType
        });
        try {
          delete window.selectedModalId;
        } catch (e) {
          window.selectedModalId = undefined;
        }
      });
    },

    _loadRemotePopover: function(link, divId, data) {
      $.ajax({
        url: link,
        data: data || undefined,
        success: function(resp) {
          $('#' + divId).html(resp);
        }
      });
      return '<div id="' + divId + '"><br /><p style="text-align: center;"><i class="fa fa-spinner fa-2x fa-spin"></i></p></div>';
    },

    _loadSubscriptionOptionsPopover: function(link, divId, data) {
      $.ajax({
        url: link,
        data: data || undefined,
        success: function(resp) {
          $('#' + divId).html(resp);
        }
      });
      return '<div id="' + divId + '"><br /><p style="text-align: center;"><i class="fa fa-spinner fa-2x fa-spin"></i></p></div>';
    },

    _loadRemoteInstallmentsPopover: function(link, divId, data, popover, extraClasses) {
      $.ajax({
        url: link,
        data: data || undefined,
        success: function(resp) {
          popover.cache = '<div class="' + extraClasses + '" id="' + divId + '">' + resp + '</div>';
          $(popover).popover('show');
        }
      });
      return '<div class="' + extraClasses + '" id="' + divId + '"><br /><p style="text-align: center;"><i class="fa fa-spinner fa-2x fa-spin"></i></p></div>';
    },

    getPathKey: function() {
      var path = document.location.pathname.replace(/\/fr|\/en/g, '');
      return _.take(path.split('/'), 7).join('_');
    },

    getSearchMembershipsParams: function() {
      var params = {};

      var selectedTags = [];
      $('input[name="selectedTags"]:checked').each(function (i, el) {
        selectedTags.push($(el).val());
      });
      if (selectedTags.length) {
        params.selectedTags = selectedTags;
      }

      var keywordValue = $('#appendedInputButton').val();
      if (keywordValue) {
        params.keyword = keywordValue;
      }

      var seasonValue = $('.membership-season-filter[name="season"]').val();
      if (seasonValue) {
        params.season = seasonValue;
      }

      return params;
    },

    sanitizeStringForSearch: function(text) {
      return _.latinize(text.replace(/\+/g, ' ')).toLowerCase();
    },

    isKeywordInText: function(keyword, text) {
      if (!keyword || !text) return false;

      var textDecoded = $('<textarea />').html(text).text();
      var textSanitized = self.sanitizeStringForSearch(textDecoded);
      var keywordSanitized = self.sanitizeStringForSearch(keyword);

      return textSanitized.indexOf(keywordSanitized) > -1;
    },

    filterMembershipsByKeywords: function(listOfMemberships, membershipsToRemove, keyword) {
      if (!keyword) return [];

      var keywords = self.sanitizeStringForSearch(keyword);

      $.each(listOfMemberships, function (id, membership) {
        var isInName = self.isKeywordInText(keywords, membership.Name);
        var isInDescription = self.isKeywordInText(keywords, membership.Description);

        if (!isInName && !isInDescription) {
          membershipsToRemove.push(membership.Id);
        }
      });
    },

    filterMembershipsBySeason: function(listOfMemberships, membershipsToRemove, season) {
      var seasonId = parseInt(season, 10);
      if (!seasonId) return [];

      $.each(listOfMemberships, function (id, membership) {
        var hasSeason = membership.Season && membership.Season.Id === seasonId;

        if (!hasSeason) {
          membershipsToRemove.push(membership.Id);
        }
      });
    },

    filterMembershipsByTags: function(listOfMemberships, membershipsToRemove, tags) {
      if (tags.length < 1) return [];

      $.each(listOfMemberships, function (id, membership) {
        var hasTag = false;

        if (membership.Tags) {
          var membershipTagIds = _.map(membership.Tags, function(tag) {
            return tag.Id;
          });
          hasTag = _.intersection(membershipTagIds, tags).length > 0;
        }

        if (!hasTag) {
          membershipsToRemove.push(membership.Id);
        }
      });
    },

    _searchMemberships: function(e) {
      e && e.preventDefault();

      var paramsForUrl = self.getSearchMembershipsParams();

      var quickRegisterId = parseInt(AMILIA_APP.utils.getURLParameter('quickRegisterId'), 10);
      if (quickRegisterId) {
        paramsForUrl.quickRegisterId = quickRegisterId;
      }

      var paramsForUrlAsQueryString = $.param(paramsForUrl, true);

      var url = window.location.pathname + '?' + paramsForUrlAsQueryString;
      window.history.replaceState(undefined, undefined, url);

      var params = parseParamsAsArrays();
      var selectedTags = (_.map(params.selectedTags, Number) || []);

      var membershipsToDisplay = _.map(AMILIA_APP.memberships, function(membership) {
        return membership.Id;
      });
      var membershipsToRemove = [];

      self.filterMembershipsByKeywords(AMILIA_APP.memberships, membershipsToRemove, (params.keyword ? params.keyword[0] : ''));
      self.filterMembershipsBySeason(AMILIA_APP.memberships, membershipsToRemove, (params.season ? params.season[0] : ''));
      self.filterMembershipsByTags(AMILIA_APP.memberships, membershipsToRemove, selectedTags);

      self._showMembershipsFound(_.difference(membershipsToDisplay, membershipsToRemove), selectedTags);
    },

    _showMembershipsFound: function(membershipsFound, selectedTags) {
      membershipsFound = membershipsFound || [];
      var $membershipList = $('#membership-list');
      var $memberships = $membershipList.find('.membership-item-js');
      var $noMembershipsMessage =
        $(
          '<div id="store-results-empty__text" style="text-align: center;">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="fill: #CBE1F3;height: 70px;"><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"/></svg>'+
            '<p className="store-results-empty__text">' + AMILIA_APP.Labels.NoSearchResults + '<br/>' + AMILIA_APP.Labels.ChangeCriterias + '</p>' +
          '</div>'
        );
      var $adminOnlyMembershipsTitle = $membershipList.find('.admin-visible-only-title');
      var shouldShowAdminOnlyMembershipsTitle = false;

      $membershipList.find('.noMemberships').remove();
      $memberships.each(function() { $(this).hide(); });

      if (membershipsFound.length > 0) {
        $.each(membershipsFound, function(key, membershipId) {
          var $membership = $membershipList.find('[data-membership-id="' + membershipId + '"]');
          if ($membership.hasClass('admin-visible-only')) { shouldShowAdminOnlyMembershipsTitle = true; }
          $membership.show();

          var $membershipTags = $membership.find('.label.amilia-label');
          if ($membershipTags.length > 0) {
            $.each($membershipTags, function(_, tag) {
              var tagId = tag.getAttribute('data-tag-id');

              if (selectedTags.includes(+tagId)) {
                $(tag).show();
              } else {
                $(tag).hide();
              }
            });
          }
        });
      } else if(!$membershipList.find('#store-results-empty__text').length){
          $membershipList.append($noMembershipsMessage);
      }

      if (!shouldShowAdminOnlyMembershipsTitle) {
        $adminOnlyMembershipsTitle.hide();
      } else {
        $adminOnlyMembershipsTitle.show();
      }

      $('.results-count-filtered').html(membershipsFound.length);
    },

    _searchDaysFormData: function() {
      var days = 0;

      $('input.days-checkbox:checked').each(function() {
        days += parseInt($(this).val(), 10);
      });

      $('input[name="days"]').val(days);
    },
    _tagFormData: function() {
      var tagIds = [];

      $('#activity-filter-container input:checked[name="selectedTags"]').each(function() {
        tagIds.push($(this).val());
      });

      $('#searchActivity input[name="SelectedTags"]').val(tagIds.join(','));
    },
    _locationFormData: function() {
      var locationIds = [];

      $('#activity-filter-container input:checked[name="selectedLocations"]').each(function() {
        locationIds.push($(this).val());
      });

      $('#searchActivity input[name="SelectedLocations"]').val(locationIds.join(','));
    },
    _programFormData: function() {
      var programId = $('#activity-filter-container button.active[name="selectedProgram"]').val();
      $('#searchActivity input[name="SelectedProgram"]').val(programId);
    },
    _categoryFormData: function() {
      var categoryId = $('#activity-filter-container button.active[name="selectedCategory"]').val();
      $('#searchActivity input[name="SelectedCategory"]').val(categoryId);
    },
    _subCategoryFormData: function() {
      var subCategoryId = $('#activity-filter-container button.active[name="selectedSubCategory"]').val();
      $('#searchActivity input[name="SelectedSubCategory"]').val(subCategoryId);
    },
    _clickSubmit: function() {
      $('#searchActivity button.btn-primary[type="Submit"]').click();
    },
    _agesFormData: function() {
      var ages = [];

      $('#activity-filter-container button.active[name="selectedAges"]').each(function() {
        ages.push($(this).val());
      });

      $('#searchActivity input[name="SelectedAges"]').val(ages.join(','));
    },
    _setSearchCheckbox: function (e, value) {
      var checkId = e.target && e.target.dataset && e.target.dataset.id;
      if (checkId) {
        var $checkItem = $('#' + checkId);
        if ($checkItem) {
          $checkItem.prop('checked', value);
        }
      }
    },
    _removeSelectedAge: function (e) {
      var ageButtonId = e.target && e.target.dataset && e.target.dataset.id;
      if (ageButtonId) {
        var $ageButton = $('#' + ageButtonId);
        if ($ageButton) {
          $ageButton.removeClass('active');
        }
      }
      self._clickSubmit();
    },
    _clearAll: function() {
      window.location = self.apiurl.shop;
    },
    _removeSelectedFilter: function (e) {
      self._setSearchCheckbox(e, false);
      self._clickSubmit();
    },
    _removeSelectedProgram: function (e) {
      $('.program-filter-button.active').removeClass('active');
      $('.category-filter-button.active').removeClass('active');
      $('.subcategory-filter-button.active').removeClass('active');
      self._clickSubmit();
    },
    _removeSelectedCategory: function (e) {
      $('.category-filter-button.active').removeClass('active');
      $('.subcategory-filter-button.active').removeClass('active');
      self._clickSubmit();
    },
    _removeSelectedSubCategory: function (e) {
      $('.subcategory-filter-button.active').removeClass('active');
      self._clickSubmit();
    },
    _removeTextCriteria: function() {
      $('input[name="textCriteria"]').val('');
      self._clickSubmit();
    },
    _submitActivitySearchForm: function() {
      self._searchDaysFormData();
      self._tagFormData();
      self._locationFormData();
      self._agesFormData();
      self._programFormData();
      self._categoryFormData();
      self._subCategoryFormData();
    },

    _clearContent: function(e) {
      // retrieve target to clear, and can trigger one event if there was any listener
      e.preventDefault();

      var $el = $(this);
      var $target = $($el.data('target-to-clear'));
      var eventType = $el.data('event-type');

      $target.html('').val('');
      if (eventType) $target.trigger(eventType);
    },

    _addPersonToAccount: function(e) {
      e.preventDefault();
      var $form = $(this);
      var $submitButton = $form.find('[type="submit"]');
      var errNb = self.ui.misc.validateForm($form);
      var formSerialized;
      var req;

      if (errNb === 0) {
        formSerialized = $form.find(':input').serialize();
        self.ui.waitingIndicator.prependToItem($submitButton);

        req = $.post(self.apiurl.addPerson(), formSerialized);
        req.success(function() {
          window.location.reload();
        });
      }
    },

    _addPersonToAccountQuick: function(e) {
      e.preventDefault();
      var $form = $(this);
      var $submitButton = $form.find('[type="submit"]');
      var errNb = self.ui.misc.validateForm($form);
      var formSerialized;
      var req;

      if (errNb === 0) {
        formSerialized = $form.find(':input').serialize();
        self.ui.waitingIndicator.prependToItem($submitButton);

        req = $.post(self.apiurl.addPerson(), formSerialized);
        req.success(function() {
          $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
          $('#' + window.selectedModalId).trigger('click', { message: AMILIA_APP.Labels.PersonAddedToAccount });
          try {
            delete window.selectedModalId;
          } catch (ex) {
            window.selectedModalId = undefined;
          }
        });
      }
    },

    setTabContent: function(args) {
      var dflCtn = '.tab-container';
      if (typeof args === 'string') {
        $(dflCtn).html(args);
        return false;
      }

      if (typeof args === 'object') {
        var target = args.target ? $(args.target) : $(dflCtn);

        $(target).empty().append(args.content).show();
        if (typeof args.success === 'function') args.success();
      }
    },

    generateErrorStringList: function(errorArray) {
      var errorsString = '';

      _.each(errorArray, function(error) {
        errorsString += error + '\n';
      });

      return '<p class="amilia-error">' + errorsString + '</p>';
    },

    _showLegalsConditions: function() {
      self.ui.modal.create({
        title: AMILIA_APP.Labels.legalsConditions,
        body: AMILIA_APP.Labels.legalsNotice,
        cancelButtonHide: true,
        okButtonClose: true
      }).render();
    },

    getCookiesValue: function () {
      return docCookies.getItem(self.getPathKey()) === "true";
    },

    toggleProgramCustomMessage: function () {
      $('i.custom-message-icon').toggleClass('fa-rotate-270');
      $('#custom-message').slideToggle();
      docCookies.setItem(self.getPathKey(), !self.getCookiesValue(), null, '/');
    },

    toggleMultiPassActivities: function(e) {

      // accessibility - Only consider Enter key here
      if (e && e.type === 'keydown' && e.keyCode !== 13) return;

      var $span = $(e.currentTarget);
      var $icon = $span.find('i');

      var $activitiesDiv = $span.next('.eligible-activities-list');
      var multiPassId = $span.data('id');

      var isFetched = $span.hasClass('fetched');
      var isOpen = $activitiesDiv.is(':visible');
      var classes = { open: 'fa fa-minus-square', closed: 'fa fa-plus-square', fetching: 'fa fa-spinner fa-spin' };

      if (isFetched) {
        $icon.attr('class', isOpen ? classes.closed : classes.open);
        $activitiesDiv[isOpen ? 'slideUp' : 'slideDown']('fast');
      } else {
        $icon.attr('class', classes.fetching);

        $.get(self.apiurl.getMultiPassActivities(), { id: multiPassId }, function(data) {
          $activitiesDiv.html(data).slideToggle('fast');
          $icon.attr('class', classes.open);
          $span.addClass('fetched');
        });
      }
    },

    toggleMultiPassPrivateLessons: function(e) {

      // accessibility - Only consider Enter key here
      if (e && e.type === 'keydown' && e.keyCode !== 13) return;

      var $span = $(e.currentTarget);
      var $icon = $span.find('i');

      var $privateLessonsDiv = $span.next('.eligible-private-lessons-list');
      var multiPassId = $span.data('id');

      var isFetched = $span.hasClass('fetched');
      var isOpen = $privateLessonsDiv.is(':visible');
      var classes = { open: 'fa fa-minus-square', closed: 'fa fa-plus-square', fetching: 'fa fa-spinner fa-spin' };

      if (isFetched) {
        $icon.attr('class', isOpen ? classes.closed : classes.open);
        $privateLessonsDiv[isOpen ? 'slideUp' : 'slideDown']('fast');
        $span.attr('aria-expanded', isOpen ? 'false' : 'true');
      } else {
        $icon.attr('class', classes.fetching);

        $.get(self.apiurl.getMultiPassPrivateLessons(), { id: multiPassId }, function(data) {
          $privateLessonsDiv.html(data).slideToggle('fast');
          $icon.attr('class', classes.open);
          $span.addClass('fetched');
          $span.attr('aria-expanded', 'true');
        });
      }
    },

    toggleMembershipActivities: function(e) {
      var $span = $(e.currentTarget);
      var $icon = $span.find('i');

      var $activitiesDiv = $span.next('.eligible-activities-list');
      var membershipId = $span.data('id');

      var isFetched = $span.hasClass('fetched');
      var isOpen = $activitiesDiv.is(':visible');
      var classes = { open: 'fa fa-minus-square', closed: 'fa fa-plus-square', fetching: 'fa fa-spinner fa-spin' };

      if (isFetched) {
        $icon.attr('class', isOpen ? classes.closed : classes.open);
        $activitiesDiv[isOpen ? 'slideUp' : 'slideDown']('fast');
        $span.attr('aria-expanded', isOpen ? 'false' : 'true');
      } else {
        $icon.attr('class', classes.fetching);

        $.get(self.apiurl.getMembershipActivities(), { id: membershipId }, function(data) {
          $activitiesDiv.html(data).slideToggle('fast');
          $icon.attr('class', classes.open);
          $span.addClass('fetched');
          $span.attr('aria-expanded', 'true');
        });
      }
    },

    _checkMandatoryMemberships: function(e, extras) {
      var cartCallbackContext = this;
      e.preventDefault();
      extras = extras || {};

      var _itemId = parseInt(
        $(this).find('input[name="itemId"]').val()
        || $(this).find('select[name="ItemId"]').val()
        || $(this).find('input[name="ItemId"]').val(), 10
      );
      var _personId = parseInt($(this).find('input[name="Options.PersonId"]').val(), 10);
      var _genuinePersonId = parseInt($(this).find('input[name="Options.GenuinePersonId"]').val(), 10);
      var _createNewPersonForOrg = $(this).find('input[name="Options.CreateNewPersonForOrg"]').val() == 'true';
      var _itemType = $(this).find('input[name="itemType"]').val();
      var _hasRequiredProducts = (extras && extras.hasRequiredProducts) || $(this).hasClass('hasRequiredProducts');
      var _hasRequiredMemberships = $(this).hasClass('haveToCheck');
      var _hasRequiredSubscriptions = $(this).hasClass('haveToCheckSubscriptions');
      var _selectedInstallmentOptionId = parseInt($(this).find('input[name="Options.SelectedInstallmentOptionId"]').val(), 10) || null;
      var _addedMandatoryMultiPass = extras.addedMandatoryMultiPass || false;
      var _subscriptionIdToAdd = extras.subscriptionIdToAdd;

      var onReqSuccess = function (data) {
        if (data.PersonHasMembership === true) {
          if (_.isArray(data.MandatoryChildItems) && !_.isEmpty(data.MandatoryChildItems)) {
            extras.MandatoryChildItems = data.MandatoryChildItems;
          }

          if (_.isArray(data.ExistingSubscriptions) && !_.isEmpty(data.ExistingSubscriptions)) {
            var bodyTemplate = _.template([
              '<%=AMILIA_APP.Labels.PersonAlreadyHasResaleMembership%>',
              '<% for (var i = 0; i < subscriptions.length;  i++) { %>',
              '<div style="margin-top: 10px"><strong><%= subscriptions[i].Name %></strong></div>',
              '<div>Expiration: <%= moment(subscriptions[i].ExpirationDate).format("YYYY-MM-DD") %></div>',
              '<% } %>'
            ].join('\n'));

            var resaleSubscriptionsMessageModal = {
              title: AMILIA_APP.Labels.MembershipFound,
              body: bodyTemplate({ subscriptions: data.ExistingSubscriptions }),
              buttons: [
                {
                  label: AMILIA_APP.Labels.Continue,
                  className: 'ok btn-primary',
                  close: true
                }
              ],
              onOk: function () {
                self._addToCart.call(cartCallbackContext, e, extras);
              }
            };

            $('.modal, .modal-backdrop').each(function () { $(this).remove(); });
            self.ui.modal.create(resaleSubscriptionsMessageModal).render();
          } else {
            self._addToCart.call(cartCallbackContext, e, extras);
          }
        } else if (data.NoEligibleMembershipForPerson === true && !window.isAdminMode) {
          // no eligible membership
          var modalOptions = {
            title: AMILIA_APP.Labels.NoEligibleMembership,
            body: AMILIA_APP.Labels.NoEligibleMembershipMessage,
            buttons: [{
              label: AMILIA_APP.Labels.cancel,
              className: 'ok btn-primary',
              close: true,
              href: document.URL
            }]
          };

          $('.modal, .modal-backdrop').each(function () { $(this).remove(); });
          self.ui.modal.create(modalOptions).render();
        } else if (data.NoValidMembershipExpiryDate === true) {
          // no valid expiry date for the membership
          var modalOptions = {
            title: AMILIA_APP.Labels.NoEligibleMembership,
            body: AMILIA_APP.Labels.NoValidMembershipExpiryDateMessage,
            buttons: [{
              label: AMILIA_APP.Labels.cancel,
              className: 'ok btn-primary',
              close: true,
              href: document.URL
            }]
          };

          $('.modal, .modal-backdrop').each(function () { $(this).remove(); });
          self.ui.modal.create(modalOptions).render();
        } else {
          // show membership or list of memberships that must be bought
          var options = getOptions();

          if (window.isAdminMode && AMILIA_APP.canAdminOverrideAtCheckout) {
            options.buttons.unshift({
              label: AMILIA_APP.Labels.SkipAndContinue,
              className: 'secondary btnSet3 btn-warning',
              close: true,
              href: document.URL
            });
          }

          $('.modal, .modal-backdrop').each(function () { $(this).remove(); });
          var modalView = self.ui.modal.create(options).render();

          var $modalOkButton = $('.modal-footer .btn.ok');

          if ($('select[name="Options.SelectedMembership"] option').length == 2) {
            var val = $('select[name="Options.SelectedMembership"] option').eq(1).val();
            $('select[name="Options.SelectedMembership"]').val(val);
            var x = setTimeout(function () {
              $('select[name="Options.SelectedMembership"]').trigger('change');
            }, 0);
          }

          $('input[name="Options.MembershipNumber"]').keydown(function (e) {
            e.stopPropagation();
            if (e.keyCode == 13) {
              $('.btn.verify').trigger('click');
              return false;
            }
          });

          $('#extra-info button.verify').click(onClick);

          $('.toggle-payments-popover.installments').popover(_.extend({}, popoverOptions, {
            content: function () {
              if (!this.cache) {
                this.cache = self._loadRemoteInstallmentsPopover(
                  self.apiurl.getInstallmentPaymentsTable(),
                  'multipayment-content-' + $(this).attr('data-id'),
                  { id: $(this).attr('data-id'), amount: $(this).attr('data-amount') },
                  this,
                  ''
                );
              }
              return this.cache;
            }
          })).click(self.ui.popHandler);

          $('.installment-option-label').on('click', function (e) {
            var $label = $(e.currentTarget);
            $label.closest('.installment-option-container').find('i').removeClass('fa-check').addClass('fa-user-plus')
              .closest('button')
              .css('background', '#2B91E1');
            $label.find('i').removeClass('fa-user-plus').addClass('fa-check').closest('button')
              .css('background', '#00bd44');
            var selectedInstallmentOptionId = $label.data('option-id');
            $('input[name="Options.MembershipInstallmentOptionId"]').val(selectedInstallmentOptionId);
            $modalOkButton.prop('disabled', selectedInstallmentOptionId === undefined);
          });

          var membershipSelector = $('#RequiredMembershipList').find('select');
          if (membershipSelector.length) {
            membershipSelector.change(checkChoice);
            // Firefox select jquery change event workaround
            membershipSelector.keyup(checkChoice);
            $modalOkButton.prop('disabled', true);
          }

          //= ====================================
          // FUNCTIONS SECTION
          //= ====================================
          function getOptions() {
            return {
              title: $(data).find('#membership-requirement-modal-title').val() || AMILIA_APP.Labels.MembershipMandatoryForThisActivity,
              body: data,
              buttons: [{
                label: AMILIA_APP.Labels.cancel,
                className: 'cancel btn-special',
                close: true,
                href: document.URL
              }, {
                label: AMILIA_APP.Labels.continueOn,
                className: 'ok btn-primary',
                close: true,
                href: document.URL
              }],
              customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
              onOk: function () {
                // extras

                var mandatoryMembershipForms = $('.all-required-memberships-form');
                var _externalMembershipNumber = $('input[name="Options.MembershipNumber"]').val();
                self.ui.waitingIndicator.prependToItem(modalView.$el.find('.ok '));

                if (_hasRequiredSubscriptions) {
                  // when adding one subscription (can only add one)
                  var chosenMembershipId = $('select[name="Options.SelectedMembership"]').find(':selected').val();
                  _subscriptionIdToAdd = chosenMembershipId;
                }

                modalView.close();

                $('.formRegister-activity.noHaveToCheck').trigger('submit', {
                  hasRequiredProducts: _hasRequiredProducts,
                  activityId: _itemId,
                  itemType: _itemType,
                  externalMembershipNumber: _externalMembershipNumber,
                  hadRequiredMembership: true,
                  mustAlsoBuyMembership: _hasRequiredSubscriptions && _hasRequiredMemberships,
                  addedMandatoryMultiPass: _addedMandatoryMultiPass,
                  mandatoryMembershipForms: mandatoryMembershipForms,
                  subscriptionIdToAdd: _subscriptionIdToAdd
                });
              },
              onSecondary: function () { // Admin's "Ignore and continue"
                $('select[name="Options.SelectedMembership"]').val('');
                var $okButton = modalView.$el.find('.ok ');
                $okButton.prop('disabled', false);
                modalView.close();
                $('.formRegister-activity.noHaveToCheck').trigger('submit', {
                  hasRequiredProducts: _hasRequiredProducts,
                  activityId: _itemId,
                  itemType: _itemType,
                  externalMembershipNumber: undefined,
                  hadRequiredMembership: true,
                  mustAlsoBuyMembership: _hasRequiredSubscriptions && _hasRequiredMemberships,
                  addedMandatoryMultiPass: _addedMandatoryMultiPass,
                  mandatoryMembershipForms: []
                });
              }
            };
          }

          function checkChoice() {
            var $selectedItem = $(this).find(':selected');
            var extraInfo = $selectedItem.data('extra-info');
            var $infoDisplay = $('.extra-information-display');
            var membershipRequiredProducts = $selectedItem.data('has-required-products') === 'True';
            if (!_hasRequiredProducts && membershipRequiredProducts) {
              _hasRequiredProducts = true;
              _itemId = $selectedItem.val();
              _itemType = 'membership';
            }
            $('.installment-membership-option').hide();
            $('#membership-' + $selectedItem.val()).show();

            var infoDisplayText = '';
            if (this.value !== '') {
              infoDisplayText = $selectedItem.data('full-description')
                + '<br/>' + $selectedItem.data('price') + '&nbsp;<span style="font-size: 10px;">' + $selectedItem.data('tax-string') + '</span>';
            }
            $infoDisplay.html(infoDisplayText);

            if (extraInfo === true) {
              $('#extra-info:hidden').slideDown();
              $modalOkButton.prop('disabled', true);
              var selectedName = $('select[name="Options.SelectedMembership"]').find(':selected').attr('data-name');
              $('#extra-info').find('.help-block').not('.admin-mode').text(AMILIA_APP.Labels.ExternalMembershipHelpText.replace('{0}', selectedName));
            } else {
              $('#extra-info:visible').slideUp();
              $modalOkButton.prop('disabled', this.value === '');
            }

            if ($selectedItem.data('has-installments-enabled') === 'True') {
              $modalOkButton.prop('disabled', true);
            }
            $('.installment-option-container').find('i').removeClass('fa-check').addClass('fa-user-plus')
              .closest('button')
              .css('background', '#2B91E1');
            $('input[name="Options.SelectedInstallmentId"]').val('');
          }

          function onClick() {
            var $self = $(this);
            $('.amilia-error-ctn').addClass('hidden');
            $self.css('background', '#494949');
            $self.prop('disabled', true);
            $self.find('i').removeClass('fa-arrow-right').addClass('fa-spinner fa-spin');

            var _membershipId = $('[name="Options.SelectedMembership"]').find(':selected').val();
            var _externalMembershipNumber = $('input[name="Options.MembershipNumber"]').val();
            var _isGenuinePerson = $('input[name="Options.CreateNewPersonForOrg"]').val();

            var request = $.ajax({
              url: '//' + window.location.hostname + '/store/' + culture + '/' + urlOrgName + '/shop/memberships/verifyexternalmembership',
              type: 'POST',
              data: {
                membershipId: _membershipId,
                personId: _personId,
                externalMembershipNumber: _externalMembershipNumber,
                isGenuinePerson: _isGenuinePerson
              }
            });

            request.success(function () {
              $self.css('background', 'green');
              $self.find('i').removeClass().addClass('verify-status fa fa-check fa-fw');
              $self.prop('disabled', true);
              $('.extra-info-container input').prop('readonly', true);
              $modalOkButton.prop('disabled', false);
            });

            request.fail(function (err) {
              $self.css('background', 'orange');
              $self.find('i').removeClass().addClass('verify-status fa fa-exclamation-triangle fa-fw');
              $self.prop('disabled', false);
              $('.amilia-error-ctn').removeClass('hidden').html(err.statusText);
            });
          }
          //= ====================================
          // END FUNCTIONS
          //= ====================================
        }
      };

      var req = $.post(self.apiurl.checkMandatoryMemberships(), {
        id: _itemId,
        personId: _personId,
        genuinePersonId: _genuinePersonId,
        createNewPersonForOrg: _createNewPersonForOrg,
        itemType: _itemType,
        selectedInstallmentOptionId: _selectedInstallmentOptionId,
        checkForRequiredSubscriptions: _hasRequiredSubscriptions
      });

      req.success(function (data) {
        if (data.PersonHasMembership === true && _hasRequiredSubscriptions && _hasRequiredMemberships) {
          var extras = {};
          if (_.isArray(data.MandatoryChildItems) && !_.isEmpty(data.MandatoryChildItems)) {
            extras = { MandatoryChildItems: data.MandatoryChildItems };
          }

          // Don't add to cart right away; we've verified that the person has the required Subscription.
          // Must now call back-end again for required memberships
          _hasRequiredSubscriptions = false;
          var secondReq = $.post(self.apiurl.checkMandatoryMemberships(), {
            id: _itemId,
            personId: _personId,
            genuinePersonId: _genuinePersonId,
            createNewPersonForOrg: _createNewPersonForOrg,
            itemType: _itemType,
            selectedInstallmentOptionId: _selectedInstallmentOptionId,
            checkForRequiredSubscriptions: false
          });
          secondReq.success(function (data) {
            onReqSuccess(data);
          });
        } else {
          onReqSuccess(data);
        }
      });
    },

    _checkMandatoryMultiPass: function(e) {
      var cartCallbackContext = this;
      e.preventDefault();

      var _itemId = parseInt($(this).find('input[name="itemId"]').val(), 10);
      var _personId = parseInt($(this).find('input[name="Options.PersonId"]').val(), 10);
      var _genuinePersonId = parseInt($(this).find('input[name="Options.GenuinePersonId"]').val(), 10);
      var _createNewPersonForOrg = $(this).find('input[name="Options.CreateNewPersonForOrg"]').val() == 'true';
      var _itemType = $(this).find('input[name="itemType"]').val();

      var req = $.post(self.apiurl.checkMandatoryMultipass(), {
        id: _itemId,
        personId: _personId,
        genuinePersonId: _genuinePersonId,
        createNewPersonForOrg: _createNewPersonForOrg,
        itemType: _itemType
      });
      req.success(function(data) {
        if (data.PersonHasMultipass === true) {
          self._addToCart.call(cartCallbackContext, e);
        } else {
          var options = {
            title: AMILIA_APP.Labels.MembershipMandatoryForThisActivity,
            body: data,
            buttons: [{
              label: AMILIA_APP.Labels.cancel,
              className: 'cancel btn-special',
              close: true,
              href: document.URL
            }, {
              label: AMILIA_APP.Labels.continueOn,
              className: 'ok btn-primary',
              close: true,
              href: document.URL
            }],
            customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
            onOk: function() {
              self.ui.waitingIndicator.prependToItem(modalView.$el.find('.ok '));

              modalView.close();

              // Event will be handled by _addToOrRemoveFromCart
              $('.formRegister-activity').trigger('submit', {
                hasRequiredProducts: false,
                activityId: _itemId,
                itemType: _itemType,
                addedMandatoryMultiPass: true
              });
            },
            onSecondary: function() {
              $('select[name="ItemId"]').val('');
              var $okButton = modalView.$el.find('.ok ');
              $okButton.prop('disabled', false);
              $okButton.trigger('click'); // Event will be handled by onOk
            }
          };

          $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
          var modalView = self.ui.modal.create(options).render();

          var $modalOkButton = $('.modal-footer .btn.ok');
          var checkChoice = function() {
            var $selectedItem = $(this).find(':selected');
            var extraInfo = $selectedItem.data('extra-info');
            var requiredMembership = $selectedItem.data('check-membership');
            var $infoDisplay = $('.extra-information-display');
            var $form = $(this).closest('form');

            $('.installment-multipass-option').hide();
            $('#multipass-' + $selectedItem.val()).show();

            $form.removeClass('haveToCheck noHaveToCheck').addClass(requiredMembership ? 'haveToCheck' : 'noHaveToCheck');

            this.value !== '' ? $infoDisplay.text($selectedItem.data('full-description')) : $infoDisplay.text('');

            if (extraInfo === true) {
              $('#extra-info:hidden').slideDown();
              $modalOkButton.prop('disabled', true);
              var selectedName = $('select[name="ItemId"]').find(':selected').attr('data-name');
              $('#extra-info').find('.help-block').not('.admin-mode').text(AMILIA_APP.Labels.ExternalMembershipHelpText.replace('{0}', selectedName));
            } else {
              $('#extra-info:visible').slideUp();
              $modalOkButton.prop('disabled', this.value === '');
            }

            if ($selectedItem.data('has-installments-enabled') === 'True') {
              $modalOkButton.prop('disabled', true);
            }
            $('.installment-option-container').find('i').removeClass('fa-check').addClass('fa-user-plus')
              .closest('button')
              .css('background', '#2B91E1');
            $('input[name="Options.SelectedInstallmentId"]').val('');
          };

          $('#RequiredMultipassList select').change(checkChoice);
          // Firefox select jquery change event workaround
          $('#RequiredMultipassList select').keyup(checkChoice);

          if ($('select[name="ItemId"] option').length == 2) {
            var val = $('select[name="ItemId"] option').eq(1).val();
            $('select[name="ItemId"]').val(val);
            var x = setTimeout(function() {
              $('select[name="ItemId"]').trigger('change');
            }, 0);
          }

          $('input[name="ItemId"]').keydown(function(e) {
            e.stopPropagation();
            if (e.keyCode == 13) {
              $('.btn.verify').trigger('click');
              return false;
            }
          });

          $('.installment-option-label').on('click', function(e) {
            var $label = $(e.currentTarget);
            $label.closest('.installment-option-container').find('i').removeClass('fa-check').addClass('fa-user-plus')
              .closest('button')
              .css('background', '#2B91E1');
            $label.find('i').removeClass('fa-user-plus').addClass('fa-check').closest('button')
              .css('background', '#00bd44');
            var selectedInstallmentOptionId = $label.data('option-id');
            $('input[name="Options.SelectedInstallmentOptionId"]').val(selectedInstallmentOptionId);
            $modalOkButton.prop('disabled', selectedInstallmentOptionId === undefined);
          });

          $modalOkButton.prop('disabled', !window.isAdminMode);
        }
      });
    },

    displayErrorModal: function(message) {
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

      this.ui.modal
        .create({
          title: AMILIA_APP.Labels.problemOccured,
          body: message,
          cancelButtonHide: true,
          okButtonClose: true
        })
        .render();
    },

    displayInformationModal: function(message) {
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });

      this.ui.modal
        .create({
          title: 'Information',
          body: message,
          cancelButtonHide: true,
          okButtonClose: true
        })
        .render();
    },

    _updateCartInformation: function(requestData, addedType, onSuccessCallback, onFailureCallback) {
      function processCartInfo() {
        $.get(self.apiurl.getCartActivityAndSegmentIds(), function(ids) {
          var sessionSelect;
          var segmentSelect;

          if (ids.sessionIds.length) sessionSelect = ids.sessionIds.map(function(id) { return '#' + id; }).join(', ');
          if (ids.segmentIds.length) segmentSelect = ids.segmentIds.map(function(id) { return 'a[data-id="' + id + '"]'; }).join(', ');

          // reset all the buttons
          $('button.register-compact-btn, button.register-subscription-btn').removeClass('in-cart')
            .find('i').removeClass('fa-check')
            .addClass('fa-user-plus');
          $('a[data-id]').removeClass('in-cart');

          // set only those applicable
          $(sessionSelect).addClass('in-cart').find('i').removeClass('fa-user-plus')
            .addClass('fa-check');
          $(segmentSelect).addClass('in-cart');

          onSuccessCallback && onSuccessCallback();
        });
      }

      if (requestData.anyError) {
        var body;

        if (requestData.Errors) {
          body = self.generateErrorStringList(requestData.Errors);
        } else {
          body = self.generateErrorStringList([requestData.toastMessage]);
        }

        if (requestData.ShowErrorModal) {
          self.displayErrorModal(body);
        }
        onFailureCallback && onFailureCallback(requestData);

        return;
      }

      $.post(self.apiurl.getCart(), function(result) {
        var $cartContainer = $('.cart-container');
        var $cartContent = $('#items-sub-container');

        if ($cartContent.length) {
          // if cart already contains items, just flash numbers
          $cartContainer.html(result);
          self.ui.cart.restartCountdown($('.timer-section').data('time-remaining'), $('.timer-section').data('time-to-remind'));
          for (var i = 0; i < 3; i++) {
            $('#number-of-items').fadeTo(150, 0.1).fadeTo(150, 1);
          }
        } else {
          // otherwise we are adding the first item, so show off the cart to the user
          $cartContainer.hide().html(result);
          self.ui.cart.restartCountdown($('.timer-section').data('time-remaining'), $('.timer-section').data('time-to-remind'));
          self._adjustCartHeight($('#itemsContainer'));
          $cartContainer.fadeToggle(function() {
            $('#cart-content').fadeToggle(300).delay(2000).fadeToggle(300);
          });
        }

        processCartInfo();
        $(window).scroll();

        if (window.selectedModalId) {
          $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
          $('#' + window.selectedModalId).trigger('click', { message: requestData.toastMessage || undefined });
          try {
            delete window.selectedModalId;
          } catch (e) {
            window.selectedModalId = undefined;
          }
        } else if ($('.modal.quick-registration-modal').is(':visible')) {
          $('.modal.quick-registration-modal')
            .find('.modal-body')
            .trigger('update:message', { message: requestData.toastMessage || undefined });
        } else {
          AMILIA_APP.notifyToast(AMILIA_APP.Labels.AddToCartSuccess, { large: $(window).width() > self.mobileWidth });
        }
      });
    },

    _addToOrRemoveFromCart: function(e, extras) {
      var $form = $(e.target);
      var checkForMandatoryMemberships = $form.hasClass('haveToCheck')
        || $form.hasClass('haveToCheckSubscriptions')
        || (extras && extras.mustAlsoBuyMembership);
      var removeFromCart = $form.find('button').hasClass('in-cart');
      var id = $form.find('button').first().attr('data-id');
      var isQuickRegModal = !!$form.closest('.quick-registration-modal').length;
      var isPassOnly = $form.hasClass('isPassOnly');

      if (removeFromCart) {
        e.preventDefault();
        $.ajax({
          url: self.apiurl.purchase() + "?itemId=" + id,
          type: 'DELETE'
        }).done(function(cart) {
          if (!cart.HasItem) self.ui.cart.destroyCart(true);
        });
        return false;
      }

      if (isQuickRegModal) window.selectedModalId = $form.find('[name="itemId"]').val();

      if (isPassOnly) { return self._checkMandatoryMultiPass.apply(this, arguments); }

      if (checkForMandatoryMemberships) { return self._checkMandatoryMemberships.apply(this, arguments); }

      return self._addToCart.apply(this, arguments);
    },

    _onInstallmentOptionSettingChange: function (e) {
      var $selectedOption = $('option:selected', this);
      var pricePerInstallment = $selectedOption.data('price');
      var modelId = $selectedOption.data('model-id');
      var installmentId = $selectedOption.data('options-id');
      var $priceElement = $('.store-membership-price-' + modelId);

      $('.' + e.currentTarget.id + ' input[name="Options.SelectedInstallmentOptionId"]').val(installmentId);
      $priceElement.html(pricePerInstallment);
      $priceElement.append('<div class="membership-price-details"> ' + AMILIA_APP.Labels.Per + ' ' + AMILIA_APP.Labels.Installment.toLowerCase() + '</div>');
   },

    _addToCart: function(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback, continueIfAccountIsAlreadySet) {
      e.preventDefault();
      extras = extras || {};
      var transactionType = e.data && e.data.transType || '';
      var $target = $(e.currentTarget);
      var $form = $target.closest('form');

      var storedEvent = {
        data: e.data,
        currentTarget: e.currentTarget
      };

      if (!AMILIA_APP.allowsOnlineRegistrations) {
        new Backbone.OnlineTransactionsNotAvailableModalView().render();
        updateQuickRegisterIdInQueryString(undefined);
        return;
      }

      if (!AMILIA_APP.isLoggedIn) {
        new Backbone.AuthenticationModalView({ url: AMILIA_APP.LoginUrl + '?ReturnUrl=' + encodeURIComponent(window.location.href) })
          .on('close', function() { window.location.reload(); })
          .render();
        scrollToTop();
        return;
      }

      if (AMILIA_APP.hasToSetupAccount) {
        var setUpAccountCallback;
        if (e.currentTarget === $('.addDonationToCart')[0]) { // hackish callback assignement for donations
          setUpAccountCallback = self._addToCartAfterChecks.bind(self, e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback);
        } else {
          setUpAccountCallback = continueIfAccountIsAlreadySet
            ? self._addToCartAfterChecks.bind(self, e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback)
            : undefined;
        }

        setUpAccount(setUpAccountCallback);
        return;
      }

      if (transactionType === 'merchandise') {
        if (AMILIA_APP.StoreResident.merchandise.shouldShowAddressValidationModal($form)) {
          var genuinePersonId = AMILIA_APP.StoreResident.merchandise.getSelectedGenuinePersonId($form);
          var merchId = AMILIA_APP.StoreResident.merchandise.getMerchandiseId();

          AMILIA_APP.StoreResident.handleResidenciesCheckForPromo(e, {
            id: merchId,
            type: transactionType,
            genuinePersonId: genuinePersonId,
            done: function () {
              self._addToCartAfterChecks(storedEvent, extras, defaultPostParameters, onSuccessCallback, onFailureCallback);
            }
          });
          return;
        }
      }
      self._addToCartAfterChecks(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback);
    },

    _addToCartAfterChecks: function(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback) {
      var originalData = e.data;

      if (AMILIA_APP.HasDataPrivacyConsent) {
        // hack~ish
        e.data = originalData;
        self._addToCartNextStep(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback);
      } else {
        var model = new Backbone.Model({
          HasConsentDataPrivacy: false
        });

        var dataPrivacyConsentModalView = new Backbone.DataPrivacyConsentModalView({
          model: model,
          onContinue: function(dataPrivacyConsentContinueEvent) {
            dataPrivacyConsentContinueEvent.preventDefault();

            if (!this.model.get('HasConsentDataPrivacy')) {
              dataPrivacyConsentModalView.$footer.find('.continue .fa-spinner').remove();
              return false;
            }

            $.ajax({ url: self.apiurl.getDataPrivacyConsentRootUrl(), type: 'PUT', data: { HasDataPrivacyConsent: true } })
              .done(function() {
                e.data = originalData;
                AMILIA_APP.HasDataPrivacyConsent = true;
                dataPrivacyConsentModalView.close();
                return self._addToCartNextStep(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback);
              })
              .fail(function() {
                onFailureCallback && onFailureCallback();
                self.displayErrorModal(AMILIA_APP.Labels.GenericUserError);
                scrollToTop();
              });
            return false;
          }
        })
          .on('modal:close:withoutConsent', function() {
            onFailureCallback && onFailureCallback();
          })
          .render();
        scrollToTop();
      }
    },

    _addToCartNextStep: function(e, extras, defaultPostParameters, onSuccessCallback, onFailureCallback) {
      var setAnyErrorField = function(data) {
        // this is to handle the inconsistent response from cartitem, fix this later.
        data.anyError = data.success === false || data.Success === false || data.Errors;
      };

      // currentTarget here, to retrieve the form submitted
      var ctarg = $(e.currentTarget);

      var $submitButton = ctarg.find('[type=submit]').length
        ? ctarg.find('[type=submit]')
        : ctarg.find('.compact-submit');

      var createNewPersonForOrg = ctarg.find('input[name="Options.CreateNewPersonForOrg"]').val() == 'true';

      // the form will be serialized according to the memberships requirements (any or all)
      var formSerialized;

      var addMandatoryItems = function(mandatoryItems) {
        if (_.isArray(mandatoryItems) && !_.isEmpty(mandatoryItems)) {
          _.each(mandatoryItems, function(childId) {
            formSerialized += '&MandatoryChildItems=' + childId;
          });
        }
      };

      // if required membership IDs were passed

      // check if all memberships are required, serialize in an array
      var allMembershipsRequiredForms = extras.mandatoryMembershipForms;
      var extraMandatoryChildItems = extras.MandatoryChildItems || [];
      var mandatoryChildItems = [];

      $('input[name="MandatoryChildItems"]').each(function() {
        mandatoryChildItems.push(this.value);
      });

      extras.MandatoryChildItems = extraMandatoryChildItems.concat(mandatoryChildItems);

      if (allMembershipsRequiredForms !== undefined && allMembershipsRequiredForms.length > 1) {
        var formArray = [];

        var addToQueue = function() {
          formArray.push($(this));
        };

        allMembershipsRequiredForms.each(addToQueue);
        formArray.push(ctarg);

        formSerialized = [];
        _.each(formArray, function(el) {
          formSerialized.push($(el).serializeArray().reduce(function(m, o) {
            m[o.name] = o.value;
            return m;
          }, {}));
        });
      } else { // otherwise simple string serialization
        formSerialized = ctarg.serialize(); // here ctarg.serialize gives an empty string... add the mandatory items in extras.MandatoryChildItems instead?? TODO
        addMandatoryItems(extras.MandatoryChildItems);

        if (ctarg.find('#product-person').length) {
          createNewPersonForOrg = ctarg.find('#product-person').find(':selected').attr('data-create-new-person') == 'true';
          var genuinePersonId = ctarg.find('#product-person').find(':selected').attr('data-gp-id');

          formSerialized += '&Options.CreateNewPersonForOrg=' + createNewPersonForOrg;
          if (genuinePersonId) {
            formSerialized += '&Options.GenuinePersonId=' + genuinePersonId;
          }
        }

        // if there is a subscription ID to add and it's not already in the parameters
        var subscriptionIdNotInParameters = formSerialized.indexOf('Options.SelectedMembership=' + extras.subscriptionIdToAdd) === -1;
        if (extras.subscriptionIdToAdd && subscriptionIdNotInParameters) {
          // turn into an array, we will need to call the plural AddCartItems instead of AddCartItem
          formSerialized = [];
          formSerialized.push((ctarg).serializeArray().reduce(function (m, o) {
            m[o.name] = o.value;
            return m;
          }, {}));
        }
      }

      // prepend the Subscription to the cart items sent to BE
      if (extras.subscriptionIdToAdd && Array.isArray(formSerialized)) {
        var subscriptionCartItem = {
          itemType: 'Membership',
          isRemovable: 'false',
          isChildItem: 'true',
          itemId: extras.subscriptionIdToAdd,
          'Options.IsRecurringBilling': 'true',
          'Options.PersonId': formSerialized[0]['Options.PersonId'],
          'Options.GenuinePersonId': formSerialized[0]['Options.GenuinePersonId']
        };
        formSerialized.unshift(subscriptionCartItem);

        // add it in ctarg too, this is where we will take it from if there are required products later
        ctarg.subscriptionIdToAdd = extras.subscriptionIdToAdd;
      }

      var hasRequiredProducts = extras.hasRequiredProducts || ctarg.hasClass('hasRequiredProducts');
      var mandatoryMembershipForms = extras.mandatoryMembershipForms || [];
      var currentId = extras.activityId || ctarg.find('input[name="itemId"]').val();
      var requiredCheckType = extras.itemType || ctarg.find('input[name="itemType"]').val();
      var personId = parseInt(ctarg.find('input[name="Options.PersonId"]').val(), 10);
      if (!personId) {
        personId = parseInt(ctarg.find('input[name="Options.GenuinePersonId"]').val(), 10);
      }
      if (!personId) {
        personId = parseInt(ctarg.find('select[name="Options.PersonId"]').val(), 10);
      }
      var addedType = e.data && e.data.transType ? e.data.transType : '';
      var formModels = [];

      // when the request fails due to an error (status code != 2xx)
      var addRequestError = function(data) {
        this.displayErrorModal(AMILIA_APP.Labels.AddItemToCartError);
        onFailureCallback && onFailureCallback();
      };

      // when a response has been received and the status code in the 2xx range
      // the item might not have been added to the cart as the response has its own success flag.
      var addRequestSuccess = function(data) {
        self.ui.waitingIndicator.killAll();

        $submitButton.attr({
          'data-id': data.id,
          'data-orgurl': data.orgUrl
        });
        var $form = $submitButton.closest('.an-activity');
        if (!$form.length) $form = $submitButton.closest('.formRegister-activity,.formRegister-membership');

        $form
          .find('button')
          .addClass('in-cart')
          .attr('title', AMILIA_APP.Labels.RegisterRemovePersonFromCart)
          .prop('disabled', false)
          .find('i')
          .removeClass('fa-plus fa-spinner fa-spin')
          .addClass('fa-check')
          .end()
          .closest('.pass-container')
          .find('button')
          .not('.in-cart')
          .prop('disabled', true)
          .find('i')
          .removeClass('fa-user-plus')
          .addClass('fa-ban');


        if (addedType === 'merchandise') {
          $submitButton.prop('disabled', false);
          $('input#donationAmount').val('').trigger('blur');

          if (data.success === false) {
            AMILIA_APP.notifyToast(data.toastMessage, {
              color: '#494949', large: false, wait: 5000, symbolClasses: 'fa fa-exclamation-triangle'
            });
            return;
          }
        }

        if (addedType === 'membership') {
          $submitButton.addClass('original-button');
        }

        // Add item to cart unless it is from another organization
        data.OrgHasChanged ? self._orgChangeControl(data) : self._updateCartInformation(data, addedType, onSuccessCallback, onFailureCallback);
      };

      var getPurchaseUrl = function(itemType, isMultiple) {
        if (itemType === 'GiftCard') return self.apiurl.purchaseGiftCard();

        return isMultiple ? self.apiurl.purchaseMultiple() : self.apiurl.purchase();
      };

      var postAddToCart = function (postParameters, doneCallback, alwaysCallback) {
        var isMultiple = Array.isArray(postParameters) || Array.isArray(defaultPostParameters);
        var dataToPost = postParameters || defaultPostParameters;
        var params = isMultiple ? $.param({ models: dataToPost }) : dataToPost;

        var purchaseUrl = getPurchaseUrl(dataToPost.ItemType, isMultiple);

        $.post(purchaseUrl, params)
          .always(function (response) {
            alwaysCallback && alwaysCallback(response);
          })
          .done(setAnyErrorField)
          .done(addRequestSuccess)
          .done(function(response) {
            doneCallback && doneCallback(response);
          })
          .fail(_.bind(addRequestError, self));
      };

      var prodRequestSuccess = function (data) {
        if (data.ShowModal === 'false') {
          addMandatoryItems(data.MandatoryChildItems);

          postAddToCart(
            formSerialized,
            null,
            function() {
              if (createNewPersonForOrg) window.location.reload();
            }
          );

          return;
        }

        // prevent stack overflow in IE 8 due to competing modal focusin propagation
        // see: https://github.com/twbs/bootstrap/issues/4781
        $('.modal, .modal-backdrop').each(function () { $(this).remove(); });

        var removeableStatusItems = $(data).find('input[name="IsRemovable"]')
          .map(function (idx, x) { return $(x).attr('value') == 'true'; });

        var anyMandatoryItems = _.any(removeableStatusItems, function(x) { return x === false; });

        var title = anyMandatoryItems
          ? AMILIA_APP.Labels.MandatoryProducts
          : AMILIA_APP.Labels.NonMandatoryProducts;

        var options = {
          title: title,
          body: data,
          buttons: [{
            label: AMILIA_APP.Labels.cancel,
            className: 'cancel btn-special',
            close: true,
            href: document.URL
          }, {
            label: AMILIA_APP.Labels.continueOn,
            className: 'ok btn-primary',
            href: document.URL
          }],
          customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
          onOk: function () {
            var $modalSubmit = modalView.$el.find('.ok');
            var addToQueue = function() {
              formModels.push($(this));
            };

            self.ui.waitingIndicator.prependToItem($modalSubmit);
            $modalSubmit.prop('disabled', true);

            $('input.switch-checkbox:checked').closest('form').each(addToQueue);
            $('.formAdd-reqProducts.noHaveToCheck.mandatory-product').each(addToQueue);
            if (mandatoryMembershipForms && mandatoryMembershipForms.length) {
              mandatoryMembershipForms.each(addToQueue);
            }
            formModels.push(ctarg);

            var formData = [];
            _.each(formModels, function(el, ix) {
              formData.push($(el).serializeArray().reduce(function(m, o) {
                m[o.name] = o.value;
                return m;
              }, {}));
            });

            if (ctarg.subscriptionIdToAdd) {
              var subscriptionCartItem = {
                itemType: 'Membership',
                isRemovable: 'false',
                isChildItem: 'true',
                itemId: ctarg.subscriptionIdToAdd,
                'Options.IsRecurringBilling': 'true',
                'Options.PersonId': formData[formData.length - 1]['Options.PersonId'],
                'Options.GenuinePersonId': formData[formData.length - 1]['Options.GenuinePersonId']
              };
              formData.unshift(subscriptionCartItem);
            }

            postAddToCart(
              formData,
              function() {
                modalView.close();
              }
            );
          },
          onCancel: function() {
            $submitButton.prop('checked', false);
            returnToQuickRegistration();
          },
          onHidden: function() {
            self.ui.waitingIndicator.killAll();
            returnToQuickRegistration();
          },
          onSecondary: function() {
            modalView.close();

            postAddToCart(formSerialized);
          }
        };

        if (window.isAdminMode && AMILIA_APP.canAdminOverrideAtCheckout) {
          options.buttons.unshift({
            label: AMILIA_APP.Labels.SkipAndContinue,
            className: 'secondary btn-warning',
            close: true,
            href: document.URL
          });
        }

        var modalView = self.ui.modal.create(options).render();
        var installmentDivs = $('.installment-option-choice');
        if (installmentDivs.length > 0) {
          var disableOkButton = false;
          $.each(installmentDivs, function(index, elem) {
            if ($(elem).data('is-mandatory') === 'True') {
              disableOkButton = true;
            }
          });
          modalView.$el.find('button.ok').prop('disabled', disableOkButton);
        }
        if (modalView.$el.find('.amilia-error.block-required').length) modalView.$el.find('button.ok').prop('disabled', true);
        if (modalView.$el.find('.amilia-error.admin-block-bypass').length) modalView.$el.find('button.ok').removeClass('btn-primary').addClass('btn-warning');
      };

      if (!$submitButton.hasClass('compact-submit')) self.ui.waitingIndicator.prependToItem($submitButton);

      if (hasRequiredProducts) {
        var requiredCheckTypeLower = requiredCheckType.toLowerCase();
        if (requiredCheckTypeLower === 'activity') $.post(self.apiurl.checkActivityProducts(), { activityId: currentId, personId: personId, isGenuinePerson: createNewPersonForOrg }, prodRequestSuccess);
        if (requiredCheckTypeLower === 'activitysegment') {
          var selectedMembershipId = parseInt(ctarg.find('[name="Options.SelectedMembership"]').find(':selected').val(), 10) || null;
          $.post(self.apiurl.checkSegmentProducts(), {
            segmentId: currentId,
            personId: personId,
            isGenuinePerson: createNewPersonForOrg,
            linkedMembershipId: selectedMembershipId
          }, prodRequestSuccess);
        }
        if (requiredCheckTypeLower === 'membership') $.post(self.apiurl.checkMembershipProducts(), { membershipId: currentId, personId: personId, isGenuinePerson: createNewPersonForOrg }, prodRequestSuccess);
        if (requiredCheckTypeLower === 'product') $.post(self.apiurl.checkProductProducts(), { productId: currentId, personId: personId }, prodRequestSuccess);
      } else {
        if (!extras.hadRequiredMembership || extras.addedMandatoryMultiPass) {
          try {
            delete window.selectedModalId;
          } catch (e) {
            window.selectedModalId = undefined;
          }
        }

        if (extras.addedMandatoryMultiPass) {
          var template = _.template([
            '<p class="well well-small" style="border: 1px solid #f9645f">',
            ' <small><strong>NOTE <%=AMILIA_APP.Labels.PonctuationColon%> </strong> <%=AMILIA_APP.Labels.MultiPassPurchaseNote%> </small>',
            '</p>'
          ].join('\n'));

          var confirmModalOptions = {
            title: 'Attention',
            body: template(),
            buttons: [{
              label: AMILIA_APP.Labels.close,
              className: 'cancel btn-special',
              close: true
            }, {
              label: AMILIA_APP.Labels.Checkout,
              className: 'ok btn-primary',
              close: false
            }],
            customButtonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
            onOk: function() {
              window.location.href = self.apiurl.checkout;
            },
            onHidden: function() {
              window.location.reload();
            }
          };

          self.ui.modal.create(confirmModalOptions).render();
        }

        var data = formSerialized;
        var timeoutId = setTimeout(_.bind(_.partial(self.onLongAddToCartOperation, data), self), 5000);

        postAddToCart(
          formSerialized,
          function (response) {
            if (!response.anyError && createNewPersonForOrg && !extras.addedMandatoryMultiPass) window.location.reload();
          },
          function () {
            clearTimeout(timeoutId);
          }
        );
      }
    },

    _orgChangeControl: function(requestData) {
      $('.modal, .modal-backdrop').each(function() { $(this).remove(); });
      var message = AMILIA_APP.Labels.StoreChangeDescription1
        + requestData.OrgOldName
        + AMILIA_APP.Labels.StoreChangeDescription2
        + AMILIA_APP.Labels.StoreChangeDescription3.replace('{0}', requestData.OrgOldName);

      var modalOptions = {
        title: AMILIA_APP.Labels.StoreChangeTitle,
        body: message,
        buttons: [{
          label: AMILIA_APP.Labels.cancel,
          className: 'cancel',
          close: true,
          href: document.URL
        }, {
          label: AMILIA_APP.Labels.StoreChangeDestroy,
          className: 'secondary btnSet3 btn-special',
          close: true,
          href: document.URL
        }, {
          label: AMILIA_APP.Labels.StoreChangeGoBack,
          className: 'ok btnSet3 btn-primary',
          close: true,
          href: document.URL
        }],
        onSecondary: function() {
          self.ui.cart.destroyCart(true);
        },
        onOk: function() { window.location.href = '/store/' + culture + '/' + requestData.OrgOldRewriteUrl + '/shop/'; }
      };

      modalView = self.ui.modal
        .create(modalOptions)
        .render();
    },

    _removeItemFromCart: function(eventOrTarget, quickRemove) {

      // accessibility - only consider Enter key here
      if (eventOrTarget && eventOrTarget.type === 'keydown' && eventOrTarget.keyCode !== 13) return;

      var target = eventOrTarget && eventOrTarget.currentTarget || eventOrTarget;
      var $this = $(target);
      var id = $this.data('id');

      var isLoading = $this.find('i').hasClass('fa-spinner fa-spin');
      if (!quickRemove && !isLoading) self.appendSpinner(eventOrTarget);

      var req = $.ajax({
        url: self.apiurl.purchase() + "?itemId=" + id,
        type: 'DELETE'
      });

      req.success(function(cart) {
        if (!cart.HasItem) self.ui.cart.destroyCart(false);

        if (quickRemove) {
          self._updateCartInformation({ toastMessage: AMILIA_APP.Labels.RemoveFromCartSuccess });
          $this.prop('disabled', false);
          $this.find('i').removeClass('fa-spinner fa-spin').addClass('fa-user-plus');

          // special icon switching for multipass and subscriptions
          $this.closest('.pass-container')
            .find('button').prop('disabled', false).end()
            .find('button:not(".multi-pass")')
            .removeAttr('data-id data-orgurl')
            .find('i.fa-ban')
            .removeClass('fa-ban')
            .addClass('fa-user-plus');

          $this.removeAttr('data-id data-orgurl');
          $this.removeData();
        } else {
          window.location.reload();
        }
      });
    },

    _toggleCartVisibility: function(e) {

      // accessibility - Only consider Enter key here
      if (e && e.type === 'keydown' && e.keyCode !== 13) return;

      var $cartContents = $('#cart-content');

      self._adjustCartHeight($('#itemsContainer'));

      $cartContents.fadeToggle(300, function() {
        $('body').unbind('click');

        // accessibility - update aria-expanded
        $('.cart-section').attr('aria-expanded', $cartContents.is(':visible'));

        if ($cartContents.is(':visible')) {
          if (AMILIA_APP.checkFeature.hasTouchEvents()) $('body').css({ cursor: 'pointer', '-webkit-tap-highlight-color': 'rgba(0, 0, 0, 0)' });
          $('body').click(function(e) {
            if ($(e.target).closest('.cart-container').length === 0) {
              $cartContents.fadeOut(300);
              $('body').unbind('click');
              if (AMILIA_APP.checkFeature.hasTouchEvents()) $('body').css('cursor', 'initial');

              // accessibility - update aria-expanded
              $('.cart-section').attr('aria-expanded', false);
            }
          });
        }
      });
    },

    _adjustCartHeight: function(cart) {
      var desiredHeight = Math.round($(window).height() * 0.75) - 92;
      cart.css({ 'max-height': desiredHeight < 228 ? '228px' : desiredHeight + 'px' });
    },

    _tryPasswordForProtectProgram: function(e) {
      e.preventDefault();

      var formSerialized = $(this).serializeArray();
      var programId = $(this).data('program-id');

      var scCallback = function(data) {
        self.ui.waitingIndicator.kill(modalView.$el.find('.ok '));
        if (data.message == 1) {
          modalView.$el.find('input[type="password"][name="password"]').focus();
          modalView.$el.find('.amilia-error').text(data.messageString).show();
        } else {
          modalView.$el.find('.amilia-error').hide();
          modalView.close();
          $('.tab-container').empty().append(data).show();
        }
      };

      var reqOpt = {
        type: 'POST',
        url: self.apiurl.tryProgramPassword(programId),
        data: {
          programId: programId,
          password: formSerialized[0].value
        },
        success: scCallback
      };

      var req = $.ajax(reqOpt);
    },

    displayDonationAmount: function(e) {
      var action = e.type;
      var currentValue = $(e.currentTarget).val();
      var $button = $(e.currentTarget).closest('form').find('button[type="submit"]');

      if (currentValue.charAt(0) === '0') {
        $(this).val('');
      }
      if (action === 'keyup') $button.prop('disabled', !currentValue.length);
      if (action === 'focusin') $(e.currentTarget).val(currentValue);
      if (action === 'focusout') {
        $('input#donationAmountNumber').val(currentValue);
        $button.prop('disabled', !currentValue.length);
        currentValue.length ? $(e.currentTarget).val(currentValue) : $(e.currentTarget).val('');
      }
    },

    onLongAddToCartOperation: function() {
      var message = 'Adding item to cart still was not complete after 5000ms from the POV of the client';
      // prod has it, others env dont.
      /* eslint-disable */
      if (window.newrelic) {
        window.newRelic.noticeError(message);
      } else if(window.NREUM) {
        window.NREUM.noticeError(message);
      } else {
        console.error(message);
      }
      /* eslint-enable */
    },

    onFamilyMembershipAddedToCart: function() {
      var addToCartButton = $('.addFamilyMembershipToCartForm button[type="submit"]');
      addToCartButton.addClass('cursor-not-allowed')
        .prop('title', AMILIA_APP.Labels.AddToCartSuccess)
        .prop('disabled', 'disabled');
    },

    preventChars: function() {
      var input = $(this);
      var oldVal = input.val();
      var regex = new RegExp('^\\d+([\\.,]\\d{0,2})?$', 'gi');

      setTimeout(function() {
        var newVal = input.val();
        if (!regex.test(newVal)) {
          input.val(oldVal);
        }
      }, 0);
    },

    navigateBack: function(e) {
      e.preventDefault();
      window.history.back();
    },

    appendSpinner: function(eventOrTarget) {
      var target = eventOrTarget && eventOrTarget.currentTarget || eventOrTarget;
      var $button = $(target);
      self.ui.waitingIndicator.prependToItem($button);
    },

    moduleEditClick: function(e) {
      e.preventDefault();
      window.location = $(e.currentTarget).data('url');
    },

    // TODO: ActivitySearch to remove
    _synchActivitySearch: function(e) {
      e.preventDefault();
      var $target = $(e.currentTarget);
      if ($target.hasClass('disabled')) {
        return;
      }

      $target.addClass('disabled');

      // TODO: remove if not use
      $.post(self.apiurl.getActivitySync(), null, function(resp) {
        if (resp) {
          alert('Sync complete');
        }
        $target.removeClass('disabled');
      });
    },

    _toggleDescription: function(e) {
      var $target = $(e.target);
      if ($target.is('a') && $target[0].attributes.href != null && $target[0].attributes.href.nodeValue.search('http') > -1) {
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      var currentDiv = $(e.currentTarget);
      currentDiv.hide();
      if (currentDiv.hasClass('description-short')) {
        currentDiv.next().show();
      } else {
        currentDiv.prev().show();
      }
    },

    _toggleActivityScheduleList: function(e) {
      e.preventDefault();
      $(e.target).parent().children('.toggle-less').toggle();
      $(e.target).parent().children('.toggle-more').toggle();
      $(e.target).parent().siblings('.activity-schedule-list-container').toggle();
    },

    _onMembershipSeasonFilterChange: function (e) {
      e.preventDefault();
      var form = $(e.currentTarget).closest('form');
      form.submit();
    },

    _toggleFamilyMembershipBuyButton: function (e) {
      var $selectedOption = $('option:selected', this);
      var currentValue = $selectedOption.val();
      var modelId = $selectedOption.data('model-id');
      var fullPrice = $selectedOption.data('price-info');
      var formsClass = e.currentTarget.name;
      var formToShowSelector = '.' + currentValue;
      var paymentOptionsSelector = '#add-to-cart-pay-in-installments-' + modelId;

      if (/add-to-cart-pay-in-installments/.test(currentValue)) {
        $(paymentOptionsSelector).show();
      } else {
        $(paymentOptionsSelector).hide();
        // show full price
        $('.store-membership-price-' + modelId).html(fullPrice);
      }

      $('form.' + formsClass + formToShowSelector).toggleClass('d-none');
      $('form.' + formsClass + ':not(' + formToShowSelector + ')').toggleClass('d-none');
    }
  });

  $(document).ready(function () {
    if ($('.search-membership-form').length > 0) {
      self._searchMemberships();
    }

    $('.store-program-result__image-container').each(function() {
      var $container = $(this);
      var $image = $container.find('img');
      var pictureId = $image.data('pictureId');
      var $programAdminEditButton = $container.find('.js-store-program-admin-edit');

      if (pictureId) {
        $.post('/Ws/Download/Secure', { id: pictureId }).done(function(resp) {
          $image.attr('src', resp);
          $container.addClass('active');
        });
      }

      if ($programAdminEditButton.length) {
        $programAdminEditButton.show();

        $programAdminEditButton.on('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.open($(this).data('href'), '_blank');
        });
      }
    });

    // for store redesign
    $('.program-info-container').each(function() {
      var $container = $(this);
      var $programAdminEditButton = $container.find('.js-store-program-admin-edit');

      if ($programAdminEditButton.length) {
        $programAdminEditButton.show();

        $programAdminEditButton.on('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.open($(this).data('href'), '_blank');
        });
      }
    });
  });
}).call(this);
;
(function() {
  Backform.GenderControl = Backform.SelectControl.extend({
    defaults: {
      options: [
        { label: AMILIA_APP.Labels.NotSpecified, value: 1 },
        { label: AMILIA_APP.Labels.Male, value: 2 },
        { label: AMILIA_APP.Labels.Female, value: 4 },
        { label: AMILIA_APP.Labels.PreferNotToSay, value: 8 }
      ]
    },
    template: _.template([
      '<label class="<%=Backform.controlLabelClassName%>"><%-label%></label>',
      '<div class="<%=Backform.controlsClassName%>">',
      '  <select class="input-small" name="<%=name%>" value="<%-value%>" <%=disabled ? "disabled" : ""%> <%=required ? "required" : ""%> style="width:auto;">',
      '    <% for (var i=0; i < options.length; i++) { %>',
      '      <% var option = options[i]; %>',
      '      <option value="<%-option.value%>" <%=option.value == value ? "selected=\'selected\'" : ""%>><%-option.label%></option>',
      '    <% } %>',
      '  </select>',
      '</div>'
    ].join('\n'))
  });

  var PersonFormModalFields = [
    {
      name: 'FirstName',
      label: AMILIA_APP.Labels.FirstName,
      control: 'input',
      required: true
    }, {
      name: 'LastName',
      label: AMILIA_APP.Labels.LastName,
      control: 'input',
      required: true
    }, {
      name: 'Gender',
      label: AMILIA_APP.Labels.Gender,
      control: Backform.GenderControl
    }, {
      name: 'AgeType',
      control: 'radio',
      required: true,
      options: [
        {
          value: 1,
          label: AMILIA_APP.Labels.Child
        }, {
          value: 0,
          label: AMILIA_APP.Labels.Adult
        }
      ]
    }, {
      name: 'DateOfBirth',
      label: AMILIA_APP.Labels.DateOfBirth,
      control: Backform.BirthdayControl
    }
  ];

  var PersonFormModal = Backbone.BackformModal.extend({
    className: 'modal backbone-modal modal-set-1 add-person-modal',
    buttonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
    isDuplicate: false,
    fields: PersonFormModalFields,
    buttons: [{
      className: 'cancel btn-special',
      label: AMILIA_APP.Labels.cancel,
      close: true
    }, {
      className: 'continue btn-primary',
      label: AMILIA_APP.Labels.Save
    }],
    postRender: function() {
      if (!this.model.get('ShowGender')) {
        this.fields = _.reject(this.fields, function(f) { return f.name === 'Gender'; });
      }

      Backbone.BackformModal.prototype.postRender.apply(this, arguments);

      function updateQueryString(query) {
        var queryString = $.param(query);
        if (queryString.length) queryString = '?' + queryString;
        var uri = window.location.pathname + queryString;
        window.history.replaceState(undefined, undefined, uri);
      }

      function updateNewPersonIdInQueryString(value) {
        if (typeof window.history.pushState !== 'undefined') {
          var query = $.parseParams(window.location.href);
          if (value === undefined) delete query.newPersonId;
          else query.newPersonId = value;
          updateQueryString(query);
        }
      }

      var model = this.model;
      if ((model.get('IsGenuine') === true || model.get('IsGenuine') == 'true') && !isNaN(model.get('GenuinePersonId'))) {
        model.set('Id', model.get('GenuinePersonId'));
      }
      this.buttonView = new Backbone.ButtonView({
        el: this.$footer.find('.continue'),
        text: AMILIA_APP.Labels.Save,
        busyText: AMILIA_APP.Labels.PleaseWait,
        click: function(e, button) {
          model.save()
            .fail(button.ajaxFail)
            .done(function(resp, statusText, xhr) {
              if (resp && resp.newPersonId) {
                updateNewPersonIdInQueryString(resp.newPersonId);
                button.reset.apply(this, arguments);
                button.success.call(this, xhr.statusText, 200, function() {
                  window.location.reload();
                });
              } else {
                button.ajaxSuccessReload.apply(this, arguments);
              }
            });
        }
      });
      this.buttonView.render();

      return this;
    }
  });

  Backbone.ArchivedPersonModel = Backbone.Model.extend({
    idAttribute: 'PersonId'
  });

  Backbone.ArchivedPersonCollection = Backbone.Collection.extend({
    model: Backbone.ArchivedPersonModel,
    url: AMILIA_APP.ArchivedPersonInAccountUrl
  });

  Backbone.SeparatorControl = Backform.TextOnlyControl.extend({
    template: _.template([
      '<hr />'
    ].join('\n'))
  });

  Backbone.FullRowTextOnlyControl = Backform.TextOnlyControl.extend({
    template: _.template([
      '<div>',
      '  <span><a class="changeState" href="#"><%=label%></a> <i class="fa <%=caretClass%>" aria-hidden="true" style="color:#2B91E1;"></i></span>',
      '</div>'
    ].join('\n'))
  });

  Backbone.UnarchiveControl = Backform.TextOnlyControl.extend({
    initialize: function() {
      Backform.TextOnlyControl.prototype.initialize.apply(this, arguments);
      _.bindAll(this, 'handleUnarchiveAndReloadPage');
    },
    template: _.template([
      '<label class="<%=Backform.controlLabelClassName%>"><%=label%></label>',
      '<div class="<%=Backform.controlsClassName%>">',
      '   <button class="btn btnSet3 btn-outline-secondary unarchive" style="margin-left: 160px;">',
      '     <span><i class="fa fa-archive" aria-hidden="true"></i>&nbsp;<%=controlLabel%></span>',
      '   </button>',
      '</div>'
    ].join('\n')),
    events: {
      'click .unarchive': 'handleUnarchiveAndReloadPage'
    },
    handleUnarchiveAndReloadPage: function(e) {
      e.preventDefault();
      var postUrl = this.field.get('unarchiveUrl');
      $.post(postUrl)
        .done(function() {
          window.location.reload();
        });
    }
  });

  Backbone.BackbonePersonAddAndUnarchiveModalView = PersonFormModal.extend({
    initialize: function(options) {
      Backbone.BackformModal.prototype.initialize.apply(this, arguments);
      if (options.collection === undefined) {
        this.collection = new Backbone.Collection();
      }
      this.state = 'collapsed';
      _.bindAll(this, 'changeState');
    },
    changeState: function() {
      if (this.state === 'collapsed') {
        this.state = 'expanded';
      } else {
        this.state = 'collapsed';
      }
      this.render();
    },
    events: {
      'click .changeState': 'changeState'
    },
    buildUnarchivedActionsControls: function() {
      if (this.collection.length === 0) {
        return [];
      }
      return _.map(this.collection.models, function(item) {
        var id = item.get('PersonId');
        return {
          controlLabel: AMILIA_APP.Labels.Unarchive,
          name: 'PersonId:' + id,
          control: Backbone.UnarchiveControl,
          label: item.get('FullName'),
          unarchiveUrl: item.get('UnarchiveUrl')
        };
      });
    },
    createViewArchived: function() {
      if (this.collection.length === 0) {
        return [];
      }

      var caret;
      if (this.state === 'collapsed') {
        caret = 'fa-caret-right';
      } else {
        caret = 'fa-caret-down';
      }
      return [{
        control: Backbone.SeparatorControl,
        name: 'separator'
      }, {
        name: 'FakeLink',
        control: Backbone.FullRowTextOnlyControl,
        label: AMILIA_APP.Labels.UnarchiveList,
        caretClass: caret
      }];
    },
    postRender: function() {
      var shownFields = PersonFormModalFields.concat(this.createViewArchived());
      if (this.state === 'expanded') {
        shownFields = shownFields.concat(this.buildUnarchivedActionsControls());
      }
      this.fields = shownFields;
      PersonFormModal.prototype.postRender.apply(this, arguments);
    }
  });

  // Person in account
  Backbone.PersonModel = Backbone.ModelWithState.extend({
    urlRoot: AMILIA_APP.PersonInAccountUrl,
    idAttribute: 'Id',
    defaults: {
      AgeType: 0, // adult=0, child=1
      FirstName: null,
      LastName: null,
      Gender: 1,
      DateOfBirth: null,
      IAm18: false,
      IsGenuine: false
    }
  });

  Backbone.AddPersonFormModal = PersonFormModal.extend({
    title: '<h3>' + AMILIA_APP.Labels.AddPersonToAccount + '</h3>'
  });

  Backbone.ModifyPersonFormModal = PersonFormModal.extend({
    title: '<h3>' + AMILIA_APP.Labels.ModifyPersonInAccount + '</h3>'
  });

  // Person as account owner
  Backbone.PersonAccountModel = Backbone.PersonModel.extend({
    url: AMILIA_APP.NewPersonAccountUrl
  });

  Backbone.PersonAccountFormModal = PersonFormModal.extend({
    title: '<h3>' + AMILIA_APP.Labels.AccountCreateNewPerson + '</h3>',
    fields: (function() {
      var fields = [{
        name: 'IAm18',
        label: AMILIA_APP.Labels.IConfirmIAm18OrHigher,
        control: 'checkbox',
        required: true
      }];

      fields.push({
        name: 'GivesConsent',
        label: AMILIA_APP.Labels.IConfirmIGiveConsent,
        control: 'checkbox',
        required: true
      });

      return _.union(PersonFormModal.prototype.fields.slice(0, -2), fields);
    }).call(),
    postRender: function() {
      PersonFormModal.prototype.postRender.apply(this, arguments);

      this.$body.prepend('<div class="alert alert-info">' + AMILIA_APP.Labels.AccountCreateSmallText + '</div>');

      this.listenTo(this.model, 'change:IAm18', this.updateButtonState);
      this.listenTo(this.model, 'change:GivesConsent', this.updateButtonState);
      this.updateButtonState();

      return this;
    },
    updateButtonState: function() {
      if (this.model.get('IAm18') && this.model.get('GivesConsent')) return this.buttonView.reset();

      return this.buttonView.disable();
    }
  });

  Backbone.SelectPersonAccountFormModal = Backbone.BackformModal.extend({
    className: 'modal backbone-modal modal-set-1 in add-person-modal',
    title: '<h3>' + AMILIA_APP.Labels.SelectAccountOwner + '</h3>',
    buttonTemplate: _.template('<button type="button" class="btn btnSet3 <%=className%>"><%=label%></button>'),
    fields: (function() {
      var fields = [{
        name: 'GenuinePersonId',
        label: AMILIA_APP.Labels.AccountOwner,
        control: Backform.SelectControl.extend({
          render: function() {
            Backform.SelectControl.prototype.render.apply(this, arguments);
            var options = '';
            _.each(this.model.get('Adults'), function(adult) {
              options += '<option value=' + adult.Id + '>' + adult.FirstName + ' ' + adult.LastName + '</option>';
            });

            this.$el.find('select').html(options);

            return this;
          }
        }),
        required: true
      }];

      fields.push({
        name: 'GivesConsent',
        label: AMILIA_APP.Labels.IConfirmIGiveConsent,
        control: 'boolean',
        required: true
      });


      return fields;
    }).call(),
    buttons: [{
      className: 'cancel btn-special',
      label: AMILIA_APP.Labels.cancel,
      close: true
    }, {
      className: 'add-person btn-primary',
      label: AMILIA_APP.Labels.AddPersonToAccount,
      close: true
    }, {
      className: 'continue btn-primary',
      label: AMILIA_APP.Labels.Save
    }],
    postRender: function() {
      Backbone.BackformModal.prototype.postRender.apply(this, arguments);
      var self = this;
      var model = this.model;

      var $genuinePersonId = self.$('select[name="GenuinePersonId"]');
      var $givesConsent = self.$('input[name="GivesConsent"]');

      $givesConsent.on('change', function(e) {
        this.updateButtonState(e);
      }.bind(this));

      this.$body.prepend('<div class="alert alert-info">' + AMILIA_APP.Labels.AccountCreateSmallText + '</div>');

      this.selectButtonView = new Backbone.ButtonView({
        el: this.$footer.find('.continue'),
        text: AMILIA_APP.Labels.Save,
        busyText: AMILIA_APP.Labels.PleaseWait,
        click: function(e, button) {
          var genuinePersonId = $genuinePersonId.val();
          var givesConsent = $givesConsent.val();

          model.save({}, {
            url: AMILIA_APP.SelectGenuinePersonAccountUrl + '?genuinePersonId=' + genuinePersonId + '&givesConsent=' + givesConsent
          })
            .fail(button.ajaxFail)
            .done(function(resp, statusText, xhr) {
              if (resp && resp.newPersonId) {
                button.reset.apply(this, arguments);
                button.success.call(this, xhr.statusText, 200, function() {
                  window.location.reload();
                });
              } else {
                button.ajaxSuccessReload.apply(this, arguments);
              }
            });
        }
      });

      this.selectButtonView.render();
      this.selectButtonView.disable();

      this.addButtonView = new Backbone.ButtonView({
        el: this.$footer.find('.add-person'),
        text: AMILIA_APP.Labels.AddPersonToAccount,
        busyText: AMILIA_APP.Labels.PleaseWait,
        click: function() {
          new Backbone.PersonAccountFormModal({ model: new Backbone.PersonAccountModel() })
            .on('close', function() {
              self.trigger('close:add-person:modal');
            })
            .render();
        }
      });
      this.addButtonView.render();

      return this;
    },
    updateButtonState: function(e) {
      var $box = $(e.currentTarget);

      if ($box.is(':checked')) this.selectButtonView.reset();
      else this.selectButtonView.disable();
    }
  });

  // Use Backbone.PersonModel (same PUT url)
  Backbone.ModifyPersonAccountFormModal = PersonFormModal.extend({
    title: '<h3>' + AMILIA_APP.Labels.AccountModifyPerson + '</h3>',
    postRender: function() {
      PersonFormModal.prototype.postRender.apply(this, arguments);
      this.$body.prepend('<div class="alert alert-info">' + AMILIA_APP.Labels.AccountModifySmallText + '</div>');
      return this;
    }
  });
}).call(this);
;
(function() {
  var labels = AMILIA_APP.Labels;
  var models = {
    CorporateAccount: Backbone.ModelWithState.extend({
      url: AMILIA.Store_ns.apiurl.createCorporateAccount()
    })
  };

  Backbone.CreateNewCorporateAccountModal = Backbone.BackformModal.extend({
    initialize: function(options) {
      Backbone.BackformModal.prototype.initialize.apply(this, arguments);

      this.model = new models.CorporateAccount({
        Name: undefined,
        Email: options.Email
      });
    },

    title: labels.CreateACorporateAccount_CreateAccount,
    fields: [
      { name: 'Name', label: labels.CreateACorporateAccount_Name, control: 'input', required: true },
      { name: 'Email', label: labels.CreateACorporateAccount_Email, control: 'input', type: 'email', required: true }
    ],
    buttons: [
      { label: labels.cancel, close: true },
      { label: labels.CreateACorporateAccount_CreateAccountAction, className: 'btn btn-primary btnSet3 create-new-account-btn' }
    ],

    postRender: function() {
      Backbone.BackformModal.prototype.postRender.apply(this, arguments);

      var btn = new Backbone.ButtonView({
        el: this.$el.find('.create-new-account-btn'),
        text: labels.CreateACorporateAccount_CreateAccount,
        busyText: labels.PleaseWait,
        click: _.bind(this.onCreateNewAccountClicked, this)
      }).render();

      return this;
    },

    onCreateNewAccountClicked: function(e, button) {
      this.model.save()
        .success(function(result) {
          button.ajaxSuccess.apply(button, arguments);
          window.location = AMILIA.Store_ns.apiurl.shopWithCorporateAccount(result.UserAccountId);
        })
        .error(button.ajaxFail);
    }
  });
}());
;
(function () {
  'use strict';

  function hasAncestorWithClass(element, classname) {
    if(!element) {
      return false;
    }
    if (element.className.split(' ').indexOf(classname) >= 0) return true;
    return (
      element.parentNode && hasAncestorWithClass(element.parentNode, classname)
    );
  }

  Backbone.AuthenticationModalView = Backbone.ModalView.extend({
    template: _.template([
      '<div class="modal-header"><h3>&nbsp;</h3></div>',
      '<div class="modal-body bs-fix bs-fix-<%- AMILIA_APP.BootstrapVersion || "2" %>"><div style="text-align: center;"><i class="fa fa-3x fa-spinner fa-spin" style="color: #2B91E1;"></i></div></div>',
      '<div class="modal-footer"></div>'
    ].join('\n')),
    className: 'modal backbone-modal modal-set-1 modal-auth selenium-store-authentication-modal',
    initialize: function(options) {
      Backbone.ModalView.prototype.initialize.apply(this, arguments);
      options || (options = {});
      this.url = options.url;
      _.bindAll(this, 'replaceContentWithUrl', 'onFormLoaded', 'onFormLoadError', 'onFormSubmit', 'onFormSubmitError', 'onLnkAjaxClick');
    },
    postRender: function() {
      this.$el.hide().fadeIn('fast');
      this.$footer.remove();
      this.replaceContentWithUrl(this.url, 'login');
    },
    close: function(e) {
      if (e) e.preventDefault();
      var view = this;
      view.$el.fadeOut('fast', function() {
        view.$el.modal('hide');
        view.remove();
      });
      var accountVerifiedElt = document.getElementById('accountVerified');
      if (hasAncestorWithClass(accountVerifiedElt, 'modal-auth')) {
        window.location.reload();
      }
      this.trigger('close');
      AMILIA_APP.callReactModule('authenticationSignUp_unmount');
      AMILIA_APP.callReactModule('authenticationLogIn_unmount');
    },
    loaderTimeout: null,
    delayedLoader: function() {
      this.loaderTimeout = window.setTimeout(function() {
        this.$body.html('<div class="text-center"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16 fa-spin text-muted" style="margin-top: 40px; width: 1em;" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg></div>');
      }.bind(this), 250);
    },
    replaceContentWithUrl: function(url, action) {
      if (action === 'signup') {
        AMILIA_APP.callReactModule('authenticationLogIn_unmount');
      }
      else if (action === 'login') {
        AMILIA_APP.callReactModule('authenticationSignUp_unmount');
      }

      this.$header.find('h3').html(AMILIA_APP.Labels[action === 'login' ? 'LogIn' : 'CreateAnAccount']);
      this.delayedLoader();

      $.ajax(url, {type: 'GET', cache: false})
        .done(this.onFormLoaded.bind(this, action))
        .fail(this.onFormLoadError);
    },
    afterFormLoaded: _.debounce(function() {
      this.$el.find('.lnk-ajax').on('click', this.onLnkAjaxClick);
      this.setTopUrl();

      // need to focus first element again because we injected html in the modal
      AMILIA_APP.a11y.focusFirstElement(this.$el);
    }, 50),
    onFormLoaded: function(action, content) {
      window.clearTimeout(this.loaderTimeout);

      this.$body.html(content);
      if (action === 'signup') {
        AMILIA_APP.callReactModule('authenticationSignUp', {
          isStorePage: true,
          onReady: this.afterFormLoaded.bind(this)
        });
        return;
      }

      if (action === 'login') {
        AMILIA_APP.callReactModule('authenticationLogIn', {
          isStorePage: true,
          onReady: this.afterFormLoaded.bind(this)
        });
        return;
      }

      this.afterFormLoaded();
    },
    onFormLoadError: function(xhr, textStatus, errorThrown) {
      window.clearTimeout(this.loaderTimeout);
      this.$body.html(textStatus);
    },
    onLnkAjaxClick: function(e) {
      e.preventDefault();
      var url = $(e.target).attr('href');
      var action = $(e.target).data('action');
      this.replaceContentWithUrl(url, action);
    },
    onFormSubmit: function(e) {
      e.preventDefault();
      var data = this.$form.serialize(),
          url = this.$form.attr('action');

      $.post(url, data)
        .done(this.onFormLoaded.bind(this, 'loginSuccess'))
        .fail(this.onFormSubmitError);
    },
    onFormSubmitError: function(xhr, textStatus, errorThrown) {
      this.$body.html(textStatus);
    },
    setTopUrl: function() {
      if (!window._amiliaIframeHelper || !window._amiliaIframeHelper.isIframe()) return;

      // Set iFrame returnUrl for external logins
      window._amiliaIframeHelper.postMessageToParent('set_top_url');
    }
  });

}).call(this);;
(function() {
  'use strict';

  Backbone.DataPrivacyConsentModalView = Backbone.ModalView.extend({
    title: '<h3>' + AMILIA_APP.Labels.DataPrivacyModalHeader + '</h3>',
    className: 'modal backbone-modal modal-set-1 selenium-data-privacy-consent',
    buttons: [{
      label: AMILIA_APP.Labels.Cancel,
      className: 'cancel',
      close: true
    }, {
      label: AMILIA_APP.Labels.Continue,
      className: 'continue btn-primary',
      close: false
    }],
    initialize: function(options) {
      Backbone.ModalView.prototype.initialize.apply(this, arguments);
      this.options = options || (options = {});
      this.model = this.options.model;
      this.model.on('change:HasConsentDataPrivacy', this.toggleContinueDisabled.bind(this));
    },
    postRender: function() {
      var $bodyContent = $('<div><div class="data-privacy-text"></div><div class="data-privacy-form"></div></div>');
      var orgName = AMILIA_APP.orgName || '';

      $bodyContent
        .find('.data-privacy-text')
        .html(AMILIA_APP.Labels.DataPrivacyModalText.replace(new RegExp('{orgName}', 'g'), orgName));
      this.$body.html($bodyContent);

      new Backform.Form({
        model: this.model,
        el: this.$body.find('.data-privacy-form'),
        fields: [{
          name: 'HasConsentDataPrivacy',
          label: AMILIA_APP.Labels.DataPrivacyModalCheckboxText,
          control: 'checkbox'
        }]
      }).render();
      this.$el.modal('show');
      this.toggleContinueDisabled();
      // need to focus first element again because we injected html in the modal
      AMILIA_APP.a11y.focusFirstElement(this.$el);
    },
    close: function(e) {
      if (e) e.preventDefault();

      var view = this;
      view.$el.fadeOut('fast', function() {
        view.$el.modal('hide');
        view.remove();
      });
    },
    triggerNoConsentEvent: function(e) {
      if (e) e.preventDefault();
      this.trigger('modal:close:withoutConsent');
    },
    events: {
      'click a.continue': function(e) {
        e.preventDefault();
        typeof this.options.onContinue === 'function' && this.options.onContinue.call(this, e);
        return false;
      },
      'click a.cancel': function(e) {
        this.triggerNoConsentEvent(e);
      },
      'click button.close': function(e) {
        this.triggerNoConsentEvent(e);
      }
    },
    toggleContinueDisabled: function() {
      if (this.model.get('HasConsentDataPrivacy')) {
        this.$el.find('.btn.continue').removeClass('disabled').attr('disabled', false);
      } else {
        this.$el.find('.btn.continue').addClass('disabled').attr('disabled', true);
      }
    }
  });

}).call(this);;
(function() {
  Backbone.OnlineTransactionsNotAvailableModalView = Backbone.ModalView.extend({
    title: '<h3><%=AMILIA.Labels.OnlinePurchase%></h3>',
    body: '<div class="my-3 text-center"><%=AMILIA.Labels.OnlineTransactionsNotAvailable%></div>',
  });
}).call(this);
;
AMILIA_APP.modules.calendar = function(_calendarModel, options) {

  options = _.defaults(options || {}, {
    showFilters: true,
    defaultView: 'month',
    scrollToCalendar: false,
    isLoggedIn: false
  });

  if (window.accounting && window.accounting.settings) {
    window.accounting.settings.currency = {
      symbol: '$',
      decimal: window.culture === 'en' ? '.' : ',',
      thousand: window.culture === 'en' ? ',' : ' ',
      precision: 2,
      format: {
        pos: window.culture === 'en' ? '%s%v' : '%v %s',
        neg: window.culture === 'en' ? '%s(%v)' : '(%v) %s',
        zero: window.culture === 'en' ? '%s ---' : '--- %s'
      }
    };
  }

  Backbone.ProgramModel = Backbone.ModelWithState.extend({
    idAttribute: 'Id'
  });

  Backbone.ActivityModel = Backbone.ModelWithState.extend({
    idAttribute: 'Id'
  });

  Backbone.TagModel = Backbone.Model.extend({
    idAttribute: 'Id'
  });

  Backbone.TagCollection = Backbone.Collection.extend({
    model: Backbone.TagModel
  });

  Backbone.SelectView = Backbone.View.extend({
    template: _.template([
      '<label><%=title%></label>',
      '<select>',
      '  <% for (var i = 0; i < options.length; i++) { %>',
      '    <option value="<%=options[i].value%>" <%= value == options[i].value ? "selected=\'selected\'" : ""%> ><%=options[i].label%></option>',
      '  <% } %>',
      '</select>'
    ].join('')),
    events: {
      'change select': 'onChange'
    },
    initialize: function(options) {
      this.title = options.title;
      this.options = options.options;
      this.value = options.value;
    },
    render: function() {
      this.$el.html(this.template({
        title: this.title,
        options: this.options,
        value: this.value
      }));
      return this;
    },
    onChange: function(e) {
      this.value = parseInt(this.$('select').val(), 10);
      if (isNaN(this.value)) this.value = undefined;
      this.trigger('change', this, this.value);
    }
  });

  Backbone.CheckboxView = Backbone.View.extend({
    template: _.template([
      '<div class="row-fluid">',
      '  <div class="span12">',
      '    <label class="checkbox" style="display: inline-block">',
      '      <input type="checkbox" <%=value ? "checked=\'checked\'" : ""%> /> <%=title%>',
      '    </label>',
      '  </div>',
      '</div>'
    ].join('\n')),
    events: {
      'change input': 'onChange'
    },
    initialize: function(options) {
      this.title = options.title;
      this.value = options.value;
    },
    render: function() {
      this.$el.html(this.template({
        title: this.title,
        value: this.value
      }));
      return this;
    },
    onChange: function(e) {
      this.value = this.$el.find('input').is(':checked');
      this.trigger('change', this, this.value);
    }
  });

  Backbone.FiltersView = Backbone.View.extend({
    template: _.template([
      '<div class="category mb-3 mr-3"></div>',
      '<div class="sub-category mb-3 mr-3"></div>',
      '<div class="tags mb-3 mr-3">',
      '  <%if (showFilters) {%>',
      '    <label><%=AMILIA_APP.Labels.Tags%></label>',
      '    <select multiple="multiple"></select>',
      '  <%}%>',
      '</div>',
      '<div class="account mb-3 mr-3"></div>'
    ].join('')),
    initialize: function(options) {
      _.bindAll(this, 'categoryChanged', 'subCategoryChanged', 'onlyRegisteredChanged', 'triggerChange');
      this.tags = options.tags;
      this.program = options.program;
      this.categoryId = options.categoryId;
      this.subCategoryId = options.subCategoryId;
      this.tagIds = options.tagIds;
      this.showOnlyRegistered = options.showOnlyRegistered;
      this.showFilters = options.showFilters;
      this.isLoggedIn = options.isLoggedIn;
    },
    render: function() {
      this.$el.html(this.template({showFilters: this.showFilters}));

      this.$categoryFilter = this.$el.find('.category select');
      this.$subCategoryFilter = this.$el.find('.sub-category select');
      this.$tagsFilter = this.$el.find('.tags select');

      if (this.showFilters) {
        this.renderCategorySelect();
        this.renderTags();
      }

      this.$showOnlyRegistered = this.$el.find('.account input');
      if (this.isLoggedIn) this.renderOnlyRegistered();

      return this;
    },
    renderCategorySelect: function() {
      var options = _.map(this.program.Categories, function(o) {
        return {
          value: o.Id,
          label: o.Name
        };
      });
      options.unshift({
        value: undefined,
        label: AMILIA_APP.Labels.All
      });
      if (this.categoryView) this.stopListening(this.categoryView);
      this.categoryView = new Backbone.SelectView({
        el: this.$('.category'),
        title: AMILIA_APP.Labels.Category,
        options: options,
        value: this.categoryId
      }).render();
      this.listenTo(this.categoryView, 'change', this.categoryChanged);

      this.categoryChanged(this.categoryView, this.categoryId, false);
    },
    categoryChanged: function(view, value, resetSubCategoryId) {
      this.categoryId = value;

      if(resetSubCategoryId)
        this.subCategoryId = undefined;

      this.renderSubCategorySelect();
    },
    renderSubCategorySelect: function() {
      var category = _.findWhere(this.program.Categories, {Id: this.categoryId});
      var options = category ? _.map(category.Categories, function(o) {
        return {
          value: o.Id,
          label: o.Name
        };
      }) : [];
      options.unshift({
        value: undefined,
        label: AMILIA_APP.Labels.All
      });

      if (this.subCategoryView) this.stopListening(this.subCategoryView);
      this.subCategoryView = new Backbone.SelectView({
        el: this.$('.sub-category'),
        title: AMILIA_APP.Labels.SubCategory,
        options: options,
        value: this.subCategoryId
      }).render();
      this.listenTo(this.subCategoryView, 'change', this.subCategoryChanged);

      this.subCategoryChanged(this.subCategoryView, this.subCategoryId);

      return this;
    },
    subCategoryChanged: function(view, value) {
      this.subCategoryId = value;
      this.triggerChange();
    },
    renderTags: function() {
      var self = this;
      var tags = this.tags;
      var numberDisplayed = 5;
      var selectedIds = this.tagIds;

      this.$tagsFilter.multiselect({
        enableHTML: true,
        disableIfEmpty: true,
        maxHeight: 300,
        buttonClass: 'btn btnSet3',
        numberDisplayed: numberDisplayed,
        templates: {
          ul: '<ul class="multiselect-container dropdown-menu amilia-label-multiselect-container"></ul>'
        },
        onChange: function() {
          self.tagIds = _.map(self.$tagsFilter.val(), function(val) {
            return parseInt(val, 10);
          });
          self.triggerChange();
        },
        buttonText: function(selected, select) {
          if (!selected || !selected.length)
            return AMILIA_APP.Labels.All;

          var result = [];
          for (var i = 0; i < numberDisplayed; i++) {
            if (i >= selected.length) break;
            var tag = tags.get(parseInt($(selected[i]).val(), 10));
            result.push('<span class="label amilia-label amilia-label-' + tag.get('Color') + '">' + tag.get('Name') + '</span>');
          }

          return result.join(' ') + (selected.length <= numberDisplayed ? '' : ' ...');
        },
        optionLabel: function(el) {
          var tag = tags.get(parseInt($(el).val(), 10));
          return '<span class="label amilia-label amilia-label-' + tag.get('Color') + '">' + tag.get('Name') + '</span>';
        }
      });

      this.$tagsFilter.multiselect('dataprovider', tags.map(function(tag) {
        return _.extend(tag.toJSON(), {
          label: tag.get('Name'),
          value: tag.id,
          selected: _.indexOf(selectedIds, tag.id) != -1
        });
      }));

      return this;
    },
    renderOnlyRegistered: function() {
      if (this.onlyRegisteredView) this.stopListening(this.onlyRegisteredView);
      this.onlyRegisteredView = new Backbone.CheckboxView({
        el: this.$('.account'),
        title: AMILIA_APP.Labels.ShowOnlyMyEvents,
        value: this.showOnlyRegistered
      }).render();
      this.listenTo(this.onlyRegisteredView, 'change', this.onlyRegisteredChanged);

      this.onlyRegisteredChanged(this.onlyRegisteredView, this.showOnlyRegistered);

      return this;
    },
    onlyRegisteredChanged: function(view, value) {
      this.showOnlyRegistered = value;
      this.triggerChange();
    },
    triggerChange: function() {
      this.trigger('change', this, this.categoryId, this.subCategoryId, this.tagIds, this.showOnlyRegistered);
    }
  });

  var pageJustLoaded = true;
  var query = $.parseParams(window.location.href);
  var program = new Backbone.ProgramModel(_calendarModel.Program);
  var activity = _calendarModel.Activity ? new Backbone.ActivityModel(_calendarModel.Activity) : null;
  var firstEventStartDate = _calendarModel.StartDate;
  var today = moment();
  var tags = new Backbone.TagCollection(_calendarModel.Tags);
  var $filters = $('#filters');
  var $calendar = $('#calendar');
  var filters = undefined;

  if (options.showFilters || options.isLoggedIn) {
    filters = window.filters = new Backbone.FiltersView({
      el: $filters,
      program: _calendarModel.Program,
      tags: tags,
      categoryId: query.categoryId ? parseInt(query.categoryId, 10) : undefined,
      subCategoryId: query.subCategoryId ? parseInt(query.subCategoryId, 10) : undefined,
      tagIds: _.map(query.tagIds ? query.tagIds.split(',') : [], function(tagId) {return parseInt(tagId, 10)}),
      showOnlyRegistered: query.showOnlyRegistered ? !!query.showOnlyRegistered : undefined,
      showFilters: options.showFilters,
      isLoggedIn: options.isLoggedIn
    }).render();

    filters.on('change', function(categoryId, subCategoryId, tagIds, showOnlyRegistered) {
      $calendar.fullCalendar('refetchEvents');
    });
  }

  var userEventTemplate = _.template([
    '<div class="fc-title mb--mini">',
    '<%if (MetaData.OrgLogoUrl) {%>',
    '<img src="<%=MetaData.OrgLogoUrl%>" alt="" style="max-height: 20px; max-width: 20px;"/>',
    '<%}%>',
    '<%=title%>',
    '</div>',
    '<div class="fc-person mb--mini"><%=MetaData.GenuinePersonName%></div>',
    '<% if (!allDay) { %>',
    '  <div class="fc-time mb--mini"><%=moment(start).format(AMILIA_APP.Labels.MomentTimeFormat)%> - <%=moment(end).format(AMILIA_APP.Labels.MomentTimeFormat)%></div>',
    '<% } %>',
    '<%=MetaData.TypeIcon%>',
    '<%if(MetaData.InvoiceItemDiscriminant == \'AII\') {%>',
    '<%=AMILIA_APP.Labels.Session%>',
    '<%} else if (MetaData.InvoiceItemDiscriminant == \'SEGII\') {%>',
    '<%=AMILIA_APP.Labels.DropIn%>',
    '<%} else if (MetaData.InvoiceItemDiscriminant == \'RBII\' || MetaData.InvoiceItemDiscriminant == \'FBII\') {%>',
    '<%=AMILIA_APP.Labels.ResourceBookings%>',
    '<%}%>'
  ].join('\n'));

  var userHolidayTemplate = _.template([
    '<div class="fc-title mb--mini">',
    '<%if (OrgLogoUrl) {%>',
    '  <img src="<%=OrgLogoUrl%>" alt="" style="max-height: 20px; max-width: 20px;"/>',
    '<%}%>',
    '<%=OrgName%><br/>',
    '<strong><%=title%></strong>',
    '</div>'
  ].join('\n'));

  var bookingTemplate = _.template([
    '<div class="fc-title mb--mini">',
    '  <div class="fc-time"><%-moment(start).format(AMILIA_APP.Labels.MomentTimeFormat).replace(":00", "").replace(" 00", "")%></div>',
    '  <strong><%=title%></strong>',
    '  <% if (MetaData.Location && MetaData.Location.length) { %>',
    '    <div class="fc-subtitle"><%=MetaData.Location%></div>',
    '  <% } %>',
    '</div>'
  ].join('\n'));

  var segmentTemplate = _.template([
    '<div class="fc-title mb--mini">',
    '  <div class="fc-time"><%-moment(start).format(AMILIA_APP.Labels.MomentTimeFormat).replace(":00", "").replace(" 00", "")%></div>',
    '  <strong><%=title%></strong>',
    '</div>'
  ].join('\n'));

  var activitySegmentEventTemplate = _.template([
    '<div class="fc-title"><%=title%></div>',
    '<% if (!allDay) { %>',
    '  <div class="fc-time"><%=moment(start).format(AMILIA_APP.Labels.MomentTimeFormat)%> - <%=moment(end).format(AMILIA_APP.Labels.MomentTimeFormat)%></div>',
    '<% } %>',
    '<% if ((Location = Location || "") && Location.length) { %>',
    '  <div class="fc-subtitle"><%=Location%></div>',
    '<% } %>',
    '<div class="fc-labels">',
    '<% for (var i = 0; i < Tags.length; i++) { %>',
    '  <span title="<%=Tags[i].Name%>" class="label amilia-label amilia-label-<%=Tags[i].Color%>"><%=Tags[i].Name%></span>',
    '<% } %>',
    '</div>',
    '<% if (!HasPassed) { %>',
    '  <div class="fc-price-spots">',
    '    <% if (!HasUnlimitedSpots) { %>',
    '      <div class="fc-spots" title="<%=AMILIA_APP.Labels.SpotsAvailable%>"><%=AttendanceString%></div>',
    '    <% } %>',
    '    <% if (AlreadyInCart || AccountHasSpots) { %>',
    '      <i class="fa fa-check-square in-cart fc-mark"></i>',
    '    <% } %>',
    '    <% if (Price) { %>',
    '      <div class="fc-price">',
    '        <% if (BestPrice !== null && BestPrice !== undefined) { %> <%=window.accounting.formatMoney(BestPrice)%> - <% } %>',
    '        <%=window.accounting.formatMoney(Price)%>',
    '      </div>',
    '    <% } %>',
    '  </div>',
    '  <% if (IsAdminMode && AdminCanOverrideAtCheckout && (!HasPlaceLeft || !CanRegister)) { %>',
    '    <button class="register-admin"><i class="fa fa-plus-square"></i><%=AMILIA_APP.Labels.Register%></button>',
    '  <% } else if (CanRegister && (HasPlaceLeft || AccountHasEligiblePersonInWaitList)) { %>',
    '    <button class="register"><i class="fa fa-plus-square"></i><%=AMILIA_APP.Labels.Register%></button>',
    '  <% } else if (CanUnregister && !HasPlaceLeft) { %>',
    '    <button class="unregister"><i class="fa fa-times"></i><%=AMILIA_APP.Labels.Unregister%></button>',
    '  <% } %>',
    '  <% if (AMILIA_APP.accessModules.indexOf(\'WaitlistForDropIn\') > -1 && WaitListEnabled && !HasPlaceLeft && !AccountHasEligiblePersonInWaitList) { %>',
    '    <button class="waitlist"><i class="fa fa-clock-o fc-mark"></i><%=AMILIA_APP.Labels.WaitingList%></button>',
    '  <% } %>',
    '<% } %>'
  ].join('\n'));

  var registrationEventTemplate = _.template([
    '<div class="fc-title"><%=title%></div>',
    '<div class="fc-time"><%=moment(start).format(AMILIA_APP.Labels.MomentTimeFormat)%></div>'
  ].join('\n'));

  var holidayEventSource = window.holidayEventSource = {
    events: [],
    rendering: 'background',
    backgroundColor: '#f99'
  };
  function buildHolidayEvents(allEvents) {
    $calendar.fullCalendar('removeEventSource', holidayEventSource);

    var view = $calendar.fullCalendar('getView');
    holidayEventSource.events = _.reduce(allEvents, function(events, e) {
      if (e.Type != 'holiday') return events;

      var event = _.clone(e);

      if (view.name != 'month') {
        events.push(_.clone(e));
        event.end = moment(event.start).endOf('day');
        event.allDay = false;
      }

      events.push(event);
      return events;
    }, []);
    $calendar.fullCalendar('addEventSource', holidayEventSource);
  }

  var eventsSources = options.eventsSources || [{
    url: AMILIA_APP.EventsUrl,
    data: function() {
      return {
        programId: program.id,
        categoryId: options.showFilters ? (filters.categoryId || undefined) : undefined,
        subCategoryId: options.showFilters ? (filters.subCategoryId || undefined) : undefined,
        tagIds: options.showFilters ? (filters.tagIds.length ? filters.tagIds : undefined) : undefined,
        activityId: activity ? activity.id : undefined,
        showOnlyRegistered: options.showFilters || options.isLoggedIn ? (filters.showOnlyRegistered || undefined) : undefined
      };
    },
    success: function(data, textStatus, xhr) {
      buildHolidayEvents(data);
    },
    traditional: true
  }];

  $calendar.fullCalendar({
    locale: moment.locale(), // FC >= 3.0
    defaultView: query['view'] || (AMILIA_APP.checkFeature.mq('only screen and (max-width : 767px)') ? 'mobileListView' : options.defaultView),
    defaultDate: query['date'] || (firstEventStartDate && today.diff(firstEventStartDate) < 0 ? firstEventStartDate : today),
    lazyFetching: false,
    allDaySlot: true,
    height: 'auto',
    slotDuration: '01:00:00',
    header: {
      left: 'prev,next today',
      center: 'title',
      right: 'month,basicWeek,mobileListView'
    },
    views: {
      mobileListView: {
        type: 'mobileList',
        duration: { days: 6 },
        buttonText: AMILIA_APP.Labels.CustomListViewButtonText
      }
    },
    eventSources: eventsSources,
    eventRender: function(event, $el, view) {
      // accessibility - setting role and tabindex to make sure the <a> is focusable
      $el.attr('role', 'button');
      $el.attr('tabindex', '0');

      $el.addClass(event.Type);

      // Mobile list view
      if (view.type === 'mobileListView') {
        $el.data('dateStartTitle', event.start.format(AMILIA_APP.Labels.CustomListViewTitleFormat));
      }

      switch (event.Type) {
        case 'holiday':
          $el.attr('title', event.Description);
          break;
        case 'user-holiday':
          $el.attr('title', event.Description);
          $el.find('.fc-content').html(userHolidayTemplate(event));
          break;
        case 'registration':
        case 'pre-registration':
          $el.attr('title', event.Description);
          $el.find('.fc-content').html(registrationEventTemplate(event));
          break;
        case 'user-event':
          $el.find('.fc-content').html(userEventTemplate(event));
          break;
        case 'activity-segment':
          var hasWaitListEnabled = AMILIA_APP.accessModules.indexOf('WaitlistForDropIn') > -1 && event.WaitListEnabled;
          var eventIsFull = !event.HasPassed && !event.HasPlaceLeft && !event.AccountHasEligiblePersonInWaitList;
          var clientAlreadyRegistered = event.AlreadyInCart || (event.AccountHasSpots && !event.HasPassed);
          var clientCanRegister = (event.CanRegister && event.HasPlaceLeft) ||
            (event.CanRegister && event.AccountHasEligiblePersonInWaitList) ||
            (event.CanUnregister && event.AccountHasSpots);
          var adminCanOverride = event.IsAdminMode && event.AdminCanOverrideAtCheckout;

          $el.attr({
            title: _.uniq(_.compact([event.ActivityName, event.SubCategoryName, event.CategoryName])).join(', '),
            'data-segment-id': event.SegmentId,
            'data-activity-id': event.ActivityId
          });

          $el.find('.fc-content').html(activitySegmentEventTemplate(event));

          var labels;
          var labelsHorizontalDistance = 10;

          labels = $el.find('.fc-labels .label');
          labels.each(function minifyLabels() {
            $(this)
              .addClass('fc-labels-mini')
              .css({
                'max-width': (100 - (labels.length * labelsHorizontalDistance)) / labels.length + '%'
              });
          });

          if (event.HasPassed) {
            $el.addClass('has-passed');
          }

          if (eventIsFull) {
            if (!event.IsAdminMode) {
              if (!hasWaitListEnabled) {
                $el.addClass('full');
              } else {
                $el.addClass('full-with-waitlist');
              }
            } else {
              $el.addClass('full-dropin');
              $el.addClass('can-register');
            }
          }

          if (clientAlreadyRegistered) {
            $el.addClass('in-cart');
          }

          if (clientCanRegister && !event.HasPassed) {
            $el.addClass('can-register');
          }

          if (event.ActivityState === 1) {
            $el.addClass('activity-hidden');
          }

          if (clientCanRegister || clientAlreadyRegistered || adminCanOverride) {
            $el.attr({
              rel: 'quick-reg',
              id: event.SegmentId
            });
          }

          if (eventIsFull && hasWaitListEnabled) {
            // when a dropin is full, admins can either register the participant or add to the waitlist
            // while end users should go throught the waitlist flow
            var waitListHandle = $el;
            if (adminCanOverride || event.CanUnregister) {
              waitListHandle = $el.find('.waitlist');
            } else {
              $el.removeAttr('rel');
            }

            waitListHandle.on('click keydown', function (e) {
              if (e && e.type === 'keydown' && e.keyCode !== 13) return;
              e.stopPropagation();
              window.location.assign(AMILIA_APP.WaitListUrl + '/Index/' + event.ActivityId + '?segmentId='+ event.SegmentId);
            })
          }

          break;
        case 'Staff':
        case 'PrivateLesson':
        case 'Segment': // user account home calendar for private lessons, session activities and dropIns (staff or user)
          $el.attr('title', event.Description);
          $el.attr('Location', event.Location);
          $el.find('.fc-content').html(segmentTemplate(event));
          break;
        case 'Booking':
        case 'Contract':
        case 'StaffBooking': // user account home calendar for bookings (staff or user)
          $el.attr('title', event.Description);
          $el.attr('Location', event.Location);
          $el.find('.fc-content').html(bookingTemplate(event));
          break;
        default:
          break;
      }
      if (view.name == 'basicWeek') {
        $el.find('.fc-content').prepend($el.find('.fc-time').remove());
      }
    },
    customViewDateStartTitle: null,
    customViewJsClassName: 'js-customListView',
    customViewClassName: 'customListView',
    eventAfterRender: function(event, $el, view) {
      var $customView;
      var $dayContainer;
      var $newEventElement;
      var $holidayBgElement;
      var isHolidayEvent;
      var todayClass;

      // Mobile list view
      if (view.type === 'mobileListView') {

        // Custom view container
        $customView = ($('.' + view.options.customViewJsClassName).length ? $('.' + view.options.customViewJsClassName) : $('<div class="' + view.options.customViewJsClassName + ' ' + view.options.customViewClassName + '"></div>').insertAfter('.fc-view-container'));

        // Day container
        if ($el.data('dateStartTitle') !== view.options.customViewDateStartTitle) {
          view.options.customViewDateStartTitle = $el.data('dateStartTitle');

          todayClass = (event.start.format("YYYY-MM-DD") === moment().format('YYYY-MM-DD') ? 'fc-today' : '');

          $dayContainer = $('div [data-list-day="' + view.options.customViewDateStartTitle + '"]');

          // Create the container if not exists yet, and add the title
          if (!$dayContainer.length) {
            $dayContainer = $('<div class="customListView__day-container" data-list-day="' + view.options.customViewDateStartTitle + '"></div>').appendTo($customView);
            $('<h4 class="' + view.options.customViewClassName + '__title ' + ($el.data('isToday') ? 'fc-today' : '') + '"></h4>').appendTo($dayContainer).addClass(todayClass).text(view.options.customViewDateStartTitle);
          }
        }

        // Get the day container
        $dayContainer = $dayContainer ? $dayContainer : $('div [data-list-day="' + view.options.customViewDateStartTitle + '"]');

        isHolidayEvent = $el.hasClass('fc-event') && $el.hasClass('holiday');

        // Clone the event element
        $newEventElement = $el.clone(true);

        // Move the event element
        if (isHolidayEvent) {
          $newEventElement.insertAfter($dayContainer.find('h4'));

          $holidayBgElement = $dayContainer.find('.fc-bgevent.holiday');

          if ($holidayBgElement.length) {
            $newEventElement.css('background-color', $holidayBgElement.css('background-color'));
            $holidayBgElement.remove();
          }

        } else {
          $newEventElement.appendTo($dayContainer);
        }
      }
    },
    viewRender: function(view) {
      $('.' + view.options.customViewJsClassName).remove();
      view.options.customViewDateStartTitle = null;
    },
    loading: function(isLoading, view) {

      // URL history
      if (typeof window.history.pushState != 'undefined') {
        var query = $.parseParams(window.location.href);
        var calendarDate = $calendar.fullCalendar('getDate');

        if (typeof calendarDate === 'object' && calendarDate.hasOwnProperty('_isAMomentObject')) {

          if(calendarDate.format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
            delete query.date;
          } else {
            query.date = calendarDate.format('YYYY-MM-DD');
          }

        } else {
          query.date = moment().format('YYYY-MM-DD');
        }

        query.view = $calendar.fullCalendar('getView').type;
        query.scrollToCalendar = options.scrollToCalendar;

        if (options.showFilters) {
          var subCategoryId = filters.subCategoryId || undefined;
          if (subCategoryId)
            query.subCategoryId = subCategoryId;
          else
            delete query.subCategoryId;

          var categoryId = filters.categoryId || undefined;
          if (categoryId)
            query.categoryId = categoryId;
          else {
            // If no category selected, must remove both params
            delete query.categoryId;
            delete query.subCategoryId;
          }

          var tagIds = filters.tagIds.length ? filters.tagIds.join(',') : undefined;
          if (tagIds)
            query.tagIds = tagIds;
          else
            delete query.tagIds;
        }

        if (options.isLoggedIn) {
          var showOnlyRegistered = filters.showOnlyRegistered || undefined;
          if (showOnlyRegistered)
            query.showOnlyRegistered = showOnlyRegistered;
          else
            delete query.showOnlyRegistered;
        }

        var uri = window.location.pathname + '?' + $.param(query);

        // we are replacing it instead of pushing the new state to avoid
        // to create new entry in the browser history
        // It's for the back button
        window.history.replaceState(undefined, undefined, uri);

        pageJustLoaded = false;
      }

      // Loader
      if (isLoading) {
        var $loader = $('<div id="calendar-loader" style="text-align: center;"><i class="fa fa-3x fa-spinner fa-spin" style="color: #2B91E1;"></i></div>');

        $calendar.prepend($loader);
        $('.' + view.options.customViewJsClassName).remove();
        view.options.customViewDateStartTitle = null;
        return;
      } else {
        return $('#calendar-loader').remove();
      }
    },
    eventAfterAllRender: function(view) {

      // Mobile list view
      if (view.type === 'mobileListView') {
        $('.fc-mobileListView-view').addClass('hide');
      }

      if (view.el.find('[rel="quick-reg"]').length) $(document).trigger('calendar:loaded');
    }
  });

  $(function() {
    $calendar.fullCalendar('render');

    if (options.scrollToCalendar) {
      $('html,body').animate({
        scrollTop: $('.calendar-container').offset().top
      }, 400);
    }
  })

};

// Custom Mobile list view
$.fullCalendar.views.mobileList = $.fullCalendar.views.basic;
;
(function() {
    'strict';


    var FC = $.fullCalendar, // a reference to FullCalendar's root namespace
        View = FC.View, // the class that all views must inherit from
        ListView; // our subclass

    ListView = View.extend({ // make a subclass of View

        computeRange: function(date) {
            var intervalDuration = moment.duration(this.opt('duration') || this.constructor.duration || {
                days: 10
            });
            var intervalUnit = 'day';
            var intervalStart = date.clone().startOf(intervalUnit);
            var intervalEnd = intervalStart.clone().add(intervalDuration);
            var start, end;

            // normalize the range's time-ambiguity
            intervalStart.stripTime();
            intervalEnd.stripTime();

            start = intervalStart.clone();
            start = this.skipHiddenDays(start);
            end = intervalEnd.clone();
            end = this.skipHiddenDays(end, -1, true); // exclusively move backwards

            return {
                intervalDuration: intervalDuration,
                intervalUnit: intervalUnit,
                intervalStart: intervalStart,
                intervalEnd: intervalEnd,
                start: start,
                end: end
            };
        },

        initialize: function() {
            // called once when the view is instantiated, when the user switches to the view.
            // initialize member variables or do other setup tasks.

            View.prototype.initialize.apply(this, arguments);
        },

        render: function() {

            // responsible for displaying the skeleton of the view within the already-defined
            // this.el, a jQuery element.
            View.prototype.render.apply(this, arguments);
        },

        computeTitle: function() {
            return moment().format(this.opt('titleFormat'));
        },

        setHeight: function(height, isAuto) {
            // responsible for adjusting the pixel-height of the view. if isAuto is true, the
            // view may be its natural height, and `height` becomes merely a suggestion.
            this.el.height(height);

            View.prototype.setHeight.apply(this, arguments);
        },

        renderEvents: function(events) {
            // reponsible for rendering the given Event Objects

            var noDebug = true;
            noDebug || console.log(events);

            var eventsCopy = events.slice().reverse(); //copy and reverse so we can modify while looping

            var tbody = $('<tbody></tbody>');

            this.scrollerEl = this.el.addClass('fc-scroller');

            this.el.html('')
                .append('<table style="border: 0; width:100%"></table>').children()
                .append(tbody);

            var periodEnd = this.end.clone(); //clone so as to not accidentally modify

            noDebug || console.log('Period start: ' + this.start.format("YYYY MM DD HH:mm:ss Z") + ', and end: ' + this.end.format("YYYY MM DD HH:mm:ss Z"));

            var currentDayStart = this.start.clone();
            while (currentDayStart.isBefore(periodEnd)) {

                var didAddDayHeader = false;
                var currentDayEnd = currentDayStart.clone().add(1, 'days');

                noDebug || console.log('=== this day start: ' + currentDayStart.format("YYYY MM DD HH:mm:ss Z") + ', and end: ' + currentDayEnd.format("YYYY MM DD HH:mm:ss Z"));

                //Assume events were ordered descending originally (notice we reversed them)
                for (var i = eventsCopy.length - 1; i >= 0; --i) {
                    var e = eventsCopy[i];

                    var eventStart = e.start.clone();
                    var eventEnd = this.calendar.getEventEnd(e);

                    if (!noDebug) {
                        console.log(e.title);
                        console.log('event index: ' + (events.length - i - 1) + ', and in copy: ' + i);
                        console.log('event start: ' + eventStart.format("YYYY MM DD HH:mm:ss Z"));
                        console.log('event end: ' + this.calendar.getEventEnd(e).format("YYYY MM DD HH:mm:ss Z"));
                        console.log('currentDayEnd: ' + currentDayEnd.format("YYYY MM DD HH:mm:ss Z"));
                        console.log(currentDayEnd.isAfter(eventStart));
                    }

                    if (currentDayStart.isAfter(eventEnd) || (currentDayStart.isSame(eventEnd) && !eventStart.isSame(eventEnd)) || periodEnd.isBefore(eventStart)) {
                        eventsCopy.splice(i, 1);
                        noDebug || console.log("--- Removed the above event");
                    } else if (currentDayEnd.isAfter(eventStart)) {
                        //We found an event to display

                        noDebug || console.log("+++ We added the above event");

                        if (!didAddDayHeader) {
                            tbody.append(
                                '<tr class="fc-header" date="">' +
                                    '<th colspan="2">' +
                                        '<span class="fc-header-day">' + currentDayStart.format('dddd') + '</span>' +
                                        '<span class="fc-header-date">' + currentDayStart.format(this.opt('columnFormat')) + '</span>' +
                                    '</th>' +
                                '</tr>');

                            didAddDayHeader = true;
                        }

                        /*
                        <td class="fc-event-handle">\
                                <span class="fc-event"></span>\
                            </td>\
                         */

                        var segEl = $(
                            '<tr class="fc-row fc-event-container fc-content">' +
                                '<td class="fc-time">' + (e.allDay ? this.opt('allDayText') : e.start.format('H:mm') + '-' + e.end.format('H:mm')) + '</td>' +
                                '<td>' +
                                    '<div class="fc-title">' + e.title + '</div>' +
                                    '<div class="fc-description">' + e.location + '</div>' +
                                '</td>' +
                            '</tr>');
                        tbody.append(segEl);

                        //Tried to use fullcalendar code for this stuff but to no avail
                        (function(_this, myEvent, mySegEl) { //temp bug fix because 'e' seems to change
                            segEl.on('click', function(ev) {
                                return _this.trigger('eventClick', mySegEl, myEvent, ev);
                            });
                        })(this, e, segEl);

                    }

                }

                currentDayStart.add(1, 'days');
            }

            this.updateHeight();

            View.prototype.renderEvents.apply(this, arguments);
        },

        destroyEvents: function() {
            // responsible for undoing everything in renderEvents
            View.prototype.destroyEvents.apply(this, arguments);
        },

        renderSelection: function(range) {
            // accepts a {start,end} object made of Moments, and must render the selection
            View.prototype.renderSelection.apply(this, arguments);
        },

        destroySelection: function() {
            // responsible for undoing everything in renderSelection
            View.prototype.destroySelection.apply(this, arguments);
        }

    });

    FC.views.list = ListView; // register our class with the view system

})();
;
(function($) {
  'use strict';

  AMILIA_APP.StoreWishlist = AMILIA_APP.StoreWishlist || {};

  var self = AMILIA_APP.StoreWishlist;
  self.toggleWishListItem = function(e) {
    e.preventDefault();
    var $a = $(e.currentTarget);
    var $i = $a.find('i');
    var $total = $('.total-wish .wish-count');
    var count = parseInt($total.text(), 10);

    if ($a.hasClass('active')) {
      $.ajax({
        url: $a.data('removeurl'),
        type: 'DELETE'
      })
        .done(function() {
          $a.removeClass('active');
          $i.removeClass('fa-heart').addClass('fa-heart-o');
          $total.text(count - 1);
        });
    } else {
      $.post($a.data('addurl'))
        .done(function(id) {
          $a.addClass('active');
          $i.removeClass('fa-heart-o').addClass('fa-heart');
          $a.data('removeurl', $a.data('removeurl').replace(/\/[0-9]+$/, '/' + id));
          $total.text(count + 1);
        });
    }
  };

  self.removeWishListItem = function(e) {
    if (e) e.preventDefault();
    var $a = $(e.currentTarget);

    $.ajax({
      url: $a.data('removeurl'),
      type: 'DELETE'
    })
      .done(function() {
        window.location.reload();
      });
  };

  self.sortAndSearchWishListItems = function() {
    var search = $('input.wish-list-search')[0].value;
    var sortBy = $('select.wish-list-sort')[0].value;

    var newUrl = window.location.origin + window.location.pathname + '?search=' + search + '&sortBy=' + sortBy;
    window.location.href = newUrl;
  };
}(jQuery));
;
(function() {
  'use strict';

  if (!document.body.classList.contains('store-redesign')) return;

  var nav = document.querySelector('.store-redesign .nav-modules');

  if (!nav) return;

  var modules = nav.querySelectorAll('.nav-pills > li:not(.dropdown):not(.active)');
  var active = nav.querySelector('.nav-pills .active');
  var dropdown = nav.querySelector('.nav-pills .dropdown');
  var dropdownList = dropdown.querySelector('ul');
  var dropdownElements = dropdownList.querySelectorAll('li');
  var WIDTH_BUFFER = 6;

  // eslint-disable-next-line compat/compat
  new ResizeObserver(function () {
    var navWidth = nav.offsetWidth - dropdown.offsetWidth - (active ? active.offsetWidth : 0) - WIDTH_BUFFER;
    var cumulativeWidth = 0;
    var hiddenModules = 0;

    // Hide / show modules
    for (var i = 0; i < modules.length; ++i) {
      var module = modules[i];

      if (!nav.contains(module)) {
        // We first need to render the element for `.offsetWidth` to return a
        // non-zero value.
        nav.appendChild(module);
      }

      cumulativeWidth += (module.offsetWidth + WIDTH_BUFFER);

      // if it is the last module, no modules are hidden and it would fit without the dropdown (More)
      var isLast = i === modules.length - 1;
      var lastWouldFit = isLast && cumulativeWidth <= (navWidth + dropdown.offsetWidth) && hiddenModules === 0;

      if (cumulativeWidth > navWidth && (!isLast || (isLast && !lastWouldFit))) {
        module.remove();
        hiddenModules += 1;
      }
    }

    if (window.innerWidth < 576) {
      // Mobile view
      dropdown.remove();
      dropdown.style.removeProperty('display');
      nav.appendChild(dropdown);
      for (var j = 0; j < dropdownElements.length; ++j) {
        var element = dropdownElements[j];
        element.remove();
        dropdownList.appendChild(element);
      }
      return;
    }

    // Hide / show 'More' button
    if (hiddenModules > 0) {
      dropdown.remove();
      dropdown.style.removeProperty('display');
      nav.appendChild(dropdown);
    } else {
      dropdown.style.setProperty('display', 'none');
      return;
    }

    // Hide / show entries inside the 'More' dropdown
    if (hiddenModules > 0) {
      var isLoggedIn = AMILIA_APP.isLoggedIn;
      var hasWishList = AMILIA_APP.accessModules.indexOf('WishList') !== -1;

      var elementsToRemove = isLoggedIn && hasWishList ? 1 : 0;

      dropdownElements.forEach(function(dropdownElement, index) {
        dropdownElement.remove();

        // Only show the missing modules, in other words:
        // - Hide modules on nav bar
        // - Hide 'My Account/Administration' and 'Wish List' (if the org has the wishlist module and the user is logged in)

        if (index >= modules.length - hiddenModules && index < (dropdownElements.length - elementsToRemove)) {
          dropdownList.appendChild(dropdownElement);
        }
      });
    }
  }).observe(document.body);
}).call(this);
